// /**Released Version v3.1.10,BUILD 236,Time 1749031423138. Fengmap Javascript SDK  es6, see: https://www.fengmap.com for details**/
let t={NONE:0,EXTRUDE_MARKER:2,FM3DTILE_LAYER:4,IMAGE_MARKER:8,LOCATION_MARKER:16,POLYGON_MARKER:32,TEXT_MARKER:64,LINE_MARKER:128,LINE3D_MARKER:256,HEAT_MAP_MARKER:512,EXTENT:1024,EXTERNAL_MODEL:2048,MODEL:4096,FACILITY:8192,LABEL:16384,DYNAMIC_MODEL_MARKER:32768,DOM_MARKER:65536,SPHERE_MARKER:1<<17,CAD_LAYER:1<<18,EXTENT_LAYER:1<<20,EXTERNAL_MODEL_LAYER:1<<21,MODEL_LAYER:1<<22,FACILITY_LAYER:1<<23,LABEL_LAYER:1<<24,MARKER_GROUP:1<<25,FLOW_LINE_LAYER:1<<27,FLOW_LINE_MARKER:1<<27,FIRE_MARKER:1<<28,WALL_MARKER:1<<29,TUBE_MARKER:1<<30},s=(t.LAYER_NODE_TYPE=new Map,t.LAYER_NODE_TYPE.set(t.EXTENT_LAYER,t.EXTENT),t.LAYER_NODE_TYPE.set(t.EXTERNAL_MODEL_LAYER,t.EXTERNAL_MODEL),t.LAYER_NODE_TYPE.set(t.MODEL_LAYER,t.MODEL),t.LAYER_NODE_TYPE.set(t.FACILITY_LAYER,t.FACILITY),t.LAYER_NODE_TYPE.set(t.LABEL_LAYER,t.LABEL),t.LAYER_NODE_TYPE.set(t.DOM_MARKER,t.DOM_MARKER),t.LAYER_NODE_TYPE.set(t.DYNAMIC_MODEL_MARKER,t.DYNAMIC_MODEL_MARKER),t.LAYER_NODE_TYPE.set(t.EXTRUDE_MARKER,t.EXTRUDE_MARKER),t.LAYER_NODE_TYPE.set(t.HEAT_MAP_MARKER,t.HEAT_MAP_MARKER),t.LAYER_NODE_TYPE.set(t.LINE_MARKER,t.LINE_MARKER),t.LAYER_NODE_TYPE.set(t.LOCATION_MARKER,t.LOCATION_MARKER),t.LAYER_NODE_TYPE.set(t.POLYGON_MARKER,t.POLYGON_MARKER),t.LAYER_NODE_TYPE.set(t.TEXT_MARKER,t.TEXT_MARKER),t.LAYER_NODE_TYPE.set(t.IMAGE_MARKER,t.IMAGE_MARKER),t.LAYER_NODE_TYPE.set(t.FLOW_LINE_LAYER,t.FLOW_LINE_MARKER),t.LAYER_NODE_TYPE.set(t.FIRE_MARKER,t.FIRE_MARKER),t.LAYER_NODE_TYPE.set(t.WALL_MARKER,t.WALL_MARKER),t.LAYER_NODE_TYPE.set(t.TUBE_MARKER,t.TUBE_MARKER),t.LAYER_NODE_TYPE.set(t.LINE3D_MARKER,t.LINE3D_MARKER),t.LAYER_NODE_TYPE.set(t.SPHERE_MARKER,t.SPHERE_MARKER),t.LAYER_NODE_TYPE.set(t.CAD_LAYER,t.CAD_LAYER),["00","01","02","03","04","05","06","07","08","09","0a","0b","0c","0d","0e","0f","10","11","12","13","14","15","16","17","18","19","1a","1b","1c","1d","1e","1f","20","21","22","23","24","25","26","27","28","29","2a","2b","2c","2d","2e","2f","30","31","32","33","34","35","36","37","38","39","3a","3b","3c","3d","3e","3f","40","41","42","43","44","45","46","47","48","49","4a","4b","4c","4d","4e","4f","50","51","52","53","54","55","56","57","58","59","5a","5b","5c","5d","5e","5f","60","61","62","63","64","65","66","67","68","69","6a","6b","6c","6d","6e","6f","70","71","72","73","74","75","76","77","78","79","7a","7b","7c","7d","7e","7f","80","81","82","83","84","85","86","87","88","89","8a","8b","8c","8d","8e","8f","90","91","92","93","94","95","96","97","98","99","9a","9b","9c","9d","9e","9f","a0","a1","a2","a3","a4","a5","a6","a7","a8","a9","aa","ab","ac","ad","ae","af","b0","b1","b2","b3","b4","b5","b6","b7","b8","b9","ba","bb","bc","bd","be","bf","c0","c1","c2","c3","c4","c5","c6","c7","c8","c9","ca","cb","cc","cd","ce","cf","d0","d1","d2","d3","d4","d5","d6","d7","d8","d9","da","db","dc","dd","de","df","e0","e1","e2","e3","e4","e5","e6","e7","e8","e9","ea","eb","ec","ed","ee","ef","f0","f1","f2","f3","f4","f5","f6","f7","f8","f9","fa","fb","fc","fd","fe","ff"]);function O(){var e=4294967295*Math.random()|0,t=4294967295*Math.random()|0,i=4294967295*Math.random()|0,r=4294967295*Math.random()|0;return(s[255&e]+s[e>>8&255]+s[e>>16&255]+s[e>>24&255]+"-"+s[255&t]+s[t>>8&255]+"-"+s[t>>16&15|64]+s[t>>24&255]+"-"+s[63&i|128]+s[i>>8&255]+"-"+s[i>>16&255]+s[i>>24&255]+s[255&r]+s[r>>8&255]+s[r>>16&255]+s[r>>24&255]).toLowerCase()}function v(e,t,i){return Math.max(t,Math.min(i,e))}function F(e,t){return(e%t+t)%t}function H(e,t,i){return(1-i)*e+i*t}function r(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return e/4294967295;case Uint16Array:return e/65535;case Uint8Array:return e/255;case Int32Array:return Math.max(e/2147483647,-1);case Int16Array:return Math.max(e/32767,-1);case Int8Array:return Math.max(e/127,-1);default:throw new Error("Invalid component type.")}}function a(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return Math.round(4294967295*e);case Uint16Array:return Math.round(65535*e);case Uint8Array:return Math.round(255*e);case Int32Array:return Math.round(2147483647*e);case Int16Array:return Math.round(32767*e);case Int8Array:return Math.round(127*e);default:throw new Error("Invalid component type.")}}class V{constructor(e=0,t=0,i=0,r=1){this.isQuaternion=!0,this.t=e,this.i=t,this.o=i,this.u=r}static slerpFlat(e,t,i,r,s,a,n){let o=i[r+0],h=i[r+1],l=i[r+2],c=i[r+3];var i=s[a+0],r=s[a+1],d=s[a+2],s=s[a+3];if(0===n)e[t+0]=o,e[t+1]=h,e[t+2]=l,e[t+3]=c;else if(1===n)e[t+0]=i,e[t+1]=r,e[t+2]=d,e[t+3]=s;else{if(c!==s||o!==i||h!==r||l!==d){let e=1-n;var a=o*i+h*r+l*d+c*s,u=0<=a?1:-1,f=1-a*a,a=(f>Number.EPSILON&&(f=Math.sqrt(f),a=Math.atan2(f,a*u),e=Math.sin(e*a)/f,n=Math.sin(n*a)/f),n*u);o=o*e+i*a,h=h*e+r*a,l=l*e+d*a,c=c*e+s*a,e===1-n&&(f=1/Math.sqrt(o*o+h*h+l*l+c*c),o*=f,h*=f,l*=f,c*=f)}e[t]=o,e[t+1]=h,e[t+2]=l,e[t+3]=c}}static multiplyQuaternionsFlat(e,t,i,r,s,a){var n=i[r],o=i[r+1],h=i[r+2],i=i[r+3],r=s[a],l=s[a+1],c=s[a+2],s=s[a+3];return e[t]=n*s+i*r+o*c-h*l,e[t+1]=o*s+i*l+h*r-n*c,e[t+2]=h*s+i*c+n*l-o*r,e[t+3]=i*s-n*r-o*l-h*c,e}get x(){return this.t}set x(e){this.t=e,this.m()}get y(){return this.i}set y(e){this.i=e,this.m()}get z(){return this.o}set z(e){this.o=e,this.m()}get w(){return this.u}set w(e){this.u=e,this.m()}set(e,t,i,r){return this.t=e,this.i=t,this.o=i,this.u=r,this.m(),this}clone(){return new this.constructor(this.t,this.i,this.o,this.u)}copy(e){return this.t=e.x,this.i=e.y,this.o=e.z,this.u=e.w,this.m(),this}setFromEuler(e,t=!0){var i=e.t,r=e.i,s=e.o,a=e.p,e=Math.cos,n=Math.sin,o=e(i/2),h=e(r/2),l=e(s/2),c=n(i/2),d=n(r/2),u=n(s/2);switch(a){case"XYZ":this.t=c*h*l+o*d*u,this.i=o*d*l-c*h*u,this.o=o*h*u+c*d*l,this.u=o*h*l-c*d*u;break;case"YXZ":this.t=c*h*l+o*d*u,this.i=o*d*l-c*h*u,this.o=o*h*u-c*d*l,this.u=o*h*l+c*d*u;break;case"ZXY":this.t=c*h*l-o*d*u,this.i=o*d*l+c*h*u,this.o=o*h*u+c*d*l,this.u=o*h*l-c*d*u;break;case"ZYX":this.t=c*h*l-o*d*u,this.i=o*d*l+c*h*u,this.o=o*h*u-c*d*l,this.u=o*h*l+c*d*u;break;case"YZX":this.t=c*h*l+o*d*u,this.i=o*d*l+c*h*u,this.o=o*h*u-c*d*l,this.u=o*h*l-c*d*u;break;case"XZY":this.t=c*h*l-o*d*u,this.i=o*d*l-c*h*u,this.o=o*h*u+c*d*l,this.u=o*h*l+c*d*u;break;default:console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: "+a)}return!0===t&&this.m(),this}setFromAxisAngle(e,t){var t=t/2,i=Math.sin(t);return this.t=e.x*i,this.i=e.y*i,this.o=e.z*i,this.u=Math.cos(t),this.m(),this}setFromRotationMatrix(e){var e=e.elements,t=e[0],i=e[4],r=e[8],s=e[1],a=e[5],n=e[9],o=e[2],h=e[6],e=e[10],l=t+a+e;return 0<l?(l=.5/Math.sqrt(l+1),this.u=.25/l,this.t=(h-n)*l,this.i=(r-o)*l,this.o=(s-i)*l):a<t&&e<t?(l=2*Math.sqrt(1+t-a-e),this.u=(h-n)/l,this.t=.25*l,this.i=(i+s)/l,this.o=(r+o)/l):e<a?(l=2*Math.sqrt(1+a-t-e),this.u=(r-o)/l,this.t=(i+s)/l,this.i=.25*l,this.o=(n+h)/l):(l=2*Math.sqrt(1+e-t-a),this.u=(s-i)/l,this.t=(r+o)/l,this.i=(n+h)/l,this.o=.25*l),this.m(),this}setFromUnitVectors(e,t){let i=e.dot(t)+1;return i<Number.EPSILON?(i=0,Math.abs(e.x)>Math.abs(e.z)?(this.t=-e.y,this.i=e.x,this.o=0):(this.t=0,this.i=-e.z,this.o=e.y)):(this.t=e.y*t.z-e.z*t.y,this.i=e.z*t.x-e.x*t.z,this.o=e.x*t.y-e.y*t.x),this.u=i,this.normalize()}angleTo(e){return 2*Math.acos(Math.abs(v(this.dot(e),-1,1)))}rotateTowards(e,t){var i=this.angleTo(e);return 0!==i&&(t=Math.min(1,t/i),this.slerp(e,t)),this}identity(){return this.set(0,0,0,1)}invert(){return this.conjugate()}conjugate(){return this.t*=-1,this.i*=-1,this.o*=-1,this.m(),this}dot(e){return this.t*e.t+this.i*e.i+this.o*e.o+this.u*e.u}lengthSq(){return this.t*this.t+this.i*this.i+this.o*this.o+this.u*this.u}length(){return Math.sqrt(this.t*this.t+this.i*this.i+this.o*this.o+this.u*this.u)}normalize(){var e=this.length();return 0===e?(this.t=0,this.i=0,this.o=0,this.u=1):(this.t=this.t*(e=1/e),this.i=this.i*e,this.o=this.o*e,this.u=this.u*e),this.m(),this}multiply(e){return this.multiplyQuaternions(this,e)}premultiply(e){return this.multiplyQuaternions(e,this)}multiplyQuaternions(e,t){var i=e.t,r=e.i,s=e.o,e=e.u,a=t.t,n=t.i,o=t.o,t=t.u;return this.t=i*t+e*a+r*o-s*n,this.i=r*t+e*n+s*a-i*o,this.o=s*t+e*o+i*n-r*a,this.u=e*t-i*a-r*n-s*o,this.m(),this}slerp(t,i){if(0!==i){if(1===i)return this.copy(t);var r,s,a=this.t,n=this.i,o=this.o,h=this.u;let e=h*t.u+a*t.t+n*t.i+o*t.o;e<0?(this.u=-t.u,this.t=-t.t,this.i=-t.i,this.o=-t.o,e=-e):this.copy(t),1<=e?(this.u=h,this.t=a,this.i=n,this.o=o):(t=1-e*e)<=Number.EPSILON?(this.u=(r=1-i)*h+i*this.u,this.t=r*a+i*this.t,this.i=r*n+i*this.i,this.o=r*o+i*this.o,this.normalize()):(r=Math.sqrt(t),t=Math.atan2(r,e),s=Math.sin((1-i)*t)/r,i=Math.sin(i*t)/r,this.u=h*s+this.u*i,this.t=a*s+this.t*i,this.i=n*s+this.i*i,this.o=o*s+this.o*i,this.m())}return this}slerpQuaternions(e,t,i){return this.copy(e).slerp(t,i)}random(){var e=2*Math.PI*Math.random(),t=2*Math.PI*Math.random(),i=Math.random(),r=Math.sqrt(1-i),i=Math.sqrt(i);return this.set(r*Math.sin(e),r*Math.cos(e),i*Math.sin(t),i*Math.cos(t))}equals(e){return e.t===this.t&&e.i===this.i&&e.o===this.o&&e.u===this.u}fromArray(e,t=0){return this.t=e[t],this.i=e[t+1],this.o=e[t+2],this.u=e[t+3],this.m(),this}toArray(e=[],t=0){return e[t]=this.t,e[t+1]=this.i,e[t+2]=this.o,e[t+3]=this.u,e}fromBufferAttribute(e,t){return this.t=e.getX(t),this.i=e.getY(t),this.o=e.getZ(t),this.u=e.getW(t),this.m(),this}toJSON(){return this.toArray()}v(e){return this.m=e,this}m(){}*[Symbol.iterator](){yield this.t,yield this.i,yield this.o,yield this.u}}class N{constructor(e=0,t=0,i=0){N.prototype.isVector3=!0,this.x=e,this.y=t,this.z=i}set(e,t,i){return void 0===i&&(i=this.z),this.x=e,this.y=t,this.z=i,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y,this.z)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this}multiplyVectors(e,t){return this.x=e.x*t.x,this.y=e.y*t.y,this.z=e.z*t.z,this}applyEuler(e){return this.applyQuaternion(k.setFromEuler(e))}applyAxisAngle(e,t){return this.applyQuaternion(k.setFromAxisAngle(e,t))}applyMatrix3(e){var t=this.x,i=this.y,r=this.z,e=e.elements;return this.x=e[0]*t+e[3]*i+e[6]*r,this.y=e[1]*t+e[4]*i+e[7]*r,this.z=e[2]*t+e[5]*i+e[8]*r,this}applyNormalMatrix(e){return this.applyMatrix3(e).normalize()}applyMatrix4(e){var t=this.x,i=this.y,r=this.z,e=e.elements,s=1/(e[3]*t+e[7]*i+e[11]*r+e[15]);return this.x=(e[0]*t+e[4]*i+e[8]*r+e[12])*s,this.y=(e[1]*t+e[5]*i+e[9]*r+e[13])*s,this.z=(e[2]*t+e[6]*i+e[10]*r+e[14])*s,this}applyQuaternion(e){var t=this.x,i=this.y,r=this.z,s=e.x,a=e.y,n=e.z,e=e.w,o=2*(a*r-n*i),h=2*(n*t-s*r),l=2*(s*i-a*t);return this.x=t+e*o+a*l-n*h,this.y=i+e*h+n*o-s*l,this.z=r+e*l+s*h-a*o,this}project(e){return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)}unproject(e){return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)}transformDirection(e){var t=this.x,i=this.y,r=this.z,e=e.elements;return this.x=e[0]*t+e[4]*i+e[8]*r,this.y=e[1]*t+e[5]*i+e[9]*r,this.z=e[2]*t+e[6]*i+e[10]*r,this.normalize()}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this}divideScalar(e){return this.multiplyScalar(1/e)}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this.z=Math.max(e.z,Math.min(t.z,this.z)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this.z=Math.max(e,Math.min(t,this.z)),this}clampLength(e,t){var i=this.length();return this.divideScalar(i||1).multiplyScalar(Math.max(e,Math.min(t,i)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this}lerpVectors(e,t,i){return this.x=e.x+(t.x-e.x)*i,this.y=e.y+(t.y-e.y)*i,this.z=e.z+(t.z-e.z)*i,this}cross(e){return this.crossVectors(this,e)}crossVectors(e,t){var i=e.x,r=e.y,e=e.z,s=t.x,a=t.y,t=t.z;return this.x=r*t-e*a,this.y=e*s-i*t,this.z=i*a-r*s,this}projectOnVector(e){var t=e.lengthSq();return 0===t?this.set(0,0,0):(t=e.dot(this)/t,this.copy(e).multiplyScalar(t))}projectOnPlane(e){return G.copy(this).projectOnVector(e),this.sub(G)}reflect(e){return this.sub(G.copy(e).multiplyScalar(2*this.dot(e)))}angleTo(e){var t=Math.sqrt(this.lengthSq()*e.lengthSq());return 0===t?Math.PI/2:(e=this.dot(e)/t,Math.acos(v(e,-1,1)))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){var t=this.x-e.x,i=this.y-e.y,e=this.z-e.z;return t*t+i*i+e*e}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)+Math.abs(this.z-e.z)}setFromSpherical(e){return this.setFromSphericalCoords(e.radius,e.phi,e.theta)}setFromSphericalCoords(e,t,i){var r=Math.sin(t)*e;return this.x=r*Math.sin(i),this.y=Math.cos(t)*e,this.z=r*Math.cos(i),this}setFromCylindrical(e){return this.setFromCylindricalCoords(e.radius,e.theta,e.y)}setFromCylindricalCoords(e,t,i){return this.x=e*Math.sin(t),this.y=i,this.z=e*Math.cos(t),this}setFromMatrixPosition(e){e=e.elements;return this.x=e[12],this.y=e[13],this.z=e[14],this}setFromMatrixScale(e){var t=this.setFromMatrixColumn(e,0).length(),i=this.setFromMatrixColumn(e,1).length(),e=this.setFromMatrixColumn(e,2).length();return this.x=t,this.y=i,this.z=e,this}setFromMatrixColumn(e,t){return this.fromArray(e.elements,4*t)}setFromMatrix3Column(e,t){return this.fromArray(e.elements,3*t)}setFromEuler(e){return this.x=e.t,this.y=e.i,this.z=e.o,this}setFromColor(e){return this.x=e.r,this.y=e.g,this.z=e.b,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this}randomDirection(){var e=Math.random()*Math.PI*2,t=2*Math.random()-1,i=Math.sqrt(1-t*t);return this.x=i*Math.cos(e),this.y=t,this.z=i*Math.sin(e),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z}}let G=new N,k=new V;class D{constructor(e=0,t=0){D.prototype.isVector2=!0,this.x=e,this.y=t}get width(){return this.x}set width(e){this.x=e}get height(){return this.y}set height(e){this.y=e}set(e,t){return this.x=e,this.y=t,this}setScalar(e){return this.x=e,this.y=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y)}copy(e){return this.x=e.x,this.y=e.y,this}add(e){return this.x+=e.x,this.y+=e.y,this}addScalar(e){return this.x+=e,this.y+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this}subScalar(e){return this.x-=e,this.y-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this}multiply(e){return this.x*=e.x,this.y*=e.y,this}multiplyScalar(e){return this.x*=e,this.y*=e,this}divide(e){return this.x/=e.x,this.y/=e.y,this}divideScalar(e){return this.multiplyScalar(1/e)}applyMatrix3(e){var t=this.x,i=this.y,e=e.elements;return this.x=e[0]*t+e[3]*i+e[6],this.y=e[1]*t+e[4]*i+e[7],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this}clampLength(e,t){var i=this.length();return this.divideScalar(i||1).multiplyScalar(Math.max(e,Math.min(t,i)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this}negate(){return this.x=-this.x,this.y=-this.y,this}dot(e){return this.x*e.x+this.y*e.y}cross(e){return this.x*e.y-this.y*e.x}lengthSq(){return this.x*this.x+this.y*this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)}normalize(){return this.divideScalar(this.length()||1)}angle(){return Math.atan2(-this.y,-this.x)+Math.PI}angleTo(e){var t=Math.sqrt(this.lengthSq()*e.lengthSq());return 0===t?Math.PI/2:(e=this.dot(e)/t,Math.acos(v(e,-1,1)))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){var t=this.x-e.x,e=this.y-e.y;return t*t+e*e}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this}lerpVectors(e,t,i){return this.x=e.x+(t.x-e.x)*i,this.y=e.y+(t.y-e.y)*i,this}equals(e){return e.x===this.x&&e.y===this.y}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this}rotateAround(e,t){var i=Math.cos(t),t=Math.sin(t),r=this.x-e.x,s=this.y-e.y;return this.x=r*i-s*t+e.x,this.y=r*t+s*i+e.y,this}random(){return this.x=Math.random(),this.y=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y}}class z{constructor(e=new N(1/0,1/0,1/0),t=new N(-1/0,-1/0,-1/0)){this.isBox3=!0,this.min=e,this.max=t}set(e,t){return this.min.copy(e),this.max.copy(t),this}setFromArray(i){this.makeEmpty();for(let e=0,t=i.length;e<t;e+=3)this.expandByPoint(n.fromArray(i,e));return this}setFromBufferAttribute(i){this.makeEmpty();for(let e=0,t=i.count;e<t;e++)this.expandByPoint(n.fromBufferAttribute(i,e));return this}setFromPoints(i){this.makeEmpty();for(let e=0,t=i.length;e<t;e++)this.expandByPoint(i[e]);return this}setFromCenterAndSize(e,t){t=n.copy(t).multiplyScalar(.5);return this.min.copy(e).sub(t),this.max.copy(e).add(t),this}setFromObject(e,t=!1){return this.makeEmpty(),this.expandByObject(e,t)}clone(){return(new this.constructor).copy(this)}copy(e){return this.min.copy(e.min),this.max.copy(e.max),this}makeEmpty(){return this.min.x=this.min.y=this.min.z=1/0,this.max.x=this.max.y=this.max.z=-1/0,this}isEmpty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z}getCenter(e){return this.isEmpty()?e.set(0,0,0):e.addVectors(this.min,this.max).multiplyScalar(.5)}getSize(e){return this.isEmpty()?e.set(0,0,0):e.subVectors(this.max,this.min)}expandByPoint(e){return this.min.min(e),this.max.max(e),this}expandByVector(e){return this.min.sub(e),this.max.add(e),this}expandByScalar(e){return this.min.addScalar(-e),this.max.addScalar(e),this}expandByObject(i,r=!1){i.updateWorldMatrix(!1,!1);var e=i.geometry;if(void 0!==e){var s=e.getAttribute("position");if(!0===r&&void 0!==s&&!0!==i.isInstancedMesh)for(let e=0,t=s.count;e<t;e++)!0===i.isMesh?i.getVertexPosition(e,n):n.fromBufferAttribute(s,e),n.applyMatrix4(i.matrixWorld),this.expandByPoint(n);else void 0!==i.boundingBox?(null===i.boundingBox&&i.computeBoundingBox(),B.copy(i.boundingBox)):(null===e.boundingBox&&e.computeBoundingBox(),B.copy(e.boundingBox)),B.applyMatrix4(i.matrixWorld),this.union(B)}var a=i.children;for(let e=0,t=a.length;e<t;e++)this.expandByObject(a[e],r);return this}containsPoint(e){return e.x>=this.min.x&&e.x<=this.max.x&&e.y>=this.min.y&&e.y<=this.max.y&&e.z>=this.min.z&&e.z<=this.max.z}containsBox(e){return this.min.x<=e.min.x&&e.max.x<=this.max.x&&this.min.y<=e.min.y&&e.max.y<=this.max.y&&this.min.z<=e.min.z&&e.max.z<=this.max.z}getParameter(e,t){return t.set((e.x-this.min.x)/(this.max.x-this.min.x),(e.y-this.min.y)/(this.max.y-this.min.y),(e.z-this.min.z)/(this.max.z-this.min.z))}intersectsBox(e){return e.max.x>=this.min.x&&e.min.x<=this.max.x&&e.max.y>=this.min.y&&e.min.y<=this.max.y&&e.max.z>=this.min.z&&e.min.z<=this.max.z}intersectsSphere(e){return this.clampPoint(e.center,n),n.distanceToSquared(e.center)<=e.radius*e.radius}intersectsPlane(e){let t,i;return i=0<e.normal.x?(t=e.normal.x*this.min.x,e.normal.x*this.max.x):(t=e.normal.x*this.max.x,e.normal.x*this.min.x),0<e.normal.y?(t+=e.normal.y*this.min.y,i+=e.normal.y*this.max.y):(t+=e.normal.y*this.max.y,i+=e.normal.y*this.min.y),0<e.normal.z?(t+=e.normal.z*this.min.z,i+=e.normal.z*this.max.z):(t+=e.normal.z*this.max.z,i+=e.normal.z*this.min.z),t<=-e.constant&&i>=-e.constant}intersectsTriangle(e){return!this.isEmpty()&&(this.getCenter(J),K.subVectors(this.max,J),W.subVectors(e.a,J),Y.subVectors(e.b,J),X.subVectors(e.c,J),j.subVectors(Y,W),q.subVectors(X,Y),Z.subVectors(W,X),!!ee([0,-j.z,j.y,0,-q.z,q.y,0,-Z.z,Z.y,j.z,0,-j.x,q.z,0,-q.x,Z.z,0,-Z.x,-j.y,j.x,0,-q.y,q.x,0,-Z.y,Z.x,0],W,Y,X,K))&&!!ee([1,0,0,0,1,0,0,0,1],W,Y,X,K)&&(Q.crossVectors(j,q),ee([Q.x,Q.y,Q.z],W,Y,X,K))}clampPoint(e,t){return t.copy(e).clamp(this.min,this.max)}distanceToPoint(e){return this.clampPoint(e,n).distanceTo(e)}getBoundingSphere(e){return this.isEmpty()?e.makeEmpty():(this.getCenter(e.center),e.radius=.5*this.getSize(n).length()),e}intersect(e){return this.min.max(e.min),this.max.min(e.max),this.isEmpty()&&this.makeEmpty(),this}union(e){return this.min.min(e.min),this.max.max(e.max),this}applyMatrix4(e){return this.isEmpty()||(i[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(e),i[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(e),i[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(e),i[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(e),i[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(e),i[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(e),i[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(e),i[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(e),this.setFromPoints(i)),this}translate(e){return this.min.add(e),this.max.add(e),this}equals(e){return e.min.equals(this.min)&&e.max.equals(this.max)}}let i=[new N,new N,new N,new N,new N,new N,new N,new N],n=new N,B=new z,W=new N,Y=new N,X=new N,j=new N,q=new N,Z=new N,J=new N,K=new N,Q=new N,$=new N;function ee(i,r,s,a,n){for(let e=0,t=i.length-3;e<=t;e+=3){$.fromArray(i,e);var o=n.x*Math.abs($.x)+n.y*Math.abs($.y)+n.z*Math.abs($.z),h=r.dot($),l=s.dot($),c=a.dot($);if(Math.max(-Math.max(h,l,c),Math.min(h,l,c))>o)return!1}return!0}let te=new z,ie=new N,re=new N;class se{constructor(e=new N,t=-1){this.isSphere=!0,this.center=e,this.radius=t}set(e,t){return this.center.copy(e),this.radius=t,this}setFromPoints(i,e){var r=this.center;void 0!==e?r.copy(e):te.setFromPoints(i).getCenter(r);let s=0;for(let e=0,t=i.length;e<t;e++)s=Math.max(s,r.distanceToSquared(i[e]));return this.radius=Math.sqrt(s),this}copy(e){return this.center.copy(e.center),this.radius=e.radius,this}isEmpty(){return this.radius<0}makeEmpty(){return this.center.set(0,0,0),this.radius=-1,this}containsPoint(e){return e.distanceToSquared(this.center)<=this.radius*this.radius}distanceToPoint(e){return e.distanceTo(this.center)-this.radius}intersectsSphere(e){var t=this.radius+e.radius;return e.center.distanceToSquared(this.center)<=t*t}intersectsBox(e){return e.intersectsSphere(this)}intersectsPlane(e){return Math.abs(e.distanceToPoint(this.center))<=this.radius}clampPoint(e,t){var i=this.center.distanceToSquared(e);return t.copy(e),i>this.radius*this.radius&&(t.sub(this.center).normalize(),t.multiplyScalar(this.radius).add(this.center)),t}getBoundingBox(e){return this.isEmpty()?e.makeEmpty():(e.set(this.center,this.center),e.expandByScalar(this.radius)),e}applyMatrix4(e){return this.center.applyMatrix4(e),this.radius=this.radius*e.getMaxScaleOnAxis(),this}translate(e){return this.center.add(e),this}expandByPoint(e){var t;return this.isEmpty()?(this.center.copy(e),this.radius=0):(ie.subVectors(e,this.center),(e=ie.lengthSq())>this.radius*this.radius&&(t=.5*((e=Math.sqrt(e))-this.radius),this.center.addScaledVector(ie,t/e),this.radius+=t)),this}union(e){return e.isEmpty()||(this.isEmpty()?this.copy(e):!0===this.center.equals(e.center)?this.radius=Math.max(this.radius,e.radius):(re.subVectors(e.center,this.center).setLength(e.radius),this.expandByPoint(ie.copy(e.center).add(re)),this.expandByPoint(ie.copy(e.center).sub(re)))),this}equals(e){return e.center.equals(this.center)&&e.radius===this.radius}clone(){return(new this.constructor).copy(this)}}let o=new N,ae=new N,ne=new N,oe=new N,he=new N,le=new N,ce=new N;class de{constructor(e=new N,t=new N(0,0,-1)){this.origin=e,this.direction=t}set(e,t){return this.origin.copy(e),this.direction.copy(t),this}copy(e){return this.origin.copy(e.origin),this.direction.copy(e.direction),this}at(e,t){return t.copy(this.origin).addScaledVector(this.direction,e)}lookAt(e){return this.direction.copy(e).sub(this.origin).normalize(),this}recast(e){return this.origin.copy(this.at(e,o)),this}closestPointToPoint(e,t){t.subVectors(e,this.origin);e=t.dot(this.direction);return e<0?t.copy(this.origin):t.copy(this.origin).addScaledVector(this.direction,e)}distanceToPoint(e){return Math.sqrt(this.distanceSqToPoint(e))}distanceSqToPoint(e){var t=o.subVectors(e,this.origin).dot(this.direction);return(t<0?this.origin:(o.copy(this.origin).addScaledVector(this.direction,t),o)).distanceToSquared(e)}distanceSqToSegment(e,t,i,r){ae.copy(e).add(t).multiplyScalar(.5),ne.copy(t).sub(e).normalize(),oe.copy(this.origin).sub(ae);var e=.5*e.distanceTo(t),t=-this.direction.dot(ne),s=oe.dot(this.direction),a=-oe.dot(ne),n=oe.lengthSq(),o=Math.abs(1-t*t);let h,l,c,d;return c=0<o?(h=t*a-s,l=t*s-a,d=e*o,0<=h?l>=-d?l<=d?(o=1/o,h*=o,l*=o,h*(h+t*l+2*s)+l*(t*h+l+2*a)+n):(l=e,-(h=Math.max(0,-(t*l+s)))*h+l*(l+2*a)+n):(l=-e,-(h=Math.max(0,-(t*l+s)))*h+l*(l+2*a)+n):l<=-d?(h=Math.max(0,-(-t*e+s)),l=0<h?-e:Math.min(Math.max(-e,-a),e),-h*h+l*(l+2*a)+n):l<=d?(h=0,(l=Math.min(Math.max(-e,-a),e))*(l+2*a)+n):(h=Math.max(0,-(t*e+s)),l=0<h?e:Math.min(Math.max(-e,-a),e),-h*h+l*(l+2*a)+n)):(l=0<t?-e:e,-(h=Math.max(0,-(t*l+s)))*h+l*(l+2*a)+n),i&&i.copy(this.origin).addScaledVector(this.direction,h),r&&r.copy(ae).addScaledVector(ne,l),c}intersectSphere(e,t){o.subVectors(e.center,this.origin);var i=o.dot(this.direction),r=o.dot(o)-i*i,e=e.radius*e.radius;return e<r||(r=i-(e=Math.sqrt(e-r)),(i=i+e)<0)?null:r<0?this.at(i,t):this.at(r,t)}intersectsSphere(e){return this.distanceSqToPoint(e.center)<=e.radius*e.radius}distanceToPlane(e){var t=e.normal.dot(this.direction);return 0===t?0===e.distanceToPoint(this.origin)?0:null:0<=(e=-(this.origin.dot(e.normal)+e.constant)/t)?e:null}intersectPlane(e,t){e=this.distanceToPlane(e);return null===e?null:this.at(e,t)}intersectsPlane(e){var t=e.distanceToPoint(this.origin);return 0===t||e.normal.dot(this.direction)*t<0}intersectBox(e,t){let i,r,s,a,n,o;var h=1/this.direction.x,l=1/this.direction.y,c=1/this.direction.z,d=this.origin;return r=0<=h?(i=(e.min.x-d.x)*h,(e.max.x-d.x)*h):(i=(e.max.x-d.x)*h,(e.min.x-d.x)*h),a=0<=l?(s=(e.min.y-d.y)*l,(e.max.y-d.y)*l):(s=(e.max.y-d.y)*l,(e.min.y-d.y)*l),i>a||s>r||((s>i||isNaN(i))&&(i=s),(a<r||isNaN(r))&&(r=a),o=0<=c?(n=(e.min.z-d.z)*c,(e.max.z-d.z)*c):(n=(e.max.z-d.z)*c,(e.min.z-d.z)*c),i>o)||n>r||((n>i||i!=i)&&(i=n),(r=o<r||r!=r?o:r)<0)?null:this.at(0<=i?i:r,t)}intersectsBox(e){return null!==this.intersectBox(e,o)}intersectTriangle(e,t,i,r,s){he.subVectors(t,e),le.subVectors(i,e),ce.crossVectors(he,le);let a=this.direction.dot(ce),n;if(0<a){if(r)return null;n=1}else{if(!(a<0))return null;n=-1,a=-a}oe.subVectors(this.origin,e);t=n*this.direction.dot(le.crossVectors(oe,le));return t<0||(i=n*this.direction.dot(he.cross(oe)))<0||t+i>a||(r=-n*oe.dot(ce))<0?null:this.at(r/a,s)}applyMatrix4(e){return this.origin.applyMatrix4(e),this.direction.transformDirection(e),this}equals(e){return e.origin.equals(this.origin)&&e.direction.equals(this.direction)}clone(){return(new this.constructor).copy(this)}}let ue=0,fe=1,me=2,pe=1,ve=100,ge=204,_e=205,xe=3,Me=0,Se=300,we=1e3,ye=1001,be=1002,Ee=1006,Ce=1008,Le=1009,Te=1015,Ae=1023,Pe=0,Ne="",De="srgb",Re="srgb-linear",Ie="display-p3",Ue="display-p3-linear",Oe="linear",Fe="srgb",He="rec709",Ve="p3",Ge=7680,ke=519,ze=35044,Be=2e3,We=2001;class _{constructor(e,t,i,r,s,a,n,o,h,l,c,d,u,f,m,p){_.prototype.isMatrix4=!0,this.elements=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],void 0!==e&&this.set(e,t,i,r,s,a,n,o,h,l,c,d,u,f,m,p)}set(e,t,i,r,s,a,n,o,h,l,c,d,u,f,m,p){var v=this.elements;return v[0]=e,v[4]=t,v[8]=i,v[12]=r,v[1]=s,v[5]=a,v[9]=n,v[13]=o,v[2]=h,v[6]=l,v[10]=c,v[14]=d,v[3]=u,v[7]=f,v[11]=m,v[15]=p,this}identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this}clone(){return(new _).fromArray(this.elements)}copy(e){var t=this.elements,e=e.elements;return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[4]=e[4],t[5]=e[5],t[6]=e[6],t[7]=e[7],t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],this}copyPosition(e){var t=this.elements,e=e.elements;return t[12]=e[12],t[13]=e[13],t[14]=e[14],this}setFromMatrix3(e){e=e.elements;return this.set(e[0],e[3],e[6],0,e[1],e[4],e[7],0,e[2],e[5],e[8],0,0,0,0,1),this}extractBasis(e,t,i){return e.setFromMatrixColumn(this,0),t.setFromMatrixColumn(this,1),i.setFromMatrixColumn(this,2),this}makeBasis(e,t,i){return this.set(e.x,t.x,i.x,0,e.y,t.y,i.y,0,e.z,t.z,i.z,0,0,0,0,1),this}extractRotation(e){var t=this.elements,i=e.elements,r=1/Ye.setFromMatrixColumn(e,0).length(),s=1/Ye.setFromMatrixColumn(e,1).length(),e=1/Ye.setFromMatrixColumn(e,2).length();return t[0]=i[0]*r,t[1]=i[1]*r,t[2]=i[2]*r,t[3]=0,t[4]=i[4]*s,t[5]=i[5]*s,t[6]=i[6]*s,t[7]=0,t[8]=i[8]*e,t[9]=i[9]*e,t[10]=i[10]*e,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromEuler(e){var t,i,r,s,a=this.elements,n=e.x,o=e.y,h=e.z,l=Math.cos(n),n=Math.sin(n),c=Math.cos(o),o=Math.sin(o),d=Math.cos(h),h=Math.sin(h);return"XYZ"===e.order?(i=l*d,r=l*h,s=n*d,t=n*h,a[0]=c*d,a[4]=-c*h,a[8]=o,a[1]=r+s*o,a[5]=i-t*o,a[9]=-n*c,a[2]=t-i*o,a[6]=s+r*o,a[10]=l*c):"YXZ"===e.order?(t=c*h,i=o*d,a[0]=(s=c*d)+(r=o*h)*n,a[4]=i*n-t,a[8]=l*o,a[1]=l*h,a[5]=l*d,a[9]=-n,a[2]=t*n-i,a[6]=r+s*n,a[10]=l*c):"ZXY"===e.order?(t=c*h,i=o*d,a[0]=(r=c*d)-(s=o*h)*n,a[4]=-l*h,a[8]=i+t*n,a[1]=t+i*n,a[5]=l*d,a[9]=s-r*n,a[2]=-l*o,a[6]=n,a[10]=l*c):"ZYX"===e.order?(t=l*d,i=l*h,s=n*d,r=n*h,a[0]=c*d,a[4]=s*o-i,a[8]=t*o+r,a[1]=c*h,a[5]=r*o+t,a[9]=i*o-s,a[2]=-o,a[6]=n*c,a[10]=l*c):"YZX"===e.order?(r=l*c,t=l*o,i=n*c,s=n*o,a[0]=c*d,a[4]=s-r*h,a[8]=i*h+t,a[1]=h,a[5]=l*d,a[9]=-n*d,a[2]=-o*d,a[6]=t*h+i,a[10]=r-s*h):"XZY"===e.order&&(t=l*c,i=l*o,r=n*c,s=n*o,a[0]=c*d,a[4]=-h,a[8]=o*d,a[1]=t*h+s,a[5]=l*d,a[9]=i*h-r,a[2]=r*h-i,a[6]=n*d,a[10]=s*h+t),a[3]=0,a[7]=0,a[11]=0,a[12]=0,a[13]=0,a[14]=0,a[15]=1,this}makeRotationFromQuaternion(e){return this.compose(Xe,e,je)}lookAt(e,t,i){var r=this.elements;return l.subVectors(e,t),0===l.lengthSq()&&(l.z=1),l.normalize(),qe.crossVectors(i,l),0===qe.lengthSq()&&(1===Math.abs(i.z)?l.x+=1e-4:l.z+=1e-4,l.normalize(),qe.crossVectors(i,l)),qe.normalize(),Ze.crossVectors(l,qe),r[0]=qe.x,r[4]=Ze.x,r[8]=l.x,r[1]=qe.y,r[5]=Ze.y,r[9]=l.y,r[2]=qe.z,r[6]=Ze.z,r[10]=l.z,this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){var e=e.elements,t=t.elements,i=this.elements,r=e[0],s=e[4],a=e[8],n=e[12],o=e[1],h=e[5],l=e[9],c=e[13],d=e[2],u=e[6],f=e[10],m=e[14],p=e[3],v=e[7],g=e[11],e=e[15],_=t[0],x=t[4],M=t[8],S=t[12],w=t[1],y=t[5],b=t[9],E=t[13],C=t[2],L=t[6],T=t[10],A=t[14],P=t[3],N=t[7],D=t[11],t=t[15];return i[0]=r*_+s*w+a*C+n*P,i[4]=r*x+s*y+a*L+n*N,i[8]=r*M+s*b+a*T+n*D,i[12]=r*S+s*E+a*A+n*t,i[1]=o*_+h*w+l*C+c*P,i[5]=o*x+h*y+l*L+c*N,i[9]=o*M+h*b+l*T+c*D,i[13]=o*S+h*E+l*A+c*t,i[2]=d*_+u*w+f*C+m*P,i[6]=d*x+u*y+f*L+m*N,i[10]=d*M+u*b+f*T+m*D,i[14]=d*S+u*E+f*A+m*t,i[3]=p*_+v*w+g*C+e*P,i[7]=p*x+v*y+g*L+e*N,i[11]=p*M+v*b+g*T+e*D,i[15]=p*S+v*E+g*A+e*t,this}multiplyScalar(e){var t=this.elements;return t[0]*=e,t[4]*=e,t[8]*=e,t[12]*=e,t[1]*=e,t[5]*=e,t[9]*=e,t[13]*=e,t[2]*=e,t[6]*=e,t[10]*=e,t[14]*=e,t[3]*=e,t[7]*=e,t[11]*=e,t[15]*=e,this}determinant(){var e=this.elements,t=e[0],i=e[4],r=e[8],s=e[12],a=e[1],n=e[5],o=e[9],h=e[13],l=e[2],c=e[6],d=e[10],u=e[14];return e[3]*(+s*o*c-r*h*c-s*n*d+i*h*d+r*n*u-i*o*u)+e[7]*(+t*o*u-t*h*d+s*a*d-r*a*u+r*h*l-s*o*l)+e[11]*(+t*h*c-t*n*u-s*a*c+i*a*u+s*n*l-i*h*l)+e[15]*(-r*n*l-t*o*c+t*n*d+r*a*c-i*a*d+i*o*l)}transpose(){var e=this.elements,t=e[1];return e[1]=e[4],e[4]=t,t=e[2],e[2]=e[8],e[8]=t,t=e[6],e[6]=e[9],e[9]=t,t=e[3],e[3]=e[12],e[12]=t,t=e[7],e[7]=e[13],e[13]=t,t=e[11],e[11]=e[14],e[14]=t,this}setPosition(e,t,i){var r=this.elements;return e.isVector3?(r[12]=e.x,r[13]=e.y,r[14]=e.z):(r[12]=e,r[13]=t,r[14]=i),this}invert(){var e=this.elements,t=e[0],i=e[1],r=e[2],s=e[3],a=e[4],n=e[5],o=e[6],h=e[7],l=e[8],c=e[9],d=e[10],u=e[11],f=e[12],m=e[13],p=e[14],v=e[15],g=c*p*h-m*d*h+m*o*u-n*p*u-c*o*v+n*d*v,_=f*d*h-l*p*h-f*o*u+a*p*u+l*o*v-a*d*v,x=l*m*h-f*c*h+f*n*u-a*m*u-l*n*v+a*c*v,M=f*c*o-l*m*o-f*n*d+a*m*d+l*n*p-a*c*p,S=t*g+i*_+r*x+s*M;return 0==S?this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0):(e[0]=g*(g=1/S),e[1]=(m*d*s-c*p*s-m*r*u+i*p*u+c*r*v-i*d*v)*g,e[2]=(n*p*s-m*o*s+m*r*h-i*p*h-n*r*v+i*o*v)*g,e[3]=(c*o*s-n*d*s-c*r*h+i*d*h+n*r*u-i*o*u)*g,e[4]=_*g,e[5]=(l*p*s-f*d*s+f*r*u-t*p*u-l*r*v+t*d*v)*g,e[6]=(f*o*s-a*p*s-f*r*h+t*p*h+a*r*v-t*o*v)*g,e[7]=(a*d*s-l*o*s+l*r*h-t*d*h-a*r*u+t*o*u)*g,e[8]=x*g,e[9]=(f*c*s-l*m*s-f*i*u+t*m*u+l*i*v-t*c*v)*g,e[10]=(a*m*s-f*n*s+f*i*h-t*m*h-a*i*v+t*n*v)*g,e[11]=(l*n*s-a*c*s-l*i*h+t*c*h+a*i*u-t*n*u)*g,e[12]=M*g,e[13]=(l*m*r-f*c*r+f*i*d-t*m*d-l*i*p+t*c*p)*g,e[14]=(f*n*r-a*m*r-f*i*o+t*m*o+a*i*p-t*n*p)*g,e[15]=(a*c*r-l*n*r+l*i*o-t*c*o-a*i*d+t*n*d)*g,this)}scale(e){var t=this.elements,i=e.x,r=e.y,e=e.z;return t[0]*=i,t[4]*=r,t[8]*=e,t[1]*=i,t[5]*=r,t[9]*=e,t[2]*=i,t[6]*=r,t[10]*=e,t[3]*=i,t[7]*=r,t[11]*=e,this}getMaxScaleOnAxis(){var e=this.elements,t=e[0]*e[0]+e[1]*e[1]+e[2]*e[2];return Math.sqrt(Math.max(t,e[4]*e[4]+e[5]*e[5]+e[6]*e[6],e[8]*e[8]+e[9]*e[9]+e[10]*e[10]))}makeTranslation(e,t,i){return e.isVector3?this.set(1,0,0,e.x,0,1,0,e.y,0,0,1,e.z,0,0,0,1):this.set(1,0,0,e,0,1,0,t,0,0,1,i,0,0,0,1),this}makeRotationX(e){var t=Math.cos(e),e=Math.sin(e);return this.set(1,0,0,0,0,t,-e,0,0,e,t,0,0,0,0,1),this}makeRotationY(e){var t=Math.cos(e),e=Math.sin(e);return this.set(t,0,e,0,0,1,0,0,-e,0,t,0,0,0,0,1),this}makeRotationZ(e){var t=Math.cos(e),e=Math.sin(e);return this.set(t,-e,0,0,e,t,0,0,0,0,1,0,0,0,0,1),this}makeRotationAxis(e,t){var i=Math.cos(t),t=Math.sin(t),r=1-i,s=e.x,a=e.y,e=e.z,n=r*s,o=r*a;return this.set(n*s+i,n*a-t*e,n*e+t*a,0,n*a+t*e,o*a+i,o*e-t*s,0,n*e-t*a,o*e+t*s,r*e*e+i,0,0,0,0,1),this}makeScale(e,t,i){return this.set(e,0,0,0,0,t,0,0,0,0,i,0,0,0,0,1),this}makeShear(e,t,i,r,s,a){return this.set(1,i,s,0,e,1,a,0,t,r,1,0,0,0,0,1),this}compose(e,t,i){var r=this.elements,s=t.t,a=t.i,n=t.o,t=t.u,o=s+s,h=a+a,l=n+n,c=s*o,d=s*h,s=s*l,u=a*h,a=a*l,n=n*l,o=t*o,h=t*h,t=t*l,l=i.x,f=i.y,i=i.z;return r[0]=(1-(u+n))*l,r[1]=(d+t)*l,r[2]=(s-h)*l,r[3]=0,r[4]=(d-t)*f,r[5]=(1-(c+n))*f,r[6]=(a+o)*f,r[7]=0,r[8]=(s+h)*i,r[9]=(a-o)*i,r[10]=(1-(c+u))*i,r[11]=0,r[12]=e.x,r[13]=e.y,r[14]=e.z,r[15]=1,this}decompose(e,t,i){var r=this.elements;let s=Ye.set(r[0],r[1],r[2]).length();var a=Ye.set(r[4],r[5],r[6]).length(),n=Ye.set(r[8],r[9],r[10]).length(),e=(this.determinant()<0&&(s=-s),e.x=r[12],e.y=r[13],e.z=r[14],h.copy(this),1/s),r=1/a,o=1/n;return h.elements[0]*=e,h.elements[1]*=e,h.elements[2]*=e,h.elements[4]*=r,h.elements[5]*=r,h.elements[6]*=r,h.elements[8]*=o,h.elements[9]*=o,h.elements[10]*=o,t.setFromRotationMatrix(h),i.x=s,i.y=a,i.z=n,this}makePerspective(e,t,i,r,s,a,n=Be){var o=this.elements,h=2*s/(t-e),l=2*s/(i-r),t=(t+e)/(t-e),e=(i+r)/(i-r);let c,d;if(n===Be)c=-(a+s)/(a-s),d=-2*a*s/(a-s);else{if(n!==We)throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: "+n);c=-a/(a-s),d=-a*s/(a-s)}return o[0]=h,o[4]=0,o[8]=t,o[12]=0,o[1]=0,o[5]=l,o[9]=e,o[13]=0,o[2]=0,o[6]=0,o[10]=c,o[14]=d,o[3]=0,o[7]=0,o[11]=-1,o[15]=0,this}makeOrthographic(e,t,i,r,s,a,n=Be){var o=this.elements,h=1/(t-e),l=1/(i-r),c=1/(a-s),t=(t+e)*h,e=(i+r)*l;let d,u;if(n===Be)d=(a+s)*c,u=-2*c;else{if(n!==We)throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: "+n);d=s*c,u=-1*c}return o[0]=2*h,o[4]=0,o[8]=0,o[12]=-t,o[1]=0,o[5]=2*l,o[9]=0,o[13]=-e,o[2]=0,o[6]=0,o[10]=u,o[14]=-d,o[3]=0,o[7]=0,o[11]=0,o[15]=1,this}equals(e){var t=this.elements,i=e.elements;for(let e=0;e<16;e++)if(t[e]!==i[e])return!1;return!0}fromArray(t,i=0){for(let e=0;e<16;e++)this.elements[e]=t[e+i];return this}toArray(e=[],t=0){var i=this.elements;return e[t]=i[0],e[t+1]=i[1],e[t+2]=i[2],e[t+3]=i[3],e[t+4]=i[4],e[t+5]=i[5],e[t+6]=i[6],e[t+7]=i[7],e[t+8]=i[8],e[t+9]=i[9],e[t+10]=i[10],e[t+11]=i[11],e[t+12]=i[12],e[t+13]=i[13],e[t+14]=i[14],e[t+15]=i[15],e}}let Ye=new N,h=new _,Xe=new N(0,0,0),je=new N(1,1,1),qe=new N,Ze=new N,l=new N;class Je{addEventListener(e,t){void 0===this._&&(this._={});var i=this._;void 0===i[e]&&(i[e]=[]),-1===i[e].indexOf(t)&&i[e].push(t)}hasEventListener(e,t){var i;return void 0!==this._&&void 0!==(i=this._)[e]&&-1!==i[e].indexOf(t)}removeEventListener(e,t){var i;void 0!==this._&&void 0!==(e=this._[e])&&-1!==(i=e.indexOf(t))&&e.splice(i,1)}dispatchEvent(i){if(void 0!==this._){var e=this._[i.type];if(void 0!==e){i.target=this;var r=e.slice(0);for(let e=0,t=r.length;e<t;e++)r[e].call(this,i);i.target=null}}}}let Ke=new _,Qe=new V;class $e{constructor(e=0,t=0,i=0,r=$e.DEFAULT_ORDER){this.isEuler=!0,this.t=e,this.i=t,this.o=i,this.p=r}get x(){return this.t}set x(e){this.t=e,this.m()}get y(){return this.i}set y(e){this.i=e,this.m()}get z(){return this.o}set z(e){this.o=e,this.m()}get order(){return this.p}set order(e){this.p=e,this.m()}set(e,t,i,r=this.p){return this.t=e,this.i=t,this.o=i,this.p=r,this.m(),this}clone(){return new this.constructor(this.t,this.i,this.o,this.p)}copy(e){return this.t=e.t,this.i=e.i,this.o=e.o,this.p=e.p,this.m(),this}setFromRotationMatrix(e,t=this.p,i=!0){var e=e.elements,r=e[0],s=e[4],a=e[8],n=e[1],o=e[5],h=e[9],l=e[2],c=e[6],d=e[10];switch(t){case"XYZ":this.i=Math.asin(v(a,-1,1)),Math.abs(a)<.9999999?(this.t=Math.atan2(-h,d),this.o=Math.atan2(-s,r)):(this.t=Math.atan2(c,o),this.o=0);break;case"YXZ":this.t=Math.asin(-v(h,-1,1)),Math.abs(h)<.9999999?(this.i=Math.atan2(a,d),this.o=Math.atan2(n,o)):(this.i=Math.atan2(-l,r),this.o=0);break;case"ZXY":this.t=Math.asin(v(c,-1,1)),Math.abs(c)<.9999999?(this.i=Math.atan2(-l,d),this.o=Math.atan2(-s,o)):(this.i=0,this.o=Math.atan2(n,r));break;case"ZYX":this.i=Math.asin(-v(l,-1,1)),Math.abs(l)<.9999999?(this.t=Math.atan2(c,d),this.o=Math.atan2(n,r)):(this.t=0,this.o=Math.atan2(-s,o));break;case"YZX":this.o=Math.asin(v(n,-1,1)),Math.abs(n)<.9999999?(this.t=Math.atan2(-h,o),this.i=Math.atan2(-l,r)):(this.t=0,this.i=Math.atan2(a,d));break;case"XZY":this.o=Math.asin(-v(s,-1,1)),Math.abs(s)<.9999999?(this.t=Math.atan2(c,o),this.i=Math.atan2(a,r)):(this.t=Math.atan2(-h,d),this.i=0);break;default:console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: "+t)}return this.p=t,!0===i&&this.m(),this}setFromQuaternion(e,t,i){return Ke.makeRotationFromQuaternion(e),this.setFromRotationMatrix(Ke,t,i)}setFromVector3(e,t=this.p){return this.set(e.x,e.y,e.z,t)}reorder(e){return Qe.setFromEuler(this),this.setFromQuaternion(Qe,e)}equals(e){return e.t===this.t&&e.i===this.i&&e.o===this.o&&e.p===this.p}fromArray(e){return this.t=e[0],this.i=e[1],this.o=e[2],void 0!==e[3]&&(this.p=e[3]),this.m(),this}toArray(e=[],t=0){return e[t]=this.t,e[t+1]=this.i,e[t+2]=this.o,e[t+3]=this.p,e}v(e){return this.m=e,this}m(){}*[Symbol.iterator](){yield this.t,yield this.i,yield this.o,yield this.p}}$e.DEFAULT_ORDER="XYZ";class et{constructor(){this.mask=1}set(e){this.mask=(1<<e|0)>>>0}enable(e){this.mask|=1<<e|0}enableAll(){this.mask=-1}toggle(e){this.mask^=1<<e|0}disable(e){this.mask&=~(1<<e|0)}disableAll(){this.mask=0}test(e){return 0!=(this.mask&e.mask)}isEnabled(e){return 0!=(this.mask&(1<<e|0))}}class c{constructor(e,t,i,r,s,a,n,o,h){c.prototype.isMatrix3=!0,this.elements=[1,0,0,0,1,0,0,0,1],void 0!==e&&this.set(e,t,i,r,s,a,n,o,h)}set(e,t,i,r,s,a,n,o,h){var l=this.elements;return l[0]=e,l[1]=r,l[2]=n,l[3]=t,l[4]=s,l[5]=o,l[6]=i,l[7]=a,l[8]=h,this}identity(){return this.set(1,0,0,0,1,0,0,0,1),this}copy(e){var t=this.elements,e=e.elements;return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[4]=e[4],t[5]=e[5],t[6]=e[6],t[7]=e[7],t[8]=e[8],this}extractBasis(e,t,i){return e.setFromMatrix3Column(this,0),t.setFromMatrix3Column(this,1),i.setFromMatrix3Column(this,2),this}setFromMatrix4(e){e=e.elements;return this.set(e[0],e[4],e[8],e[1],e[5],e[9],e[2],e[6],e[10]),this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){var e=e.elements,t=t.elements,i=this.elements,r=e[0],s=e[3],a=e[6],n=e[1],o=e[4],h=e[7],l=e[2],c=e[5],e=e[8],d=t[0],u=t[3],f=t[6],m=t[1],p=t[4],v=t[7],g=t[2],_=t[5],t=t[8];return i[0]=r*d+s*m+a*g,i[3]=r*u+s*p+a*_,i[6]=r*f+s*v+a*t,i[1]=n*d+o*m+h*g,i[4]=n*u+o*p+h*_,i[7]=n*f+o*v+h*t,i[2]=l*d+c*m+e*g,i[5]=l*u+c*p+e*_,i[8]=l*f+c*v+e*t,this}multiplyScalar(e){var t=this.elements;return t[0]*=e,t[3]*=e,t[6]*=e,t[1]*=e,t[4]*=e,t[7]*=e,t[2]*=e,t[5]*=e,t[8]*=e,this}determinant(){var e=this.elements,t=e[0],i=e[1],r=e[2],s=e[3],a=e[4],n=e[5],o=e[6],h=e[7],e=e[8];return t*a*e-t*n*h-i*s*e+i*n*o+r*s*h-r*a*o}invert(){var e=this.elements,t=e[0],i=e[1],r=e[2],s=e[3],a=e[4],n=e[5],o=e[6],h=e[7],l=e[8],c=l*a-n*h,d=n*o-l*s,u=h*s-a*o,f=t*c+i*d+r*u;return 0==f?this.set(0,0,0,0,0,0,0,0,0):(e[0]=c*(c=1/f),e[1]=(r*h-l*i)*c,e[2]=(n*i-r*a)*c,e[3]=d*c,e[4]=(l*t-r*o)*c,e[5]=(r*s-n*t)*c,e[6]=u*c,e[7]=(i*o-h*t)*c,e[8]=(a*t-i*s)*c,this)}transpose(){var e=this.elements,t=e[1];return e[1]=e[3],e[3]=t,t=e[2],e[2]=e[6],e[6]=t,t=e[5],e[5]=e[7],e[7]=t,this}getNormalMatrix(e){return this.setFromMatrix4(e).invert().transpose()}transposeIntoArray(e){var t=this.elements;return e[0]=t[0],e[1]=t[3],e[2]=t[6],e[3]=t[1],e[4]=t[4],e[5]=t[7],e[6]=t[2],e[7]=t[5],e[8]=t[8],this}setUvTransform(e,t,i,r,s,a,n){var o=Math.cos(s),s=Math.sin(s);return this.set(i*o,i*s,-i*(o*a+s*n)+a+e,-r*s,r*o,-r*(-s*a+o*n)+n+t,0,0,1),this}scale(e,t){return this.premultiply(tt.makeScale(e,t)),this}rotate(e){return this.premultiply(tt.makeRotation(-e)),this}translate(e,t){return this.premultiply(tt.makeTranslation(e,t)),this}makeTranslation(e,t){return e.isVector2?this.set(1,0,e.x,0,1,e.y,0,0,1):this.set(1,0,e,0,1,t,0,0,1),this}makeRotation(e){var t=Math.cos(e),e=Math.sin(e);return this.set(t,-e,0,e,t,0,0,0,1),this}makeScale(e,t){return this.set(e,0,0,0,t,0,0,0,1),this}equals(e){var t=this.elements,i=e.elements;for(let e=0;e<9;e++)if(t[e]!==i[e])return!1;return!0}fromArray(t,i=0){for(let e=0;e<9;e++)this.elements[e]=t[e+i];return this}toArray(e=[],t=0){var i=this.elements;return e[t]=i[0],e[t+1]=i[1],e[t+2]=i[2],e[t+3]=i[3],e[t+4]=i[4],e[t+5]=i[5],e[t+6]=i[6],e[t+7]=i[7],e[t+8]=i[8],e}clone(){return(new this.constructor).fromArray(this.elements)}}let tt=new c,it=0,rt=new N,st=new V,d=new _,at=new N,nt=new N,ot=new N,ht=new V,lt=new N(1,0,0),ct=new N(0,1,0),dt=new N(0,0,1),ut={type:"added"},ft={type:"removed"},mt={type:"childadded",child:null},pt={type:"childremoved",child:null};class u extends Je{constructor(){super(),this.isObject3D=!0,Object.defineProperty(this,"id",{value:it++}),this.uuid=O(),this.name="",this.type="Object3D",this.parent=null,this.children=[],this.up=u.DEFAULT_UP.clone();var e=new N;let t=new $e,i=new V;var r=new N(1,1,1);t.v(function(){i.setFromEuler(t,!1)}),i.v(function(){t.setFromQuaternion(i,void 0,!1)}),Object.defineProperties(this,{position:{configurable:!0,enumerable:!0,value:e},rotation:{configurable:!0,enumerable:!0,value:t},quaternion:{configurable:!0,enumerable:!0,value:i},scale:{configurable:!0,enumerable:!0,value:r},modelViewMatrix:{value:new _},normalMatrix:{value:new c}}),this.matrix=new _,this.matrixWorld=new _,this.matrixAutoUpdate=u.DEFAULT_MATRIX_AUTO_UPDATE,this.matrixWorldAutoUpdate=u.DEFAULT_MATRIX_WORLD_AUTO_UPDATE,this.matrixWorldNeedsUpdate=!1,this.layers=new et,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.renderOrder=0,this.animations=[],this.userData={}}onBeforeShadow(){}onAfterShadow(){}onBeforeRender(){}onAfterRender(){}applyMatrix4(e){this.matrixAutoUpdate&&this.updateMatrix(),this.matrix.premultiply(e),this.matrix.decompose(this.position,this.quaternion,this.scale)}applyQuaternion(e){return this.quaternion.premultiply(e),this}setRotationFromAxisAngle(e,t){this.quaternion.setFromAxisAngle(e,t)}setRotationFromEuler(e){this.quaternion.setFromEuler(e,!0)}setRotationFromMatrix(e){this.quaternion.setFromRotationMatrix(e)}setRotationFromQuaternion(e){this.quaternion.copy(e)}rotateOnAxis(e,t){return st.setFromAxisAngle(e,t),this.quaternion.multiply(st),this}rotateOnWorldAxis(e,t){return st.setFromAxisAngle(e,t),this.quaternion.premultiply(st),this}rotateX(e){return this.rotateOnAxis(lt,e)}rotateY(e){return this.rotateOnAxis(ct,e)}rotateZ(e){return this.rotateOnAxis(dt,e)}translateOnAxis(e,t){return rt.copy(e).applyQuaternion(this.quaternion),this.position.add(rt.multiplyScalar(t)),this}translateX(e){return this.translateOnAxis(lt,e)}translateY(e){return this.translateOnAxis(ct,e)}translateZ(e){return this.translateOnAxis(dt,e)}localToWorld(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(this.matrixWorld)}worldToLocal(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(d.copy(this.matrixWorld).invert())}lookAt(e,t,i){e.isVector3?at.copy(e):at.set(e,t,i);e=this.parent;this.updateWorldMatrix(!0,!1),nt.setFromMatrixPosition(this.matrixWorld),this.isCamera||this.isLight?d.lookAt(nt,at,this.up):d.lookAt(at,nt,this.up),this.quaternion.setFromRotationMatrix(d),e&&(d.extractRotation(e.matrixWorld),st.setFromRotationMatrix(d),this.quaternion.premultiply(st.invert()))}add(e){if(1<arguments.length)for(let e=0;e<arguments.length;e++)this.add(arguments[e]);else e===this?console.error("THREE.Object3D.add: object can't be added as a child of itself.",e):e&&e.isObject3D?(e.removeFromParent(),(e.parent=this).children.push(e),e.dispatchEvent(ut),mt.child=e,this.dispatchEvent(mt),mt.child=null):console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.",e);return this}remove(e){if(1<arguments.length)for(let e=0;e<arguments.length;e++)this.remove(arguments[e]);else{var t=this.children.indexOf(e);-1!==t&&(e.parent=null,this.children.splice(t,1),e.dispatchEvent(ft),pt.child=e,this.dispatchEvent(pt),pt.child=null)}return this}removeFromParent(){var e=this.parent;return null!==e&&e.remove(this),this}clear(){return this.remove(...this.children)}attach(e){return this.updateWorldMatrix(!0,!1),d.copy(this.matrixWorld).invert(),null!==e.parent&&(e.parent.updateWorldMatrix(!0,!1),d.multiply(e.parent.matrixWorld)),e.applyMatrix4(d),e.removeFromParent(),(e.parent=this).children.push(e),e.updateWorldMatrix(!1,!0),e.dispatchEvent(ut),mt.child=e,this.dispatchEvent(mt),mt.child=null,this}getObjectById(e){return this.getObjectByProperty("id",e)}getObjectByName(e){return this.getObjectByProperty("name",e)}getObjectByProperty(i,r){if(this[i]===r)return this;for(let e=0,t=this.children.length;e<t;e++){var s=this.children[e].getObjectByProperty(i,r);if(void 0!==s)return s}}getObjectsByProperty(i,r,s=[]){this[i]===r&&s.push(this);var a=this.children;for(let e=0,t=a.length;e<t;e++)a[e].getObjectsByProperty(i,r,s);return s}getWorldPosition(e){return this.updateWorldMatrix(!0,!1),e.setFromMatrixPosition(this.matrixWorld)}getWorldQuaternion(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(nt,e,ot),e}getWorldScale(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(nt,ht,e),e}getWorldDirection(e){this.updateWorldMatrix(!0,!1);var t=this.matrixWorld.elements;return e.set(t[8],t[9],t[10]).normalize()}raycast(){}traverse(i){i(this);var r=this.children;for(let e=0,t=r.length;e<t;e++)r[e].traverse(i)}traverseVisible(i){if(!1!==this.visible){i(this);var r=this.children;for(let e=0,t=r.length;e<t;e++)r[e].traverseVisible(i)}}traverseAncestors(e){var t=this.parent;null!==t&&(e(t),t.traverseAncestors(e))}updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale),this.matrixWorldNeedsUpdate=!0}updateMatrixWorld(i){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||i)&&(!0===this.matrixWorldAutoUpdate&&(null===this.parent?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),i=!(this.matrixWorldNeedsUpdate=!1));var r=this.children;for(let e=0,t=r.length;e<t;e++)r[e].updateMatrixWorld(i)}updateWorldMatrix(e,t){var i=this.parent;if(!0===e&&null!==i&&i.updateWorldMatrix(!0,!1),this.matrixAutoUpdate&&this.updateMatrix(),!0===this.matrixWorldAutoUpdate&&(null===this.parent?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),!0===t){var r=this.children;for(let e=0,t=r.length;e<t;e++)r[e].updateWorldMatrix(!1,!0)}}toJSON(i){var e,t,r,s,a,n,o=void 0===i||"string"==typeof i,h={},l=(o&&(i={geometries:{},materials:{},textures:{},images:{},shapes:{},skeletons:{},animations:{},nodes:{}},h.metadata={version:4.6,type:"Object",generator:"Object3D.toJSON"}),{});function c(e,t){return void 0===e[t.uuid]&&(e[t.uuid]=t.toJSON(i)),t.uuid}if(l.uuid=this.uuid,l.type=this.type,""!==this.name&&(l.name=this.name),!0===this.castShadow&&(l.castShadow=!0),!0===this.receiveShadow&&(l.receiveShadow=!0),!1===this.visible&&(l.visible=!1),!1===this.frustumCulled&&(l.frustumCulled=!1),0!==this.renderOrder&&(l.renderOrder=this.renderOrder),0<Object.keys(this.userData).length&&(l.userData=this.userData),l.layers=this.layers.mask,l.matrix=this.matrix.toArray(),l.up=this.up.toArray(),!1===this.matrixAutoUpdate&&(l.matrixAutoUpdate=!1),this.isInstancedMesh&&(l.type="InstancedMesh",l.count=this.count,l.instanceMatrix=this.instanceMatrix.toJSON(),null!==this.instanceColor)&&(l.instanceColor=this.instanceColor.toJSON()),this.isBatchedMesh&&(l.type="BatchedMesh",l.perObjectFrustumCulled=this.perObjectFrustumCulled,l.sortObjects=this.sortObjects,l.drawRanges=this._drawRanges,l.reservedRanges=this._reservedRanges,l.visibility=this._visibility,l.active=this._active,l.bounds=this._bounds.map(e=>({boxInitialized:e.boxInitialized,boxMin:e.box.min.toArray(),boxMax:e.box.max.toArray(),sphereInitialized:e.sphereInitialized,sphereRadius:e.sphere.radius,sphereCenter:e.sphere.center.toArray()})),l.maxInstanceCount=this._maxInstanceCount,l.maxVertexCount=this._maxVertexCount,l.maxIndexCount=this._maxIndexCount,l.geometryInitialized=this._geometryInitialized,l.geometryCount=this._geometryCount,l.matricesTexture=this._matricesTexture.toJSON(i),null!==this._colorsTexture&&(l.colorsTexture=this._colorsTexture.toJSON(i)),null!==this.boundingSphere&&(l.boundingSphere={center:l.boundingSphere.center.toArray(),radius:l.boundingSphere.radius}),null!==this.boundingBox)&&(l.boundingBox={min:l.boundingBox.min.toArray(),max:l.boundingBox.max.toArray()}),this.isScene)this.background&&(this.background.isColor?l.background=this.background.toJSON():this.background.isTexture&&(l.background=this.background.toJSON(i).uuid)),this.environment&&this.environment.isTexture&&!0!==this.environment.isRenderTargetTexture&&(l.environment=this.environment.toJSON(i).uuid);else if(this.isMesh||this.isLine||this.isPoints){l.geometry=c(i.geometries,this.geometry);var d=this.geometry.parameters;if(void 0!==d&&void 0!==d.shapes){var u=d.shapes;if(Array.isArray(u))for(let e=0,t=u.length;e<t;e++){var f=u[e];c(i.shapes,f)}else c(i.shapes,u)}}if(this.isSkinnedMesh&&(l.bindMode=this.bindMode,l.bindMatrix=this.bindMatrix.toArray(),void 0!==this.skeleton)&&(c(i.skeletons,this.skeleton),l.skeleton=this.skeleton.uuid),void 0!==this.material)if(Array.isArray(this.material)){var m=[];for(let e=0,t=this.material.length;e<t;e++)m.push(c(i.materials,this.material[e]));l.material=m}else l.material=c(i.materials,this.material);if(0<this.children.length){l.children=[];for(let e=0;e<this.children.length;e++)l.children.push(this.children[e].toJSON(i).object)}if(0<this.animations.length){l.animations=[];for(let e=0;e<this.animations.length;e++){var p=this.animations[e];l.animations.push(c(i.animations,p))}}return o&&(d=v(i.geometries),o=v(i.materials),e=v(i.textures),t=v(i.images),r=v(i.shapes),s=v(i.skeletons),a=v(i.animations),n=v(i.nodes),0<d.length&&(h.geometries=d),0<o.length&&(h.materials=o),0<e.length&&(h.textures=e),0<t.length&&(h.images=t),0<r.length&&(h.shapes=r),0<s.length&&(h.skeletons=s),0<a.length&&(h.animations=a),0<n.length)&&(h.nodes=n),h.object=l,h;function v(e){var t,i=[];for(t in e){var r=e[t];delete r.metadata,i.push(r)}return i}}clone(e){return(new this.constructor).copy(this,e)}copy(t,e=!0){if(this.name=t.name,this.up.copy(t.up),this.position.copy(t.position),this.rotation.order=t.rotation.order,this.quaternion.copy(t.quaternion),this.scale.copy(t.scale),this.matrix.copy(t.matrix),this.matrixWorld.copy(t.matrixWorld),this.matrixAutoUpdate=t.matrixAutoUpdate,this.matrixWorldAutoUpdate=t.matrixWorldAutoUpdate,this.matrixWorldNeedsUpdate=t.matrixWorldNeedsUpdate,this.layers.mask=t.layers.mask,this.visible=t.visible,this.castShadow=t.castShadow,this.receiveShadow=t.receiveShadow,this.frustumCulled=t.frustumCulled,this.renderOrder=t.renderOrder,this.animations=t.animations.slice(),this.userData=JSON.parse(JSON.stringify(t.userData)),!0===e)for(let e=0;e<t.children.length;e++){var i=t.children[e];this.add(i.clone())}return this}}u.DEFAULT_UP=new N(0,1,0),u.DEFAULT_MATRIX_AUTO_UPDATE=!0,u.DEFAULT_MATRIX_WORLD_AUTO_UPDATE=!0;class vt{constructor(e=0,t=0,i=0,r=1){vt.prototype.isVector4=!0,this.x=e,this.y=t,this.z=i,this.w=r}get width(){return this.z}set width(e){this.z=e}get height(){return this.w}set height(e){this.w=e}set(e,t,i,r){return this.x=e,this.y=t,this.z=i,this.w=r,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this.w=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setW(e){return this.w=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;case 3:this.w=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y,this.z,this.w)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this.w=void 0!==e.w?e.w:1,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this.w+=e.w,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this.w+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this.w=e.w+t.w,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this.w+=e.w*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this.w-=e.w,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this.w-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this.w=e.w-t.w,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this.w*=e.w,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this.w*=e,this}applyMatrix4(e){var t=this.x,i=this.y,r=this.z,s=this.w,e=e.elements;return this.x=e[0]*t+e[4]*i+e[8]*r+e[12]*s,this.y=e[1]*t+e[5]*i+e[9]*r+e[13]*s,this.z=e[2]*t+e[6]*i+e[10]*r+e[14]*s,this.w=e[3]*t+e[7]*i+e[11]*r+e[15]*s,this}divideScalar(e){return this.multiplyScalar(1/e)}setAxisAngleFromQuaternion(e){this.w=2*Math.acos(e.w);var t=Math.sqrt(1-e.w*e.w);return t<1e-4?(this.x=1,this.y=0,this.z=0):(this.x=e.x/t,this.y=e.y/t,this.z=e.z/t),this}setAxisAngleFromRotationMatrix(t){let e,i,r,s;var a,n,o,h,l,c,t=t.elements,d=t[0],u=t[4],f=t[8],m=t[1],p=t[5],v=t[9],g=t[2],_=t[6],t=t[10];if(Math.abs(u-m)<.01&&Math.abs(f-g)<.01&&Math.abs(v-_)<.01)Math.abs(u+m)<.1&&Math.abs(f+g)<.1&&Math.abs(v+_)<.1&&Math.abs(d+p+t-3)<.1?this.set(1,0,0,0):(e=Math.PI,o=(t+1)/2,h=(u+m)/4,l=(f+g)/4,c=(v+_)/4,(n=(p+1)/2)<(a=(d+1)/2)&&o<a?s=a<.01?(i=0,r=.707106781):(i=Math.sqrt(a),r=h/i,l/i):o<n?s=n<.01?(i=.707106781,r=0,.707106781):(r=Math.sqrt(n),i=h/r,c/r):o<.01?(i=.707106781,r=.707106781,s=0):(s=Math.sqrt(o),i=l/s,r=c/s),this.set(i,r,s,e));else{let e=Math.sqrt((_-v)*(_-v)+(f-g)*(f-g)+(m-u)*(m-u));Math.abs(e)<.001&&(e=1),this.x=(_-v)/e,this.y=(f-g)/e,this.z=(m-u)/e,this.w=Math.acos((d+p+t-1)/2)}return this}setFromMatrixPosition(e){e=e.elements;return this.x=e[12],this.y=e[13],this.z=e[14],this.w=e[15],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this.w=Math.min(this.w,e.w),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this.w=Math.max(this.w,e.w),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this.z=Math.max(e.z,Math.min(t.z,this.z)),this.w=Math.max(e.w,Math.min(t.w,this.w)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this.z=Math.max(e,Math.min(t,this.z)),this.w=Math.max(e,Math.min(t,this.w)),this}clampLength(e,t){var i=this.length();return this.divideScalar(i||1).multiplyScalar(Math.max(e,Math.min(t,i)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this.w=Math.floor(this.w),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this.w=Math.ceil(this.w),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this.w=Math.round(this.w),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this.w=Math.trunc(this.w),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this.w=-this.w,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z+this.w*e.w}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this.w+=(e.w-this.w)*t,this}lerpVectors(e,t,i){return this.x=e.x+(t.x-e.x)*i,this.y=e.y+(t.y-e.y)*i,this.z=e.z+(t.z-e.z)*i,this.w=e.w+(t.w-e.w)*i,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z&&e.w===this.w}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this.w=e[t+3],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e[t+3]=this.w,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this.w=e.getW(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this.w=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z,yield this.w}}let f=new N,m=new N,gt=new N,p=new N,_t=new N,xt=new N,Mt=new N,St=new N,wt=new N,yt=new N,bt=new vt,Et=new vt,Ct=new vt;class g{constructor(e=new N,t=new N,i=new N){this.a=e,this.b=t,this.c=i}static getNormal(e,t,i,r){r.subVectors(i,t),f.subVectors(e,t),r.cross(f);i=r.lengthSq();return 0<i?r.multiplyScalar(1/Math.sqrt(i)):r.set(0,0,0)}static getBarycoord(e,t,i,r,s){f.subVectors(r,t),m.subVectors(i,t),gt.subVectors(e,t);var r=f.dot(f),i=f.dot(m),e=f.dot(gt),t=m.dot(m),a=m.dot(gt),n=r*t-i*i;return 0==n?(s.set(0,0,0),null):s.set(1-(t=(t*e-i*a)*(s=1/n))-(n=(r*a-i*e)*s),n,t)}static containsPoint(e,t,i,r){return null!==this.getBarycoord(e,t,i,r,p)&&0<=p.x&&0<=p.y&&p.x+p.y<=1}static getInterpolation(e,t,i,r,s,a,n,o){return null===this.getBarycoord(e,t,i,r,p)?(o.x=0,o.y=0,"z"in o&&(o.z=0),"w"in o&&(o.w=0),null):(o.setScalar(0),o.addScaledVector(s,p.x),o.addScaledVector(a,p.y),o.addScaledVector(n,p.z),o)}static getInterpolatedAttribute(e,t,i,r,s,a){return bt.setScalar(0),Et.setScalar(0),Ct.setScalar(0),bt.fromBufferAttribute(e,t),Et.fromBufferAttribute(e,i),Ct.fromBufferAttribute(e,r),a.setScalar(0),a.addScaledVector(bt,s.x),a.addScaledVector(Et,s.y),a.addScaledVector(Ct,s.z),a}static isFrontFacing(e,t,i,r){return f.subVectors(i,t),m.subVectors(e,t),f.cross(m).dot(r)<0}set(e,t,i){return this.a.copy(e),this.b.copy(t),this.c.copy(i),this}setFromPointsAndIndices(e,t,i,r){return this.a.copy(e[t]),this.b.copy(e[i]),this.c.copy(e[r]),this}setFromAttributeAndIndices(e,t,i,r){return this.a.fromBufferAttribute(e,t),this.b.fromBufferAttribute(e,i),this.c.fromBufferAttribute(e,r),this}clone(){return(new this.constructor).copy(this)}copy(e){return this.a.copy(e.a),this.b.copy(e.b),this.c.copy(e.c),this}getArea(){return f.subVectors(this.c,this.b),m.subVectors(this.a,this.b),.5*f.cross(m).length()}getMidpoint(e){return e.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)}getNormal(e){return g.getNormal(this.a,this.b,this.c,e)}getPlane(e){return e.setFromCoplanarPoints(this.a,this.b,this.c)}getBarycoord(e,t){return g.getBarycoord(e,this.a,this.b,this.c,t)}getInterpolation(e,t,i,r,s){return g.getInterpolation(e,this.a,this.b,this.c,t,i,r,s)}containsPoint(e){return g.containsPoint(e,this.a,this.b,this.c)}isFrontFacing(e){return g.isFrontFacing(this.a,this.b,this.c,e)}intersectsBox(e){return e.intersectsTriangle(this)}closestPointToPoint(e,t){var i=this.a,r=this.b,s=this.c;let a,n;_t.subVectors(r,i),xt.subVectors(s,i),St.subVectors(e,i);var o=_t.dot(St),h=xt.dot(St);if(o<=0&&h<=0)return t.copy(i);wt.subVectors(e,r);var l=_t.dot(wt),c=xt.dot(wt);if(0<=l&&c<=l)return t.copy(r);var d=o*c-l*h;if(d<=0&&0<=o&&l<=0)return a=o/(o-l),t.copy(i).addScaledVector(_t,a);yt.subVectors(e,s);var e=_t.dot(yt),u=xt.dot(yt);return 0<=u&&e<=u?t.copy(s):(o=e*h-o*u)<=0&&0<=h&&u<=0?(n=h/(h-u),t.copy(i).addScaledVector(xt,n)):(h=l*u-e*c)<=0&&0<=c-l&&0<=e-u?(Mt.subVectors(s,r),n=(c-l)/(c-l+(e-u)),t.copy(r).addScaledVector(Mt,n)):(s=1/(h+o+d),a=o*s,n=d*s,t.copy(i).addScaledVector(_t,a).addScaledVector(xt,n))}equals(e){return e.a.equals(this.a)&&e.b.equals(this.b)&&e.c.equals(this.c)}}let Lt=(new c).set(.8224621,.177538,0,.0331941,.9668058,0,.0170827,.0723974,.9105199),Tt=(new c).set(1.2249401,-.2249404,0,-.0420569,1.0420571,0,-.0196376,-.0786361,1.0982735),At={[Re]:{transfer:Oe,primaries:He,luminanceCoefficients:[.2126,.7152,.0722],toReference:e=>e,fromReference:e=>e},[De]:{transfer:Fe,primaries:He,luminanceCoefficients:[.2126,.7152,.0722],toReference:e=>e.convertSRGBToLinear(),fromReference:e=>e.convertLinearToSRGB()},[Ue]:{transfer:Oe,primaries:Ve,luminanceCoefficients:[.2289,.6917,.0793],toReference:e=>e.applyMatrix3(Tt),fromReference:e=>e.applyMatrix3(Lt)},[Ie]:{transfer:Fe,primaries:Ve,luminanceCoefficients:[.2289,.6917,.0793],toReference:e=>e.convertSRGBToLinear().applyMatrix3(Tt),fromReference:e=>e.applyMatrix3(Lt).convertLinearToSRGB()}},Pt=new Set([Re,Ue]),x={enabled:!0,M:Re,get workingColorSpace(){return this.M},set workingColorSpace(e){if(!Pt.has(e))throw new Error(`Unsupported working color space, "${e}".`);this.M=e},convert:function(e,t,i){return!1!==this.enabled&&t!==i&&t&&i?(t=At[t].toReference,(0,At[i].fromReference)(t(e))):e},fromWorkingColorSpace:function(e,t){return this.convert(e,this.M,t)},toWorkingColorSpace:function(e,t){return this.convert(e,t,this.M)},getPrimaries:function(e){return At[e].primaries},getTransfer:function(e){return e===Ne?Oe:At[e].transfer},getLuminanceCoefficients:function(e,t=this.M){return e.fromArray(At[t].luminanceCoefficients)}};function Nt(e){return e<.04045?.0773993808*e:Math.pow(.9478672986*e+.0521327014,2.4)}function Dt(e){return e<.0031308?12.92*e:1.055*Math.pow(e,.41666)-.055}let Rt=.001,It=Re;function Ut(){return Rt}let Ot={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},Ft={h:0,s:0,l:0},Ht={h:0,s:0,l:0};function Vt(e,t,i){return i<0&&(i+=1),1<i&&--i,i<1/6?e+6*(t-e)*i:i<.5?t:i<2/3?e+6*(t-e)*(2/3-i):e}class M{constructor(e,t,i){return this.isColor=!0,this.r=1,this.g=1,this.b=1,this.set(e,t,i)}set(e,t,i){var r;return void 0===t&&void 0===i?(r=e)&&r.isColor?this.copy(r):"number"==typeof r?this.setHex(r):"string"==typeof r&&this.setStyle(r):this.setRGB(e,t,i),this}setScalar(e){return this.r=e,this.g=e,this.b=e,this}setHex(e,t=It){return e=Math.floor(e),this.r=(e>>16&255)/255,this.g=(e>>8&255)/255,this.b=(255&e)/255,x.toWorkingColorSpace(this,t),this}setRGB(e,t,i,r=x.workingColorSpace){return this.r=e,this.g=t,this.b=i,x.toWorkingColorSpace(this,r),this}setHSL(e,t,i,r=x.workingColorSpace){return e=F(e,1),t=v(t,0,1),i=v(i,0,1),0===t?this.r=this.g=this.b=i:(this.r=Vt(t=2*i-(i=i<=.5?i*(1+t):i+t-i*t),i,e+1/3),this.g=Vt(t,i,e),this.b=Vt(t,i,e-1/3)),x.toWorkingColorSpace(this,r),this}setStyle(t,i=It){function r(e){void 0!==e&&parseFloat(e)<1&&console.warn("THREE.Color: Alpha component of "+t+" will be ignored.")}if(n=/^(\w+)\(([^\)]*)\)/.exec(t)){let e;var s=n[1],a=n[2];switch(s){case"rgb":case"rgba":if(e=/^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a))return r(e[4]),this.setRGB(Math.min(255,parseInt(e[1],10))/255,Math.min(255,parseInt(e[2],10))/255,Math.min(255,parseInt(e[3],10))/255,i);if(e=/^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a))return r(e[4]),this.setRGB(Math.min(100,parseInt(e[1],10))/100,Math.min(100,parseInt(e[2],10))/100,Math.min(100,parseInt(e[3],10))/100,i);break;case"hsl":case"hsla":if(e=/^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a))return r(e[4]),this.setHSL(parseFloat(e[1])/360,parseFloat(e[2])/100,parseFloat(e[3])/100,i);break;default:console.warn("THREE.Color: Unknown color model "+t)}}else if(n=/^\#([A-Fa-f\d]+)$/.exec(t)){var s=n[1],n=s.length;if(3===n)return this.setRGB(parseInt(s.charAt(0),16)/15,parseInt(s.charAt(1),16)/15,parseInt(s.charAt(2),16)/15,i);if(6===n)return this.setHex(parseInt(s,16),i);console.warn("THREE.Color: Invalid hex color "+t)}else if(t&&0<t.length)return this.setColorName(t,i);return this}setColorName(e,t=It){var i=Ot[e.toLowerCase()];return void 0!==i?this.setHex(i,t):console.warn("THREE.Color: Unknown color "+e),this}clone(){return new this.constructor(this.r,this.g,this.b)}copy(e){return this.r=e.r,this.g=e.g,this.b=e.b,this}copySRGBToLinear(e){return this.r=Nt(e.r),this.g=Nt(e.g),this.b=Nt(e.b),this}copyLinearToSRGB(e){return this.r=Dt(e.r),this.g=Dt(e.g),this.b=Dt(e.b),this}convertSRGBToLinear(){return this.copySRGBToLinear(this),this}convertLinearToSRGB(){return this.copyLinearToSRGB(this),this}getHex(e=It){return x.fromWorkingColorSpace(S.copy(this),e),65536*Math.round(v(255*S.r,0,255))+256*Math.round(v(255*S.g,0,255))+Math.round(v(255*S.b,0,255))}getHexString(e=It){return("000000"+this.getHex(e).toString(16)).slice(-6)}getHSL(e,t=x.workingColorSpace){x.fromWorkingColorSpace(S.copy(this),t);var i=S.r,r=S.g,s=S.b,t=Math.max(i,r,s),a=Math.min(i,r,s);let n,o;var h=(a+t)/2;if(a===t)n=0,o=0;else{var l=t-a;switch(o=h<=.5?l/(t+a):l/(2-t-a),t){case i:n=(r-s)/l+(r<s?6:0);break;case r:n=(s-i)/l+2;break;case s:n=(i-r)/l+4}n/=6}return e.h=n,e.s=o,e.l=h,e}getRGB(e,t=x.workingColorSpace){return x.fromWorkingColorSpace(S.copy(this),t),e.r=S.r,e.g=S.g,e.b=S.b,e}getStyle(e=It){x.fromWorkingColorSpace(S.copy(this),e);var t=S.r,i=S.g,r=S.b;return e!==It?`color(${e} ${t.toFixed(3)} ${i.toFixed(3)} ${r.toFixed(3)})`:`rgb(${Math.round(255*t)},${Math.round(255*i)},${Math.round(255*r)})`}offsetHSL(e,t,i){return this.getHSL(Ft),this.setHSL(Ft.h+e,Ft.s+t,Ft.l+i)}add(e){return this.r+=e.r,this.g+=e.g,this.b+=e.b,this}addColors(e,t){return this.r=e.r+t.r,this.g=e.g+t.g,this.b=e.b+t.b,this}addScalar(e){return this.r+=e,this.g+=e,this.b+=e,this}sub(e){return this.r=Math.max(0,this.r-e.r),this.g=Math.max(0,this.g-e.g),this.b=Math.max(0,this.b-e.b),this}multiply(e){return this.r*=e.r,this.g*=e.g,this.b*=e.b,this}multiplyScalar(e){return this.r*=e,this.g*=e,this.b*=e,this}lerp(e,t){return this.r+=(e.r-this.r)*t,this.g+=(e.g-this.g)*t,this.b+=(e.b-this.b)*t,this}lerpColors(e,t,i){return this.r=e.r+(t.r-e.r)*i,this.g=e.g+(t.g-e.g)*i,this.b=e.b+(t.b-e.b)*i,this}lerpHSL(e,t){this.getHSL(Ft),e.getHSL(Ht);var e=H(Ft.h,Ht.h,t),i=H(Ft.s,Ht.s,t),t=H(Ft.l,Ht.l,t);return this.setHSL(e,i,t),this}setFromVector3(e){return this.r=e.x,this.g=e.y,this.b=e.z,this}applyMatrix3(e){var t=this.r,i=this.g,r=this.b,e=e.elements;return this.r=e[0]*t+e[3]*i+e[6]*r,this.g=e[1]*t+e[4]*i+e[7]*r,this.b=e[2]*t+e[5]*i+e[8]*r,this}equals(e){return e.r===this.r&&e.g===this.g&&e.b===this.b}fromArray(e,t=0){return this.r=e[t],this.g=e[t+1],this.b=e[t+2],this}toArray(e=[],t=0){return e[t]=this.r,e[t+1]=this.g,e[t+2]=this.b,e}fromBufferAttribute(e,t){return this.r=e.getX(t),this.g=e.getY(t),this.b=e.getZ(t),this}toJSON(){return this.getHex()}*[Symbol.iterator](){yield this.r,yield this.g,yield this.b}}let S=new M,Gt=(M.NAMES=Ot,0);class kt extends Je{constructor(){super(),this.isMaterial=!0,Object.defineProperty(this,"id",{value:Gt++}),this.uuid=O(),this.name="",this.type="Material",this.blending=pe,this.side=ue,this.vertexColors=!1,this.opacity=1,this.transparent=!1,this.alphaHash=!1,this.blendSrc=ge,this.blendDst=_e,this.blendEquation=ve,this.blendSrcAlpha=null,this.blendDstAlpha=null,this.blendEquationAlpha=null,this.blendColor=new M(0,0,0),this.blendAlpha=0,this.depthFunc=xe,this.depthTest=!0,this.depthWrite=!0,this.stencilWriteMask=255,this.stencilFunc=ke,this.stencilRef=0,this.stencilFuncMask=255,this.stencilFail=Ge,this.stencilZFail=Ge,this.stencilZPass=Ge,this.stencilWrite=!1,this.clippingPlanes=null,this.clipIntersection=!1,this.clipShadows=!1,this.shadowSide=null,this.colorWrite=!0,this.precision=null,this.polygonOffset=!1,this.polygonOffsetFactor=0,this.polygonOffsetUnits=0,this.dithering=!1,this.alphaToCoverage=!1,this.premultipliedAlpha=!1,this.forceSinglePass=!1,this.visible=!0,this.toneMapped=!0,this.userData={},this.version=0,this.S=Ut()}get alphaTest(){return this.S}set alphaTest(e){0<this.S!=0<e&&this.version++,this.S=e}onBeforeRender(){}onBeforeCompile(){}customProgramCacheKey(){return this.onBeforeCompile.toString()}setValues(e){if(void 0!==e)for(var t in e){var i,r=e[t];void 0===r?console.warn(`THREE.Material: parameter '${t}' has value of undefined.`):void 0===(i=this[t])?console.warn(`THREE.Material: '${t}' is not a property of THREE.${this.type}.`):i&&i.isColor?i.set(r):i&&i.isVector3&&r&&r.isVector3?i.copy(r):this[t]=r}}toJSON(e){var t=void 0===e||"string"==typeof e,i=(t&&(e={textures:{},images:{}}),{metadata:{version:4.6,type:"Material",generator:"Material.toJSON"}});function r(e){var t,i=[];for(t in e){var r=e[t];delete r.metadata,i.push(r)}return i}return i.uuid=this.uuid,i.type=this.type,""!==this.name&&(i.name=this.name),this.color&&this.color.isColor&&(i.color=this.color.getHex()),void 0!==this.roughness&&(i.roughness=this.roughness),void 0!==this.metalness&&(i.metalness=this.metalness),void 0!==this.sheen&&(i.sheen=this.sheen),this.sheenColor&&this.sheenColor.isColor&&(i.sheenColor=this.sheenColor.getHex()),void 0!==this.sheenRoughness&&(i.sheenRoughness=this.sheenRoughness),this.emissive&&this.emissive.isColor&&(i.emissive=this.emissive.getHex()),void 0!==this.emissiveIntensity&&1!==this.emissiveIntensity&&(i.emissiveIntensity=this.emissiveIntensity),this.specular&&this.specular.isColor&&(i.specular=this.specular.getHex()),void 0!==this.specularIntensity&&(i.specularIntensity=this.specularIntensity),this.specularColor&&this.specularColor.isColor&&(i.specularColor=this.specularColor.getHex()),void 0!==this.shininess&&(i.shininess=this.shininess),void 0!==this.clearcoat&&(i.clearcoat=this.clearcoat),void 0!==this.clearcoatRoughness&&(i.clearcoatRoughness=this.clearcoatRoughness),this.clearcoatMap&&this.clearcoatMap.isTexture&&(i.clearcoatMap=this.clearcoatMap.toJSON(e).uuid),this.clearcoatRoughnessMap&&this.clearcoatRoughnessMap.isTexture&&(i.clearcoatRoughnessMap=this.clearcoatRoughnessMap.toJSON(e).uuid),this.clearcoatNormalMap&&this.clearcoatNormalMap.isTexture&&(i.clearcoatNormalMap=this.clearcoatNormalMap.toJSON(e).uuid,i.clearcoatNormalScale=this.clearcoatNormalScale.toArray()),void 0!==this.dispersion&&(i.dispersion=this.dispersion),void 0!==this.iridescence&&(i.iridescence=this.iridescence),void 0!==this.iridescenceIOR&&(i.iridescenceIOR=this.iridescenceIOR),void 0!==this.iridescenceThicknessRange&&(i.iridescenceThicknessRange=this.iridescenceThicknessRange),this.iridescenceMap&&this.iridescenceMap.isTexture&&(i.iridescenceMap=this.iridescenceMap.toJSON(e).uuid),this.iridescenceThicknessMap&&this.iridescenceThicknessMap.isTexture&&(i.iridescenceThicknessMap=this.iridescenceThicknessMap.toJSON(e).uuid),void 0!==this.anisotropy&&(i.anisotropy=this.anisotropy),void 0!==this.anisotropyRotation&&(i.anisotropyRotation=this.anisotropyRotation),this.anisotropyMap&&this.anisotropyMap.isTexture&&(i.anisotropyMap=this.anisotropyMap.toJSON(e).uuid),this.map&&this.map.isTexture&&(i.map=this.map.toJSON(e).uuid),this.matcap&&this.matcap.isTexture&&(i.matcap=this.matcap.toJSON(e).uuid),this.alphaMap&&this.alphaMap.isTexture&&(i.alphaMap=this.alphaMap.toJSON(e).uuid),this.lightMap&&this.lightMap.isTexture&&(i.lightMap=this.lightMap.toJSON(e).uuid,i.lightMapIntensity=this.lightMapIntensity),this.aoMap&&this.aoMap.isTexture&&(i.aoMap=this.aoMap.toJSON(e).uuid,i.aoMapIntensity=this.aoMapIntensity),this.bumpMap&&this.bumpMap.isTexture&&(i.bumpMap=this.bumpMap.toJSON(e).uuid,i.bumpScale=this.bumpScale),this.normalMap&&this.normalMap.isTexture&&(i.normalMap=this.normalMap.toJSON(e).uuid,i.normalMapType=this.normalMapType,i.normalScale=this.normalScale.toArray()),this.displacementMap&&this.displacementMap.isTexture&&(i.displacementMap=this.displacementMap.toJSON(e).uuid,i.displacementScale=this.displacementScale,i.displacementBias=this.displacementBias),this.roughnessMap&&this.roughnessMap.isTexture&&(i.roughnessMap=this.roughnessMap.toJSON(e).uuid),this.metalnessMap&&this.metalnessMap.isTexture&&(i.metalnessMap=this.metalnessMap.toJSON(e).uuid),this.emissiveMap&&this.emissiveMap.isTexture&&(i.emissiveMap=this.emissiveMap.toJSON(e).uuid),this.specularMap&&this.specularMap.isTexture&&(i.specularMap=this.specularMap.toJSON(e).uuid),this.specularIntensityMap&&this.specularIntensityMap.isTexture&&(i.specularIntensityMap=this.specularIntensityMap.toJSON(e).uuid),this.specularColorMap&&this.specularColorMap.isTexture&&(i.specularColorMap=this.specularColorMap.toJSON(e).uuid),this.envMap&&this.envMap.isTexture&&(i.envMap=this.envMap.toJSON(e).uuid,void 0!==this.combine)&&(i.combine=this.combine),void 0!==this.envMapRotation&&(i.envMapRotation=this.envMapRotation.toArray()),void 0!==this.envMapIntensity&&(i.envMapIntensity=this.envMapIntensity),void 0!==this.reflectivity&&(i.reflectivity=this.reflectivity),void 0!==this.refractionRatio&&(i.refractionRatio=this.refractionRatio),this.gradientMap&&this.gradientMap.isTexture&&(i.gradientMap=this.gradientMap.toJSON(e).uuid),void 0!==this.transmission&&(i.transmission=this.transmission),this.transmissionMap&&this.transmissionMap.isTexture&&(i.transmissionMap=this.transmissionMap.toJSON(e).uuid),void 0!==this.thickness&&(i.thickness=this.thickness),this.thicknessMap&&this.thicknessMap.isTexture&&(i.thicknessMap=this.thicknessMap.toJSON(e).uuid),void 0!==this.attenuationDistance&&this.attenuationDistance!==1/0&&(i.attenuationDistance=this.attenuationDistance),void 0!==this.attenuationColor&&(i.attenuationColor=this.attenuationColor.getHex()),void 0!==this.size&&(i.size=this.size),null!==this.shadowSide&&(i.shadowSide=this.shadowSide),void 0!==this.sizeAttenuation&&(i.sizeAttenuation=this.sizeAttenuation),this.blending!==pe&&(i.blending=this.blending),this.side!==ue&&(i.side=this.side),!0===this.vertexColors&&(i.vertexColors=!0),this.opacity<1&&(i.opacity=this.opacity),!0===this.transparent&&(i.transparent=!0),this.blendSrc!==ge&&(i.blendSrc=this.blendSrc),this.blendDst!==_e&&(i.blendDst=this.blendDst),this.blendEquation!==ve&&(i.blendEquation=this.blendEquation),null!==this.blendSrcAlpha&&(i.blendSrcAlpha=this.blendSrcAlpha),null!==this.blendDstAlpha&&(i.blendDstAlpha=this.blendDstAlpha),null!==this.blendEquationAlpha&&(i.blendEquationAlpha=this.blendEquationAlpha),this.blendColor&&this.blendColor.isColor&&(i.blendColor=this.blendColor.getHex()),0!==this.blendAlpha&&(i.blendAlpha=this.blendAlpha),this.depthFunc!==xe&&(i.depthFunc=this.depthFunc),!1===this.depthTest&&(i.depthTest=this.depthTest),!1===this.depthWrite&&(i.depthWrite=this.depthWrite),!1===this.colorWrite&&(i.colorWrite=this.colorWrite),255!==this.stencilWriteMask&&(i.stencilWriteMask=this.stencilWriteMask),this.stencilFunc!==ke&&(i.stencilFunc=this.stencilFunc),0!==this.stencilRef&&(i.stencilRef=this.stencilRef),255!==this.stencilFuncMask&&(i.stencilFuncMask=this.stencilFuncMask),this.stencilFail!==Ge&&(i.stencilFail=this.stencilFail),this.stencilZFail!==Ge&&(i.stencilZFail=this.stencilZFail),this.stencilZPass!==Ge&&(i.stencilZPass=this.stencilZPass),!0===this.stencilWrite&&(i.stencilWrite=this.stencilWrite),void 0!==this.rotation&&0!==this.rotation&&(i.rotation=this.rotation),!0===this.polygonOffset&&(i.polygonOffset=!0),0!==this.polygonOffsetFactor&&(i.polygonOffsetFactor=this.polygonOffsetFactor),0!==this.polygonOffsetUnits&&(i.polygonOffsetUnits=this.polygonOffsetUnits),void 0!==this.linewidth&&1!==this.linewidth&&(i.linewidth=this.linewidth),void 0!==this.dashSize&&(i.dashSize=this.dashSize),void 0!==this.gapSize&&(i.gapSize=this.gapSize),void 0!==this.scale&&(i.scale=this.scale),!0===this.dithering&&(i.dithering=!0),0<this.alphaTest&&(i.alphaTest=this.alphaTest),!0===this.alphaHash&&(i.alphaHash=!0),!0===this.alphaToCoverage&&(i.alphaToCoverage=!0),!0===this.premultipliedAlpha&&(i.premultipliedAlpha=!0),!0===this.forceSinglePass&&(i.forceSinglePass=!0),!0===this.wireframe&&(i.wireframe=!0),1<this.wireframeLinewidth&&(i.wireframeLinewidth=this.wireframeLinewidth),"round"!==this.wireframeLinecap&&(i.wireframeLinecap=this.wireframeLinecap),"round"!==this.wireframeLinejoin&&(i.wireframeLinejoin=this.wireframeLinejoin),!0===this.flatShading&&(i.flatShading=!0),!1===this.visible&&(i.visible=!1),!1===this.toneMapped&&(i.toneMapped=!1),!1===this.fog&&(i.fog=!1),0<Object.keys(this.userData).length&&(i.userData=this.userData),t&&(t=r(e.textures),e=r(e.images),0<t.length&&(i.textures=t),0<e.length)&&(i.images=e),i}clone(){return(new this.constructor).copy(this)}copy(e){this.name=e.name,this.blending=e.blending,this.side=e.side,this.vertexColors=e.vertexColors,this.opacity=e.opacity,this.transparent=e.transparent,this.blendSrc=e.blendSrc,this.blendDst=e.blendDst,this.blendEquation=e.blendEquation,this.blendSrcAlpha=e.blendSrcAlpha,this.blendDstAlpha=e.blendDstAlpha,this.blendEquationAlpha=e.blendEquationAlpha,this.blendColor.copy(e.blendColor),this.blendAlpha=e.blendAlpha,this.depthFunc=e.depthFunc,this.depthTest=e.depthTest,this.depthWrite=e.depthWrite,this.stencilWriteMask=e.stencilWriteMask,this.stencilFunc=e.stencilFunc,this.stencilRef=e.stencilRef,this.stencilFuncMask=e.stencilFuncMask,this.stencilFail=e.stencilFail,this.stencilZFail=e.stencilZFail,this.stencilZPass=e.stencilZPass,this.stencilWrite=e.stencilWrite;var t=e.clippingPlanes;let i=null;if(null!==t){var r=t.length;i=new Array(r);for(let e=0;e!==r;++e)i[e]=t[e].clone()}return this.clippingPlanes=i,this.clipIntersection=e.clipIntersection,this.clipShadows=e.clipShadows,this.shadowSide=e.shadowSide,this.colorWrite=e.colorWrite,this.precision=e.precision,this.polygonOffset=e.polygonOffset,this.polygonOffsetFactor=e.polygonOffsetFactor,this.polygonOffsetUnits=e.polygonOffsetUnits,this.dithering=e.dithering,this.alphaTest=e.alphaTest,this.alphaHash=e.alphaHash,this.alphaToCoverage=e.alphaToCoverage,this.premultipliedAlpha=e.premultipliedAlpha,this.forceSinglePass=e.forceSinglePass,this.visible=e.visible,this.toneMapped=e.toneMapped,this.userData=JSON.parse(JSON.stringify(e.userData)),this}dispose(){this.dispatchEvent({type:"dispose"})}set needsUpdate(e){!0===e&&this.version++}onBuild(){console.warn("Material: onBuild() has been removed.")}}class zt extends kt{constructor(e){super(),this.isMeshBasicMaterial=!0,this.type="MeshBasicMaterial",this.color=new M(16777215),this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.specularMap=null,this.alphaMap=null,this.envMap=null,this.envMapRotation=new $e,this.combine=Me,this.reflectivity=1,this.refractionRatio=.98,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap="round",this.wireframeLinejoin="round",this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.specularMap=e.specularMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.envMapRotation.copy(e.envMapRotation),this.combine=e.combine,this.reflectivity=e.reflectivity,this.refractionRatio=e.refractionRatio,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.fog=e.fog,this}}let w=new N,Bt=new D;class R{constructor(e,t,i=!1){if(Array.isArray(e))throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");this.isBufferAttribute=!0,this.name="",this.array=e,this.itemSize=t,this.count=void 0!==e?e.length/t:0,this.normalized=i,this.usage=ze,this.updateRanges=[],this.gpuType=Te,this.version=0}onUploadCallback(){}set needsUpdate(e){!0===e&&this.version++}setUsage(e){return this.usage=e,this}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}copy(e){return this.name=e.name,this.array=new e.array.constructor(e.array),this.itemSize=e.itemSize,this.count=e.count,this.normalized=e.normalized,this.usage=e.usage,this.gpuType=e.gpuType,this}copyAt(i,r,s){i*=this.itemSize,s*=r.itemSize;for(let e=0,t=this.itemSize;e<t;e++)this.array[i+e]=r.array[s+e];return this}copyArray(e){return this.array.set(e),this}applyMatrix3(i){if(2===this.itemSize)for(let e=0,t=this.count;e<t;e++)Bt.fromBufferAttribute(this,e),Bt.applyMatrix3(i),this.setXY(e,Bt.x,Bt.y);else if(3===this.itemSize)for(let e=0,t=this.count;e<t;e++)w.fromBufferAttribute(this,e),w.applyMatrix3(i),this.setXYZ(e,w.x,w.y,w.z);return this}applyMatrix4(i){for(let e=0,t=this.count;e<t;e++)w.fromBufferAttribute(this,e),w.applyMatrix4(i),this.setXYZ(e,w.x,w.y,w.z);return this}applyNormalMatrix(i){for(let e=0,t=this.count;e<t;e++)w.fromBufferAttribute(this,e),w.applyNormalMatrix(i),this.setXYZ(e,w.x,w.y,w.z);return this}transformDirection(i){for(let e=0,t=this.count;e<t;e++)w.fromBufferAttribute(this,e),w.transformDirection(i),this.setXYZ(e,w.x,w.y,w.z);return this}set(e,t=0){return this.array.set(e,t),this}getComponent(e,t){let i=this.array[e*this.itemSize+t];return i=this.normalized?r(i,this.array):i}setComponent(e,t,i){return this.normalized&&(i=a(i,this.array)),this.array[e*this.itemSize+t]=i,this}getX(e){let t=this.array[e*this.itemSize];return t=this.normalized?r(t,this.array):t}setX(e,t){return this.normalized&&(t=a(t,this.array)),this.array[e*this.itemSize]=t,this}getY(e){let t=this.array[e*this.itemSize+1];return t=this.normalized?r(t,this.array):t}setY(e,t){return this.normalized&&(t=a(t,this.array)),this.array[e*this.itemSize+1]=t,this}getZ(e){let t=this.array[e*this.itemSize+2];return t=this.normalized?r(t,this.array):t}setZ(e,t){return this.normalized&&(t=a(t,this.array)),this.array[e*this.itemSize+2]=t,this}getW(e){let t=this.array[e*this.itemSize+3];return t=this.normalized?r(t,this.array):t}setW(e,t){return this.normalized&&(t=a(t,this.array)),this.array[e*this.itemSize+3]=t,this}setXY(e,t,i){return e*=this.itemSize,this.normalized&&(t=a(t,this.array),i=a(i,this.array)),this.array[e+0]=t,this.array[e+1]=i,this}setXYZ(e,t,i,r){return e*=this.itemSize,this.normalized&&(t=a(t,this.array),i=a(i,this.array),r=a(r,this.array)),this.array[e+0]=t,this.array[e+1]=i,this.array[e+2]=r,this}setXYZW(e,t,i,r,s){return e*=this.itemSize,this.normalized&&(t=a(t,this.array),i=a(i,this.array),r=a(r,this.array),s=a(s,this.array)),this.array[e+0]=t,this.array[e+1]=i,this.array[e+2]=r,this.array[e+3]=s,this}onUpload(e){return this.onUploadCallback=e,this}clone(){return new this.constructor(this.array,this.itemSize).copy(this)}toJSON(){var e={itemSize:this.itemSize,type:this.array.constructor.name,array:Array.from(this.array),normalized:this.normalized};return""!==this.name&&(e.name=this.name),this.usage!==ze&&(e.usage=this.usage),e}}class Wt extends R{constructor(e,t,i){super(new Uint16Array(e),t,i)}}class Yt extends R{constructor(e,t,i){super(new Uint32Array(e),t,i)}}class E extends R{constructor(e,t,i){super(new Float32Array(e),t,i)}}let Xt={BROWSER:0,WX:1},jt=(Object.freeze(Xt),{document:"undefined"!=typeof document?document:{},window:"undefined"!=typeof window?window:{},environment:Xt.BROWSER,XMLHttpRequest:"undefined"!=typeof XMLHttpRequest?XMLHttpRequest:{}});function qt(t){for(let e=t.length-1;0<=e;--e)if(65535<=t[e])return!0;return!1}function Zt(e){return jt.document.createElementNS("http://www.w3.org/1999/xhtml",e)}let Jt=0,y=new _,Kt=new u,Qt=new N,b=new z,$t=new z,C=new N;class L extends Je{constructor(){super(),this.isBufferGeometry=!0,Object.defineProperty(this,"id",{value:Jt++}),this.uuid=O(),this.name="",this.type="BufferGeometry",this.index=null,this.attributes={},this.morphAttributes={},this.morphTargetsRelative=!1,this.groups=[],this.boundingBox=null,this.boundingSphere=null,this.drawRange={start:0,count:1/0},this.userData={}}getIndex(){return this.index}setIndex(e){return Array.isArray(e)?this.index=new(qt(e)?Yt:Wt)(e,1):this.index=e,this}getAttribute(e){return this.attributes[e]}setAttribute(e,t){return this.attributes[e]=t,this}deleteAttribute(e){return delete this.attributes[e],this}hasAttribute(e){return void 0!==this.attributes[e]}addGroup(e,t,i=0){this.groups.push({start:e,count:t,materialIndex:i})}clearGroups(){this.groups=[]}setDrawRange(e,t){this.drawRange.start=e,this.drawRange.count=t}applyMatrix4(e){var t=this.attributes.position,t=(void 0!==t&&(t.applyMatrix4(e),t.needsUpdate=!0),this.attributes.normal),i=(void 0!==t&&(i=(new c).getNormalMatrix(e),t.applyNormalMatrix(i),t.needsUpdate=!0),this.attributes.tangent);return void 0!==i&&(i.transformDirection(e),i.needsUpdate=!0),null!==this.boundingBox&&this.computeBoundingBox(),null!==this.boundingSphere&&this.computeBoundingSphere(),this}applyQuaternion(e){return y.makeRotationFromQuaternion(e),this.applyMatrix4(y),this}rotateX(e){return y.makeRotationX(e),this.applyMatrix4(y),this}rotateY(e){return y.makeRotationY(e),this.applyMatrix4(y),this}rotateZ(e){return y.makeRotationZ(e),this.applyMatrix4(y),this}translate(e,t,i){return y.makeTranslation(e,t,i),this.applyMatrix4(y),this}scale(e,t,i){return y.makeScale(e,t,i),this.applyMatrix4(y),this}lookAt(e){return Kt.lookAt(e),Kt.updateMatrix(),this.applyMatrix4(Kt.matrix),this}center(){return this.computeBoundingBox(),this.boundingBox.getCenter(Qt).negate(),this.translate(Qt.x,Qt.y,Qt.z),this}setFromPoints(i){var r=[];for(let e=0,t=i.length;e<t;e++){var s=i[e];r.push(s.x,s.y,s.z||0)}return this.setAttribute("position",new E(r,3)),this}computeBoundingBox(){null===this.boundingBox&&(this.boundingBox=new z);var e=this.attributes.position,i=this.morphAttributes.position;if(e&&e.isGLBufferAttribute)console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.",this),this.boundingBox.set(new N(-1/0,-1/0,-1/0),new N(1/0,1/0,1/0));else{if(void 0!==e){if(this.boundingBox.setFromBufferAttribute(e),i)for(let e=0,t=i.length;e<t;e++){var r=i[e];b.setFromBufferAttribute(r),this.morphTargetsRelative?(C.addVectors(this.boundingBox.min,b.min),this.boundingBox.expandByPoint(C),C.addVectors(this.boundingBox.max,b.max),this.boundingBox.expandByPoint(C)):(this.boundingBox.expandByPoint(b.min),this.boundingBox.expandByPoint(b.max))}}else this.boundingBox.makeEmpty();(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',this)}}computeBoundingSphere(){null===this.boundingSphere&&(this.boundingSphere=new se);var r=this.attributes.position,s=this.morphAttributes.position;if(r&&r.isGLBufferAttribute)console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.",this),this.boundingSphere.set(new N,1/0);else if(r){var a=this.boundingSphere.center;if(b.setFromBufferAttribute(r),s)for(let e=0,t=s.length;e<t;e++){var n=s[e];$t.setFromBufferAttribute(n),this.morphTargetsRelative?(C.addVectors(b.min,$t.min),b.expandByPoint(C),C.addVectors(b.max,$t.max),b.expandByPoint(C)):(b.expandByPoint($t.min),b.expandByPoint($t.max))}b.getCenter(a);let i=0;for(let e=0,t=r.count;e<t;e++)C.fromBufferAttribute(r,e),i=Math.max(i,a.distanceToSquared(C));if(s)for(let e=0,t=s.length;e<t;e++){var o=s[e],h=this.morphTargetsRelative;for(let e=0,t=o.count;e<t;e++)C.fromBufferAttribute(o,e),h&&(Qt.fromBufferAttribute(r,e),C.add(Qt)),i=Math.max(i,a.distanceToSquared(C))}this.boundingSphere.radius=Math.sqrt(i),isNaN(this.boundingSphere.radius)&&console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',this)}}computeTangents(){var S,w,y,b,E=this.index,e=this.attributes;if(null===E||void 0===e.position||void 0===e.normal||void 0===e.uv)console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");else{let i=e.position,r=e.normal,s=e.uv,a=(!1===this.hasAttribute("tangent")&&this.setAttribute("tangent",new R(new Float32Array(4*i.count),4)),this.getAttribute("tangent")),n=[],o=[];for(let e=0;e<i.count;e++)n[e]=new N,o[e]=new N;let h=new N,l=new N,c=new N,d=new D,u=new D,f=new D,m=new N,p=new N,v=this.groups;for(let e=0,t=(v=0===v.length?[{start:0,count:E.count}]:v).length;e<t;++e){var C=v[e],L=C.start;for(let e=L,t=L+C.count;e<t;e+=3)S=E.getX(e+0),w=E.getX(e+1),y=E.getX(e+2),b=void 0,h.fromBufferAttribute(i,S),l.fromBufferAttribute(i,w),c.fromBufferAttribute(i,y),d.fromBufferAttribute(s,S),u.fromBufferAttribute(s,w),f.fromBufferAttribute(s,y),l.sub(h),c.sub(h),u.sub(d),f.sub(d),b=1/(u.x*f.y-f.x*u.y),isFinite(b)&&(m.copy(l).multiplyScalar(f.y).addScaledVector(c,-u.y).multiplyScalar(b),p.copy(c).multiplyScalar(u.x).addScaledVector(l,-f.x).multiplyScalar(b),n[S].add(m),n[w].add(m),n[y].add(m),o[S].add(p),o[w].add(p),o[y].add(p))}let g=new N,_=new N,x=new N,M=new N;for(let e=0,t=v.length;e<t;++e){var T=v[e],A=T.start;for(let e=A,t=A+T.count;e<t;e+=3)P(E.getX(e+0)),P(E.getX(e+1)),P(E.getX(e+2))}function P(e){x.fromBufferAttribute(r,e),M.copy(x);var t=n[e],t=(g.copy(t),g.sub(x.multiplyScalar(x.dot(t))).normalize(),_.crossVectors(M,t),_.dot(o[e])),t=t<0?-1:1;a.setXYZW(e,g.x,g.y,g.z,t)}}}computeVertexNormals(){var r=this.index,s=this.getAttribute("position");if(void 0!==s){let i=this.getAttribute("normal");if(void 0===i)i=new R(new Float32Array(3*s.count),3),this.setAttribute("normal",i);else for(let e=0,t=i.count;e<t;e++)i.setXYZ(e,0,0,0);var a=new N,n=new N,o=new N,h=new N,l=new N,c=new N,d=new N,u=new N;if(r)for(let e=0,t=r.count;e<t;e+=3){var f=r.getX(e+0),m=r.getX(e+1),p=r.getX(e+2);a.fromBufferAttribute(s,f),n.fromBufferAttribute(s,m),o.fromBufferAttribute(s,p),d.subVectors(o,n),u.subVectors(a,n),d.cross(u),h.fromBufferAttribute(i,f),l.fromBufferAttribute(i,m),c.fromBufferAttribute(i,p),h.add(d),l.add(d),c.add(d),i.setXYZ(f,h.x,h.y,h.z),i.setXYZ(m,l.x,l.y,l.z),i.setXYZ(p,c.x,c.y,c.z)}else for(let e=0,t=s.count;e<t;e+=3)a.fromBufferAttribute(s,e+0),n.fromBufferAttribute(s,e+1),o.fromBufferAttribute(s,e+2),d.subVectors(o,n),u.subVectors(a,n),d.cross(u),i.setXYZ(e+0,d.x,d.y,d.z),i.setXYZ(e+1,d.x,d.y,d.z),i.setXYZ(e+2,d.x,d.y,d.z);this.normalizeNormals(),i.needsUpdate=!0}}normalizeNormals(){var i=this.attributes.normal;for(let e=0,t=i.count;e<t;e++)C.fromBufferAttribute(i,e),C.normalize(),i.setXYZ(e,C.x,C.y,C.z)}toNonIndexed(){function i(i,r){var s=i.array,a=i.itemSize,e=i.normalized,n=new s.constructor(r.length*a);let o=0,h=0;for(let e=0,t=r.length;e<t;e++){o=i.isInterleavedBufferAttribute?r[e]*i.data.stride+i.offset:r[e]*a;for(let e=0;e<a;e++)n[h++]=s[o++]}return new R(n,a,e)}if(null===this.index)return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."),this;var e,r=new L,s=this.index.array,t=this.attributes;for(e in t){var a=i(t[e],s);r.setAttribute(e,a)}var n,o=this.morphAttributes;for(n in o){var h=[],l=o[n];for(let e=0,t=l.length;e<t;e++){var c=i(l[e],s);h.push(c)}r.morphAttributes[n]=h}r.morphTargetsRelative=this.morphTargetsRelative;var d=this.groups;for(let e=0,t=d.length;e<t;e++){var u=d[e];r.addGroup(u.start,u.count,u.materialIndex)}return r}toJSON(){var i={metadata:{version:4.6,type:"BufferGeometry",generator:"BufferGeometry.toJSON"}};if(i.uuid=this.uuid,i.type=this.type,""!==this.name&&(i.name=this.name),0<Object.keys(this.userData).length&&(i.userData=this.userData),void 0!==this.parameters){var e,t=this.parameters;for(e in t)void 0!==t[e]&&(i[e]=t[e])}else{i.data={attributes:{}};var r,s=this.index,a=(null!==s&&(i.data.index={type:s.array.constructor.name,array:Array.prototype.slice.call(s.array)}),this.attributes);for(r in a){var n=a[r];i.data.attributes[r]=n.toJSON(i.data)}var o,h={};let e=!1;for(o in this.morphAttributes){var l=this.morphAttributes[o],c=[];for(let e=0,t=l.length;e<t;e++){var d=l[e];c.push(d.toJSON(i.data))}0<c.length&&(h[o]=c,e=!0)}e&&(i.data.morphAttributes=h,i.data.morphTargetsRelative=this.morphTargetsRelative);s=this.groups,s=(0<s.length&&(i.data.groups=JSON.parse(JSON.stringify(s))),this.boundingSphere);null!==s&&(i.data.boundingSphere={center:s.center.toArray(),radius:s.radius})}return i}clone(){return(new this.constructor).copy(this)}copy(e){this.index=null,this.attributes={},this.morphAttributes={},this.groups=[],this.boundingBox=null,this.boundingSphere=null;var t,i={},r=(this.name=e.name,e.index),s=(null!==r&&this.setIndex(r.clone(i)),e.attributes);for(t in s){var a=s[t];this.setAttribute(t,a.clone(i))}var n,o=e.morphAttributes;for(n in o){var h=[],l=o[n];for(let e=0,t=l.length;e<t;e++)h.push(l[e].clone(i));this.morphAttributes[n]=h}this.morphTargetsRelative=e.morphTargetsRelative;var c=e.groups;for(let e=0,t=c.length;e<t;e++){var d=c[e];this.addGroup(d.start,d.count,d.materialIndex)}r=e.boundingBox,null!==r&&(this.boundingBox=r.clone()),r=e.boundingSphere;return null!==r&&(this.boundingSphere=r.clone()),this.drawRange.start=e.drawRange.start,this.drawRange.count=e.drawRange.count,this.userData=e.userData,this}dispose(){this.dispatchEvent({type:"dispose"})}}let ei=new _,ti=new de,ii=new se,ri=new N,si=new N,ai=new N,ni=new N,oi=new N,hi=new N,li=new N,ci=new N;class di extends u{constructor(e=new L,t=new zt){super(),this.isMesh=!0,this.type="Mesh",this.geometry=e,this.material=t,this.updateMorphTargets()}copy(e,t){return super.copy(e,t),void 0!==e.morphTargetInfluences&&(this.morphTargetInfluences=e.morphTargetInfluences.slice()),void 0!==e.morphTargetDictionary&&(this.morphTargetDictionary=Object.assign({},e.morphTargetDictionary)),this.material=Array.isArray(e.material)?e.material.slice():e.material,this.geometry=e.geometry,this}updateMorphTargets(){var e=this.geometry.morphAttributes,t=Object.keys(e);if(0<t.length){var i=e[t[0]];if(void 0!==i){this.morphTargetInfluences=[],this.morphTargetDictionary={};for(let e=0,t=i.length;e<t;e++){var r=i[e].name||String(e);this.morphTargetInfluences.push(0),this.morphTargetDictionary[r]=e}}}}getVertexPosition(i,r){var e=this.geometry,t=e.attributes.position,s=e.morphAttributes.position,a=e.morphTargetsRelative,n=(r.fromBufferAttribute(t,i),this.morphTargetInfluences);if(s&&n){hi.set(0,0,0);for(let e=0,t=s.length;e<t;e++){var o=n[e],h=s[e];0!==o&&(oi.fromBufferAttribute(h,i),a?hi.addScaledVector(oi,o):hi.addScaledVector(oi.sub(r),o))}r.add(hi)}return r}raycast(e,t){var i=this.geometry,r=this.material,s=this.matrixWorld;if(void 0!==r){if(null===i.boundingSphere&&i.computeBoundingSphere(),ii.copy(i.boundingSphere),ii.applyMatrix4(s),ti.copy(e.ray).recast(e.near),!1===ii.containsPoint(ti.origin)){if(null===ti.intersectSphere(ii,ri))return;if(ti.origin.distanceToSquared(ri)>(e.far-e.near)**2)return}ei.copy(s).invert(),ti.copy(e.ray).applyMatrix4(ei),null!==i.boundingBox&&!1===ti.intersectsBox(i.boundingBox)||this.C(e,t,ti)}}C(i,r,s){let a;var e=this.geometry,n=this.material,o=e.index,h=e.attributes.position,l=e.attributes.uv,c=e.attributes.uv1,d=e.attributes.normal,u=e.groups,f=e.drawRange;if(null!==o)if(Array.isArray(n))for(let e=0,t=u.length;e<t;e++){var m=u[e],p=n[m.materialIndex];for(let e=Math.max(m.start,f.start),t=Math.min(o.count,Math.min(m.start+m.count,f.start+f.count));e<t;e+=3){var v=o.getX(e),g=o.getX(e+1),_=o.getX(e+2);(a=fi(this,p,i,s,l,c,d,v,g,_))&&(a.faceIndex=Math.floor(e/3),a.face.materialIndex=m.materialIndex,r.push(a))}}else for(let e=Math.max(0,f.start),t=Math.min(o.count,f.start+f.count);e<t;e+=3){var x=o.getX(e),M=o.getX(e+1),S=o.getX(e+2);(a=fi(this,n,i,s,l,c,d,x,M,S))&&(a.faceIndex=Math.floor(e/3),r.push(a))}else if(void 0!==h)if(Array.isArray(n))for(let e=0,t=u.length;e<t;e++){var w=u[e],y=n[w.materialIndex];for(let e=Math.max(w.start,f.start),t=Math.min(h.count,Math.min(w.start+w.count,f.start+f.count));e<t;e+=3){var b=e,E=e+1,C=e+2;(a=fi(this,y,i,s,l,c,d,b,E,C))&&(a.faceIndex=Math.floor(e/3),a.face.materialIndex=w.materialIndex,r.push(a))}}else for(let e=Math.max(0,f.start),t=Math.min(h.count,f.start+f.count);e<t;e+=3){var L=e,T=e+1,A=e+2;(a=fi(this,n,i,s,l,c,d,L,T,A))&&(a.faceIndex=Math.floor(e/3),r.push(a))}}}function ui(e,t,i,r,s,a,n,o){let h;if(null===(h=t.side===fe?r.intersectTriangle(n,a,s,!0,o):r.intersectTriangle(s,a,n,t.side===ue,o)))return null;ci.copy(o),ci.applyMatrix4(e.matrixWorld);r=i.ray.origin.distanceTo(ci);return r<i.near||r>i.far?null:{distance:r,point:ci.clone(),object:e}}function fi(e,t,i,r,s,a,n,o,h,l){e.getVertexPosition(o,si),e.getVertexPosition(h,ai),e.getVertexPosition(l,ni);e=ui(e,t,i,r,si,ai,ni,li);return e&&(t=new N,g.getBarycoord(li,si,ai,ni,t),s&&(e.uv=g.getInterpolatedAttribute(s,o,h,l,t,new D)),a&&(e.uv1=g.getInterpolatedAttribute(a,o,h,l,t,new D)),n&&(e.normal=g.getInterpolatedAttribute(n,o,h,l,t,new N),0<e.normal.dot(r.direction))&&e.normal.multiplyScalar(-1),i={a:o,b:h,c:l,normal:new N,materialIndex:0},g.getNormal(si,ai,ni,i.normal),e.face=i,e.barycoord=t),e}class e{constructor(){this.type="Curve",this.arcLengthDivisions=200}getPoint(){return console.warn("THREE.Curve: .getPoint() not implemented."),null}getPointAt(e,t){e=this.getUtoTmapping(e);return this.getPoint(e,t)}getPoints(t=5){var i=[];for(let e=0;e<=t;e++)i.push(this.getPoint(e/t));return i}getSpacedPoints(t=5){var i=[];for(let e=0;e<=t;e++)i.push(this.getPointAt(e/t));return i}getLength(){var e=this.getLengths();return e[e.length-1]}getLengths(t=this.arcLengthDivisions){if(this.cacheArcLengths&&this.cacheArcLengths.length===t+1&&!this.needsUpdate)return this.cacheArcLengths;this.needsUpdate=!1;var i=[];let r,s=this.getPoint(0),a=0;i.push(0);for(let e=1;e<=t;e++)r=this.getPoint(e/t),a+=r.distanceTo(s),i.push(a),s=r;return this.cacheArcLengths=i}updateArcLengths(){this.needsUpdate=!0,this.getLengths()}getUtoTmapping(e,t){var i=this.getLengths();let r=0;var s=i.length;let a,n=(a=t||e*i[s-1],0),o=s-1,h;for(;n<=o;)if((h=i[r=Math.floor(n+(o-n)/2)]-a)<0)n=r+1;else{if(!(0<h)){o=r;break}o=r-1}return i[r=o]===a?r/(s-1):(t=i[r],e=i[r+1],e=(a-t)/(e-t),(r+e)/(s-1))}getTangent(e,t){let i=e-1e-4,r=e+1e-4;i<0&&(i=0),1<r&&(r=1);var e=this.getPoint(i),s=this.getPoint(r),t=t||new(e.isVector2?D:N);return t.copy(s).sub(e).normalize(),t}getTangentAt(e,t){e=this.getUtoTmapping(e);return this.getTangent(e,t)}computeFrenetFrames(i,e){var t=new N,r=[],s=[],a=[],n=new N,o=new _;for(let e=0;e<=i;e++){var h=e/i;r[e]=this.getTangentAt(h,new N)}s[0]=new N,a[0]=new N;let l=Number.MAX_VALUE;var c,d=Math.abs(r[0].x),u=Math.abs(r[0].y),f=Math.abs(r[0].z);d<=l&&(l=d,t.set(1,0,0)),u<=l&&(l=u,t.set(0,1,0)),f<=l&&t.set(0,0,1),n.crossVectors(r[0],t).normalize(),s[0].crossVectors(r[0],n),a[0].crossVectors(r[0],s[0]);for(let e=1;e<=i;e++)s[e]=s[e-1].clone(),a[e]=a[e-1].clone(),n.crossVectors(r[e-1],r[e]),n.length()>Number.EPSILON&&(n.normalize(),c=Math.acos(v(r[e-1].dot(r[e]),-1,1)),s[e].applyMatrix4(o.makeRotationAxis(n,c))),a[e].crossVectors(r[e],s[e]);if(!0===e){let t=Math.acos(v(s[0].dot(s[i]),-1,1));t/=i,0<r[0].dot(n.crossVectors(s[0],s[i]))&&(t=-t);for(let e=1;e<=i;e++)s[e].applyMatrix4(o.makeRotationAxis(r[e],t*e)),a[e].crossVectors(r[e],s[e])}return{tangents:r,normals:s,binormals:a}}clone(){return(new this.constructor).copy(this)}copy(e){return this.arcLengthDivisions=e.arcLengthDivisions,this}toJSON(){var e={metadata:{version:4.6,type:"Curve",generator:"Curve.toJSON"}};return e.arcLengthDivisions=this.arcLengthDivisions,e.type=this.type,e}fromJSON(e){return this.arcLengthDivisions=e.arcLengthDivisions,this}}var mi=Object.freeze({__proto__:null,Curve:e});class pi extends e{constructor(e=new N,t=new N){super(),this.isLineCurve3=!0,this.type="LineCurve3",this.v1=e,this.v2=t}getPoint(e,t=new N){return 1===e?t.copy(this.v2):(t.copy(this.v2).sub(this.v1),t.multiplyScalar(e).add(this.v1)),t}getPointAt(e,t){return this.getPoint(e,t)}getTangent(e,t=new N){return t.subVectors(this.v2,this.v1).normalize()}getTangentAt(e,t){return this.getTangent(e,t)}copy(e){return super.copy(e),this.v1.copy(e.v1),this.v2.copy(e.v2),this}toJSON(){var e=super.toJSON();return e.v1=this.v1.toArray(),e.v2=this.v2.toArray(),e}fromJSON(e){return super.fromJSON(e),this.v1.fromArray(e.v1),this.v2.fromArray(e.v2),this}}class vi extends e{constructor(e=0,t=0,i=1,r=1,s=0,a=2*Math.PI,n=!1,o=0){super(),this.isEllipseCurve=!0,this.type="EllipseCurve",this.aX=e,this.aY=t,this.xRadius=i,this.yRadius=r,this.aStartAngle=s,this.aEndAngle=a,this.aClockwise=n,this.aRotation=o}getPoint(e,t=new D){var i=2*Math.PI;let r=this.aEndAngle-this.aStartAngle;for(var s=Math.abs(r)<Number.EPSILON;r<0;)r+=i;for(;r>i;)r-=i;r<Number.EPSILON&&(r=s?0:i),!0!==this.aClockwise||s||(r===i?r=-i:r-=i);var a,n,s=this.aStartAngle+e*r;let o=this.aX+this.xRadius*Math.cos(s),h=this.aY+this.yRadius*Math.sin(s);return 0!==this.aRotation&&(e=Math.cos(this.aRotation),s=Math.sin(this.aRotation),a=o-this.aX,n=h-this.aY,o=a*e-n*s+this.aX,h=a*s+n*e+this.aY),t.set(o,h)}copy(e){return super.copy(e),this.aX=e.aX,this.aY=e.aY,this.xRadius=e.xRadius,this.yRadius=e.yRadius,this.aStartAngle=e.aStartAngle,this.aEndAngle=e.aEndAngle,this.aClockwise=e.aClockwise,this.aRotation=e.aRotation,this}toJSON(){var e=super.toJSON();return e.aX=this.aX,e.aY=this.aY,e.xRadius=this.xRadius,e.yRadius=this.yRadius,e.aStartAngle=this.aStartAngle,e.aEndAngle=this.aEndAngle,e.aClockwise=this.aClockwise,e.aRotation=this.aRotation,e}fromJSON(e){return super.fromJSON(e),this.aX=e.aX,this.aY=e.aY,this.xRadius=e.xRadius,this.yRadius=e.yRadius,this.aStartAngle=e.aStartAngle,this.aEndAngle=e.aEndAngle,this.aClockwise=e.aClockwise,this.aRotation=e.aRotation,this}}class gi extends vi{constructor(e,t,i,r,s,a){super(e,t,i,i,r,s,a),this.isArcCurve=!0,this.type="ArcCurve"}}function _i(){let s=0,a=0,n=0,o=0;function h(e,t,i,r){s=e,a=i,n=-3*e+3*t-2*i-r,o=2*e-2*t+i+r}return{initCatmullRom:function(e,t,i,r,s){h(t,i,s*(i-e),s*(r-t))},initNonuniformCatmullRom:function(e,t,i,r,s,a,n){e=(t-e)/s-(i-e)/(s+a)+(i-t)/a,s=(i-t)/a-(r-t)/(a+n)+(r-i)/n;h(t,i,e*=a,s*=a)},calc:function(e){var t=e*e,i=t*e;return s+a*e+n*t+o*i}}}let xi=new N,Mi=new _i,Si=new _i,wi=new _i;class yi extends e{constructor(e=[],t=!1,i="centripetal",r=.5){super(),this.isCatmullRomCurve3=!0,this.type="CatmullRomCurve3",this.points=e,this.closed=t,this.curveType=i,this.tension=r}getPoint(r,e=new N){var s=this.points,t=s.length,r=(t-(this.closed?0:1))*r;let i=Math.floor(r),a=r-i;this.closed?i+=0<i?0:(Math.floor(Math.abs(i)/t)+1)*t:0===a&&i===t-1&&(i=t-2,a=1);let n,o;n=this.closed||0<i?s[(i-1)%t]:(xi.subVectors(s[0],s[1]).add(s[0]),xi);var r=s[i%t],h=s[(i+1)%t];if(o=this.closed||i+2<t?s[(i+2)%t]:(xi.subVectors(s[t-1],s[t-2]).add(s[t-1]),xi),"centripetal"===this.curveType||"chordal"===this.curveType){s="chordal"===this.curveType?.5:.25;let e=Math.pow(n.distanceToSquared(r),s),t=Math.pow(r.distanceToSquared(h),s),i=Math.pow(h.distanceToSquared(o),s);t<1e-4&&(t=1),e<1e-4&&(e=t),i<1e-4&&(i=t),Mi.initNonuniformCatmullRom(n.x,r.x,h.x,o.x,e,t,i),Si.initNonuniformCatmullRom(n.y,r.y,h.y,o.y,e,t,i),wi.initNonuniformCatmullRom(n.z,r.z,h.z,o.z,e,t,i)}else"catmullrom"===this.curveType&&(Mi.initCatmullRom(n.x,r.x,h.x,o.x,this.tension),Si.initCatmullRom(n.y,r.y,h.y,o.y,this.tension),wi.initCatmullRom(n.z,r.z,h.z,o.z,this.tension));return e.set(Mi.calc(a),Si.calc(a),wi.calc(a)),e}copy(i){super.copy(i),this.points=[];for(let e=0,t=i.points.length;e<t;e++){var r=i.points[e];this.points.push(r.clone())}return this.closed=i.closed,this.curveType=i.curveType,this.tension=i.tension,this}toJSON(){var i=super.toJSON();i.points=[];for(let e=0,t=this.points.length;e<t;e++){var r=this.points[e];i.points.push(r.toArray())}return i.closed=this.closed,i.curveType=this.curveType,i.tension=this.tension,i}fromJSON(i){super.fromJSON(i),this.points=[];for(let e=0,t=i.points.length;e<t;e++){var r=i.points[e];this.points.push((new N).fromArray(r))}return this.closed=i.closed,this.curveType=i.curveType,this.tension=i.tension,this}}function bi(e,t,i,r,s){var t=.5*(r-t),s=.5*(s-i),a=e*e;return(2*i-2*r+t+s)*(e*a)+(-3*i+3*r-2*t-s)*a+t*e+i}function Ei(e,t){e=1-e;return e*e*t}function Ci(e,t){return 2*(1-e)*e*t}function Li(e,t){return e*e*t}function Ti(e,t,i,r){return Ei(e,t)+Ci(e,i)+Li(e,r)}function Ai(e,t){e=1-e;return e*e*e*t}function Pi(e,t){var i=1-e;return 3*i*i*e*t}function Ni(e,t){return 3*(1-e)*e*e*t}function Di(e,t){return e*e*e*t}function Ri(e,t,i,r,s){return Ai(e,t)+Pi(e,i)+Ni(e,r)+Di(e,s)}class Ii extends e{constructor(e=new D,t=new D,i=new D,r=new D){super(),this.isCubicBezierCurve=!0,this.type="CubicBezierCurve",this.v0=e,this.v1=t,this.v2=i,this.v3=r}getPoint(e,t=new D){var i=this.v0,r=this.v1,s=this.v2,a=this.v3;return t.set(Ri(e,i.x,r.x,s.x,a.x),Ri(e,i.y,r.y,s.y,a.y)),t}copy(e){return super.copy(e),this.v0.copy(e.v0),this.v1.copy(e.v1),this.v2.copy(e.v2),this.v3.copy(e.v3),this}toJSON(){var e=super.toJSON();return e.v0=this.v0.toArray(),e.v1=this.v1.toArray(),e.v2=this.v2.toArray(),e.v3=this.v3.toArray(),e}fromJSON(e){return super.fromJSON(e),this.v0.fromArray(e.v0),this.v1.fromArray(e.v1),this.v2.fromArray(e.v2),this.v3.fromArray(e.v3),this}}class Ui extends e{constructor(e=new N,t=new N,i=new N,r=new N){super(),this.isCubicBezierCurve3=!0,this.type="CubicBezierCurve3",this.v0=e,this.v1=t,this.v2=i,this.v3=r}getPoint(e,t=new N){var i=this.v0,r=this.v1,s=this.v2,a=this.v3;return t.set(Ri(e,i.x,r.x,s.x,a.x),Ri(e,i.y,r.y,s.y,a.y),Ri(e,i.z,r.z,s.z,a.z)),t}copy(e){return super.copy(e),this.v0.copy(e.v0),this.v1.copy(e.v1),this.v2.copy(e.v2),this.v3.copy(e.v3),this}toJSON(){var e=super.toJSON();return e.v0=this.v0.toArray(),e.v1=this.v1.toArray(),e.v2=this.v2.toArray(),e.v3=this.v3.toArray(),e}fromJSON(e){return super.fromJSON(e),this.v0.fromArray(e.v0),this.v1.fromArray(e.v1),this.v2.fromArray(e.v2),this.v3.fromArray(e.v3),this}}class Oi extends e{constructor(e=new D,t=new D){super(),this.isLineCurve=!0,this.type="LineCurve",this.v1=e,this.v2=t}getPoint(e,t=new D){return 1===e?t.copy(this.v2):(t.copy(this.v2).sub(this.v1),t.multiplyScalar(e).add(this.v1)),t}getPointAt(e,t){return this.getPoint(e,t)}getTangent(e,t=new D){return t.subVectors(this.v2,this.v1).normalize()}getTangentAt(e,t){return this.getTangent(e,t)}copy(e){return super.copy(e),this.v1.copy(e.v1),this.v2.copy(e.v2),this}toJSON(){var e=super.toJSON();return e.v1=this.v1.toArray(),e.v2=this.v2.toArray(),e}fromJSON(e){return super.fromJSON(e),this.v1.fromArray(e.v1),this.v2.fromArray(e.v2),this}}class Fi extends e{constructor(e=new D,t=new D,i=new D){super(),this.isQuadraticBezierCurve=!0,this.type="QuadraticBezierCurve",this.v0=e,this.v1=t,this.v2=i}getPoint(e,t=new D){var i=this.v0,r=this.v1,s=this.v2;return t.set(Ti(e,i.x,r.x,s.x),Ti(e,i.y,r.y,s.y)),t}copy(e){return super.copy(e),this.v0.copy(e.v0),this.v1.copy(e.v1),this.v2.copy(e.v2),this}toJSON(){var e=super.toJSON();return e.v0=this.v0.toArray(),e.v1=this.v1.toArray(),e.v2=this.v2.toArray(),e}fromJSON(e){return super.fromJSON(e),this.v0.fromArray(e.v0),this.v1.fromArray(e.v1),this.v2.fromArray(e.v2),this}}class Hi extends e{constructor(e=new N,t=new N,i=new N){super(),this.isQuadraticBezierCurve3=!0,this.type="QuadraticBezierCurve3",this.v0=e,this.v1=t,this.v2=i}getPoint(e,t=new N){var i=this.v0,r=this.v1,s=this.v2;return t.set(Ti(e,i.x,r.x,s.x),Ti(e,i.y,r.y,s.y),Ti(e,i.z,r.z,s.z)),t}copy(e){return super.copy(e),this.v0.copy(e.v0),this.v1.copy(e.v1),this.v2.copy(e.v2),this}toJSON(){var e=super.toJSON();return e.v0=this.v0.toArray(),e.v1=this.v1.toArray(),e.v2=this.v2.toArray(),e}fromJSON(e){return super.fromJSON(e),this.v0.fromArray(e.v0),this.v1.fromArray(e.v1),this.v2.fromArray(e.v2),this}}class Vi extends e{constructor(e=[]){super(),this.isSplineCurve=!0,this.type="SplineCurve",this.points=e}getPoint(e,t=new D){var i=this.points,e=(i.length-1)*e,r=Math.floor(e),e=e-r,s=i[0===r?r:r-1],a=i[r],n=i[r>i.length-2?i.length-1:r+1],i=i[r>i.length-3?i.length-1:r+2];return t.set(bi(e,s.x,a.x,n.x,i.x),bi(e,s.y,a.y,n.y,i.y)),t}copy(i){super.copy(i),this.points=[];for(let e=0,t=i.points.length;e<t;e++){var r=i.points[e];this.points.push(r.clone())}return this}toJSON(){var i=super.toJSON();i.points=[];for(let e=0,t=this.points.length;e<t;e++){var r=this.points[e];i.points.push(r.toArray())}return i}fromJSON(i){super.fromJSON(i),this.points=[];for(let e=0,t=i.points.length;e<t;e++){var r=i.points[e];this.points.push((new D).fromArray(r))}return this}}var Gi=Object.freeze({__proto__:null,ArcCurve:gi,CatmullRomCurve3:yi,CubicBezierCurve:Ii,CubicBezierCurve3:Ui,EllipseCurve:vi,LineCurve:Oi,LineCurve3:pi,QuadraticBezierCurve:Fi,QuadraticBezierCurve3:Hi,SplineCurve:Vi});class ki extends e{constructor(){super(),this.type="CurvePath",this.curves=[],this.autoClose=!1}add(e){this.curves.push(e)}closePath(){var e,t=this.curves[0].getPoint(0),i=this.curves[this.curves.length-1].getPoint(1);return t.equals(i)||(e=!0===t.isVector2?"LineCurve":"LineCurve3",this.curves.push(new Gi[e](i,t))),this}getPoint(e,t){var i,r,s,a=e*this.getLength(),n=this.getCurveLengths();let o=0;for(;o<n.length;){if(n[o]>=a)return i=n[o]-a,s=(r=this.curves[o]).getLength(),r.getPointAt(0===s?0:1-i/s,t);o++}return null}getLength(){var e=this.getCurveLengths();return e[e.length-1]}updateArcLengths(){this.needsUpdate=!0,this.cacheLengths=null,this.getCurveLengths()}getCurveLengths(){if(this.cacheLengths&&this.cacheLengths.length===this.curves.length)return this.cacheLengths;var i=[];let r=0;for(let e=0,t=this.curves.length;e<t;e++)r+=this.curves[e].getLength(),i.push(r);return this.cacheLengths=i}getSpacedPoints(t=40){var i=[];for(let e=0;e<=t;e++)i.push(this.getPoint(e/t));return this.autoClose&&i.push(i[0]),i}getPoints(i=12){var r=[];let s;for(let e=0,t=this.curves;e<t.length;e++){var a=t[e],n=a.isEllipseCurve?2*i:a.isLineCurve||a.isLineCurve3?1:a.isSplineCurve?i*a.points.length:i,o=a.getPoints(n);for(let e=0;e<o.length;e++){var h=o[e];s&&s.equals(h)||(r.push(h),s=h)}}return this.autoClose&&1<r.length&&!r[r.length-1].equals(r[0])&&r.push(r[0]),r}copy(i){super.copy(i),this.curves=[];for(let e=0,t=i.curves.length;e<t;e++){var r=i.curves[e];this.curves.push(r.clone())}return this.autoClose=i.autoClose,this}toJSON(){var i=super.toJSON();i.autoClose=this.autoClose,i.curves=[];for(let e=0,t=this.curves.length;e<t;e++){var r=this.curves[e];i.curves.push(r.toJSON())}return i}fromJSON(i){super.fromJSON(i),this.autoClose=i.autoClose,this.curves=[];for(let e=0,t=i.curves.length;e<t;e++){var r=i.curves[e];this.curves.push((new Gi[r.type]).fromJSON(r))}return this}}class zi extends L{constructor(a=new Hi(new N(-1,-1,0),new N(-1,1,0),new N(1,1,0)),n=64,o=1,h=8,e=!1){super(),this.type="TubeGeometry",this.parameters={path:a,tubularSegments:n,radius:o,radialSegments:h,closed:e};let l=a.computeFrenetFrames(n,e),c=(this.tangents=l.tangents,this.normals=l.normals,this.binormals=l.binormals,new N),d=new N,i=new D,u=new N,f=[],m=[],r=[],s=[];for(let e=0;e<n;e++)t(e);t(!1===e?n:0);for(let t=0;t<=n;t++)for(let e=0;e<=h;e++)i.x=t/n,i.y=e/h,r.push(i.x,i.y);for(let t=1;t<=n;t++)for(let e=1;e<=h;e++){var p=(h+1)*(t-1)+(e-1),v=(h+1)*t+(e-1),g=(h+1)*t+e,_=(h+1)*(t-1)+e;s.push(p,v,_),s.push(v,g,_)}function t(e){u=a.getPointAt(e/n,u);var t=l.normals[e],i=l.binormals[e];for(let e=0;e<=h;e++){var r=e/h*Math.PI*2,s=Math.sin(r),r=-Math.cos(r);d.x=r*t.x+s*i.x,d.y=r*t.y+s*i.y,d.z=r*t.z+s*i.z,d.normalize(),m.push(d.x,d.y,d.z),c.x=u.x+o*d.x,c.y=u.y+o*d.y,c.z=u.z+o*d.z,f.push(c.x,c.y,c.z)}}this.setIndex(s),this.setAttribute("position",new E(f,3)),this.setAttribute("normal",new E(m,3)),this.setAttribute("uv",new E(r,2))}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}toJSON(){var e=super.toJSON();return e.path=this.parameters.path.toJSON(),e}static fromJSON(e){return new zi((new Gi[e.path.type]).fromJSON(e.path),e.tubularSegments,e.radius,e.radialSegments,e.closed)}}function Bi(e){var t,i={};for(t in e)for(var r in i[t]={},e[t]){var s=e[t][r];s&&(s.isColor||s.isMatrix3||s.isMatrix4||s.isVector2||s.isVector3||s.isVector4||s.isTexture||s.isQuaternion)?s.isRenderTargetTexture?(console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."),i[t][r]=null):i[t][r]=s.clone():Array.isArray(s)?i[t][r]=s.slice():i[t][r]=s}return i}function Wi(t){var i=[];for(let e=0;e<t.length;e++)i.push(t[e].clone());return i}var Yi=`
void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}
`,Xi=`
void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}
`;class ji extends kt{constructor(e){super(),this.isShaderMaterial=!0,this.type="ShaderMaterial",this.defines={},this.uniforms={},this.uniformsGroups=[],this.vertexShader=Yi,this.fragmentShader=Xi,this.linewidth=1,this.wireframe=!1,this.wireframeLinewidth=1,this.fog=!1,this.lights=!1,this.clipping=!1,this.forceSinglePass=!0,this.extensions={clipCullDistance:!1,multiDraw:!1},this.defaultAttributeValues={color:[1,1,1],uv:[0,0],uv1:[0,0]},this.index0AttributeName=void 0,this.uniformsNeedUpdate=!1,this.glslVersion=null,void 0!==e&&this.setValues(e)}copy(e){return super.copy(e),this.fragmentShader=e.fragmentShader,this.vertexShader=e.vertexShader,this.uniforms=Bi(e.uniforms),this.uniformsGroups=Wi(e.uniformsGroups),this.defines=Object.assign({},e.defines),this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.fog=e.fog,this.lights=e.lights,this.clipping=e.clipping,this.extensions=Object.assign({},e.extensions),this.glslVersion=e.glslVersion,this}toJSON(e){var t,i=super.toJSON(e);for(t in i.glslVersion=this.glslVersion,i.uniforms={},this.uniforms){var r=this.uniforms[t].value;r&&r.isTexture?i.uniforms[t]={type:"t",value:r.toJSON(e).uuid}:r&&r.isColor?i.uniforms[t]={type:"c",value:r.getHex()}:r&&r.isVector2?i.uniforms[t]={type:"v2",value:r.toArray()}:r&&r.isVector3?i.uniforms[t]={type:"v3",value:r.toArray()}:r&&r.isVector4?i.uniforms[t]={type:"v4",value:r.toArray()}:r&&r.isMatrix3?i.uniforms[t]={type:"m3",value:r.toArray()}:r&&r.isMatrix4?i.uniforms[t]={type:"m4",value:r.toArray()}:i.uniforms[t]={value:r}}0<Object.keys(this.defines).length&&(i.defines=this.defines),i.vertexShader=this.vertexShader,i.fragmentShader=this.fragmentShader,i.lights=this.lights,i.clipping=this.clipping;var s,a={};for(s in this.extensions)!0===this.extensions[s]&&(a[s]=!0);return 0<Object.keys(a).length&&(i.extensions=a),i}}let qi;class Zi{static getDataURL(e){if(/^data:/i.test(e.src))return e.src;if("undefined"==typeof HTMLCanvasElement)return e.src;let t;var i;return 2048<(t=e instanceof HTMLCanvasElement?e:((qi=void 0===qi?Zt("canvas"):qi).width=e.width,qi.height=e.height,i=qi.getContext("2d"),e instanceof ImageData?i.putImageData(e,0,0):i.drawImage(e,0,0,e.width,e.height),qi)).width||2048<t.height?(console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons",e),t.toDataURL("image/jpeg",.6)):t.toDataURL("image/png")}static sRGBToLinear(e){if("undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap){var t=Zt("canvas"),i=(t.width=e.width,t.height=e.height,t.getContext("2d")),r=(i.drawImage(e,0,0,e.width,e.height),i.getImageData(0,0,e.width,e.height)),s=r.data;for(let e=0;e<s.length;e++)s[e]=255*Nt(s[e]/255);return i.putImageData(r,0,0),t}if(e.data){var a=e.data.slice(0);for(let e=0;e<a.length;e++)a instanceof Uint8Array||a instanceof Uint8ClampedArray?a[e]=Math.floor(255*Nt(a[e]/255)):a[e]=Nt(a[e]);return{data:a,width:e.width,height:e.height}}return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."),e}}let Ji=0;class Ki{constructor(e=null){this.isSource=!0,Object.defineProperty(this,"id",{value:Ji++}),this.uuid=O(),this.data=e,this.dataReady=!0,this.version=0}set needsUpdate(e){!0===e&&this.version++}toJSON(e){var t=void 0===e||"string"==typeof e;if(!t&&void 0!==e.images[this.uuid])return e.images[this.uuid];var r={uuid:this.uuid,url:""},s=this.data;if(null!==s){let i;if(Array.isArray(s)){i=[];for(let e=0,t=s.length;e<t;e++)s[e].isDataTexture?i.push(Qi(s[e].image)):i.push(Qi(s[e]))}else i=Qi(s);r.url=i}return t||(e.images[this.uuid]=r),r}}function Qi(e){return"undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap?Zi.getDataURL(e):e.data?{data:Array.from(e.data),width:e.width,height:e.height,type:e.data.constructor.name}:(console.warn("THREE.Texture: Unable to serialize Texture."),{})}let $i=0;class er extends Je{constructor(e=er.DEFAULT_IMAGE,t=er.DEFAULT_MAPPING,i=ye,r=ye,s=Ee,a=Ce,n=Ae,o=Le,h=er.DEFAULT_ANISOTROPY,l=Ne){super(),this.isTexture=!0,Object.defineProperty(this,"id",{value:$i++}),this.uuid=O(),this.name="",this.source=new Ki(e),this.mipmaps=[],this.mapping=t,this.channel=0,this.wrapS=i,this.wrapT=r,this.magFilter=s,this.minFilter=a,this.anisotropy=h,this.format=n,this.internalFormat=null,this.type=o,this.offset=new D(0,0),this.repeat=new D(1,1),this.center=new D(0,0),this.rotation=0,this.matrixAutoUpdate=!0,this.matrix=new c,this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,this.colorSpace=l,this.userData={},this.version=0,this.onUpdate=null,this.isRenderTargetTexture=!1,this.pmremVersion=0}get image(){return this.source.data}set image(e=null){this.source.data=e}updateMatrix(){this.matrix.setUvTransform(this.offset.x,this.offset.y,this.repeat.x,this.repeat.y,this.rotation,this.center.x,this.center.y)}clone(){return(new this.constructor).copy(this)}copy(e){return this.name=e.name,this.source=e.source,this.mipmaps=e.mipmaps.slice(0),this.mapping=e.mapping,this.channel=e.channel,this.wrapS=e.wrapS,this.wrapT=e.wrapT,this.magFilter=e.magFilter,this.minFilter=e.minFilter,this.anisotropy=e.anisotropy,this.format=e.format,this.internalFormat=e.internalFormat,this.type=e.type,this.offset.copy(e.offset),this.repeat.copy(e.repeat),this.center.copy(e.center),this.rotation=e.rotation,this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrix.copy(e.matrix),this.generateMipmaps=e.generateMipmaps,this.premultiplyAlpha=e.premultiplyAlpha,this.flipY=e.flipY,this.unpackAlignment=e.unpackAlignment,this.colorSpace=e.colorSpace,this.userData=JSON.parse(JSON.stringify(e.userData)),this.needsUpdate=!0,this}toJSON(e){var t,i=void 0===e||"string"==typeof e;return i||void 0===e.textures[this.uuid]?(t={metadata:{version:4.6,type:"Texture",generator:"Texture.toJSON"},uuid:this.uuid,name:this.name,image:this.source.toJSON(e).uuid,mapping:this.mapping,channel:this.channel,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],center:[this.center.x,this.center.y],rotation:this.rotation,wrap:[this.wrapS,this.wrapT],format:this.format,internalFormat:this.internalFormat,type:this.type,colorSpace:this.colorSpace,minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy,flipY:this.flipY,generateMipmaps:this.generateMipmaps,premultiplyAlpha:this.premultiplyAlpha,unpackAlignment:this.unpackAlignment},0<Object.keys(this.userData).length&&(t.userData=this.userData),i||(e.textures[this.uuid]=t),t):e.textures[this.uuid]}dispose(){this.dispatchEvent({type:"dispose"})}transformUv(e){if(this.mapping===Se){if(e.applyMatrix3(this.matrix),e.x<0||1<e.x)switch(this.wrapS){case we:e.x=e.x-Math.floor(e.x);break;case ye:e.x=e.x<0?0:1;break;case be:1===Math.abs(Math.floor(e.x)%2)?e.x=Math.ceil(e.x)-e.x:e.x=e.x-Math.floor(e.x)}if(e.y<0||1<e.y)switch(this.wrapT){case we:e.y=e.y-Math.floor(e.y);break;case ye:e.y=e.y<0?0:1;break;case be:1===Math.abs(Math.floor(e.y)%2)?e.y=Math.ceil(e.y)-e.y:e.y=e.y-Math.floor(e.y)}this.flipY&&(e.y=1-e.y)}return e}set needsUpdate(e){!0===e&&(this.version++,this.source.needsUpdate=!0)}set needsPMREMUpdate(e){!0===e&&this.pmremVersion++}}er.DEFAULT_IMAGE=null,er.DEFAULT_MAPPING=Se,er.DEFAULT_ANISOTROPY=1;class tr extends er{constructor(e,t,i,r,s,a,n,o,h){super(e,t,i,r,s,a,n,o,h),this.isCanvasTexture=!0,this.needsUpdate=!0}}class ir extends kt{constructor(e){super(),this.isMeshStandardMaterial=!0,this.defines={STANDARD:""},this.type="MeshStandardMaterial",this.color=new M(16777215),this.roughness=1,this.metalness=0,this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.emissive=new M(0),this.emissiveIntensity=1,this.emissiveMap=null,this.bumpMap=null,this.bumpScale=1,this.normalMap=null,this.normalMapType=Pe,this.normalScale=new D(1,1),this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.roughnessMap=null,this.metalnessMap=null,this.alphaMap=null,this.envMap=null,this.envMapRotation=new $e,this.envMapIntensity=1,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap="round",this.wireframeLinejoin="round",this.flatShading=!1,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.defines={STANDARD:""},void 0!==e.defines.SHADING_MODE&&(this.defines.SHADING_MODE=e.defines.SHADING_MODE),this.color.copy(e.color),this.roughness=e.roughness,this.metalness=e.metalness,this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.emissive.copy(e.emissive),this.emissiveMap=e.emissiveMap,this.emissiveIntensity=e.emissiveIntensity,this.bumpMap=e.bumpMap,this.bumpScale=e.bumpScale,this.normalMap=e.normalMap,this.normalMapType=e.normalMapType,this.normalScale.copy(e.normalScale),this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this.roughnessMap=e.roughnessMap,this.metalnessMap=e.metalnessMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.envMapRotation.copy(e.envMapRotation),this.envMapIntensity=e.envMapIntensity,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.flatShading=e.flatShading,this.fog=e.fog,this}}class rr extends ir{constructor(e){super(e),this.type="FMMeshStandardMaterial",this.isMask=!1,this.maskType=0,this.maskPolygons=[],this.maskHolePogygons=[],this.maskHeight=0,this.maskExtrudeHeight=0,this.boundCenter=null,this.boundSize=null,this.maskOpacity=null,this.maskNodeHeight=0,this.maskParam="",this.maskHoleParam=""}clone(){var e=(new this.constructor).copy(this);return e.isMask=this.isMask,e.maskType=this.maskType,e.maskPolygons=this.maskPolygons,e.maskHolePogygons=this.maskHolePogygons,e.maskHeight=this.maskHeight,e.maskExtrudeHeight=this.maskExtrudeHeight,e.boundCenter=this.boundCenter,e.boundSize=this.boundSize,e.maskOpacity=this.maskOpacity,e.maskNodeHeight=this.maskNodeHeight,e.maskParam=this.maskParam,e.maskHoleParam=this.maskHoleParam,e}}class sr{constructor(e,t){this.L=e.points,this.T=e.color,this.A=e.opacity,void 0===this.A&&(this.A=1),this.P=e.radius,this.N=e.height,void 0===this.N&&(this.N=0),this.D=null,this.R=e.url,this.I=null,this.U=null,this.O=e.count,this.F=new fengmap.FMBound,this.H=t}}Object.assign(sr.prototype,{V(){var e=this.I;if(!e)return!1;e.enableUpdateRender()},G(e,t){let i=new Image;i.crossOrigin="Anonymous",i.onload=()=>{var e=document.createElement("canvas");e.width=512,e.height=512,e.getContext("2d").drawImage(i,0,0,512,512),t&&t(e,i.width,i.height)},i.src=e},k(e,t,i,r){let s=0;for(let e=0;e<r.length-1;e++){var a=r[e],n=r[e+1],a=Math.sqrt((a.x-n.x)*(a.x-n.x)+(a.y-n.y)*(a.y-n.y));s+=a}return e*=i/t,Math.floor(s/e)},B(i,r,s){var a=this.I;if(!a)return!1;var n=[];for(let t=0;t<i.length;t++){let e=i[t].z;e=void 0!==e?e+r/2+s:0;var o=new N(i[t].x-a.x,e,-i[t].y+a.y);n.push(o)}return n},W(e,t){e=new tr(e);return e.repeat.set(t,1),e.wrapS=e.wrapT=we,e},Y(e,t){return new zt({color:new M(e),opacity:t,transparent:!0})},X(e,t,i,r,s,a){let n=null,o=(n=e.type===fengmap.FMType.TUBE_MARKER?new rr({color:new M(i),opacity:r,side:me,transparent:!0}):this.Y(i,r),void 0!==s&&(n.visible=!1),new di(t,n));return o.mapNode=e,void 0!==s&&this.G(s,e=>{e=this.W(e,a);o.material.map=e,o.material.color=null,o.material.needsUpdate=!0,o.material.visible=!0,this.V()}),o},j(e){e=new tr(e);e.repeat.set(this.O,1),e.wrapS=e.wrapT=we,this.D.material.color=null,this.D.material.map=e,this.D.material.needsUpdate=!0,this.D.material.visible=!0,this.V()}});class ar extends sr{constructor(e,t){super(e,t),this.q=e.extrudeHeight,void 0===this.q&&(this.q=1),this.Z=e.gradient,this.D=null,this.J=90,this.K=null,this.$=!1,this.ee=!1,this.te=null,this.ie=`
            #include <common>
            #include <logdepthbuf_pars_vertex>
            varying vec2 vUv;
            varying vec3 fNormal;
            varying vec3 vPosition;
            void main(){
                    vUv = uv;
                    vPosition = position;
                    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
                    gl_Position = projectionMatrix * mvPosition;
                    #include <logdepthbuf_vertex>
            }
        `,this.re=`
            varying vec2 vUv;
            uniform float repeat;
            uniform vec3 color;
            uniform bool isColor;
            uniform sampler2D colorTexture;
            uniform bool isBgColor;
            uniform float opacity;
            uniform bool isGradient;
            uniform int direction;//0为x轴,1为y
            uniform int gradientLength;
            uniform float gradientPercent[{num}];
            uniform vec4 gradientColor[{num}];
            #include <logdepthbuf_pars_fragment>
            vec4 getColor(vec2 uv){
                int begin=0;
                int end=0;
                float value=uv.x;
                if(direction==1){
                    if(uv.y<=0.5){
                        value=(0.5-uv.y)/0.5;
                    } else {
                        value=(uv.y-0.5)/0.5;
                    }
                }
                vec4 colorBegin=gradientColor[0];//gradientColor[begin];
                vec4 colorEnd=gradientColor[0];
                float beginPercent=gradientPercent[0];
                float endPercent=gradientPercent[0];
                if(direction==1){
                    for(int i=0;i<{num};i++){
                        if(value>gradientPercent[i]){
                            colorBegin=gradientColor[i];
                            colorEnd=gradientColor[i];
                            beginPercent=gradientPercent[i];
                            endPercent=gradientPercent[i];
                            if(i+1<={num}-1){
                                colorEnd=gradientColor[i+1];
                                endPercent=gradientPercent[i+1];
                            }
                        }
                    }
                } else {
                    for(int i=0;i<{num};i++){
                        if(value>gradientPercent[i]){
                            colorBegin=gradientColor[i];
                            colorEnd=gradientColor[i];
                            beginPercent=gradientPercent[i];
                            endPercent=gradientPercent[i];
                            if(i+1<={num}-1){
                                colorEnd=gradientColor[i+1];
                                endPercent=gradientPercent[i+1];
                            }
                        }
                    }
                }

                float perCent=0.0;
                if(direction==0){
                    perCent=(uv.x-beginPercent)/(endPercent-beginPercent);
                    return mix(colorBegin,colorEnd,perCent);
                } else {
                    if(uv.y<=0.5){
                        perCent=(((0.5-uv.y)/0.5)-beginPercent)/(endPercent-beginPercent);
                        return mix(colorBegin,colorEnd,perCent);
                    } else {
                        perCent=(((uv.y-0.5)/0.5)-beginPercent)/(endPercent-beginPercent);
                        return mix(colorBegin,colorEnd,perCent);
                    }
                }

            }
            void main( void ) {
                #include <logdepthbuf_fragment>
                if(isColor){
                    if(!isGradient){
                        gl_FragColor=vec4(color,opacity);
                    } else {
                        gl_FragColor=getColor(vUv);
                    }
                } else {
                    vec4 color = texture2D( colorTexture, vec2( vUv.x*repeat,vUv.y));
                    if(isGradient){
                        if(color.a!=0.0){
                            gl_FragColor=color;
                        } else {
                            gl_FragColor=getColor(vUv);
                        }
                    } else {
                        gl_FragColor = color;
                    }
                }
            }
        `}}Object.assign(ar.prototype,{se(){var t=new ki,i=this.B(this.L,this.q,this.N);for(let e=0;e<i.length-1;e++){i[e].x===i[e+1].x&&(i[e+1].x=i[e+1].x+.01),i[e].z===i[e+1].z&&(i[e+1].z=i[e+1].z+.01);var r=new pi(i[e],i[e+1]);t.curves.push(r)}var e=new zi(t,this.J*(i.length-1),this.q/2,2),s=this.ae();return void 0!==this.R&&(s.visible=!1),this.D=new di(e,s),this.D.mapNode=this.H,void 0!==this.R?this.G(this.R,(e,t,i)=>{void 0===this.O&&(this.O=this.k(t,i,this.q,this.L)),this.ne(e)}):this.V(),!0},ae(){let e=!1,t=0,i=0;var r=[],s=[];if(void 0!==this.Z){e=!0,"y"===this.Z.direct&&(t=1);var a,n=this.Z.colors;for(a in n){r.push(parseFloat(""+a));var o=n[a],o=o.substring(o.indexOf("(")+1,o.indexOf(")")).split(","),h=parseFloat(o[0])/255,l=parseFloat(o[1])/255,c=parseFloat(o[2])/255,o=parseFloat(o[3]);s.push(new vt(h,l,c,o)),i++}for(var d=r,u=s,f=d.length,m=0;m<f-1;m++)for(var p,v=0;v<f-1-m;v++)d[v]>d[v+1]&&(p=d[v+1],d[v+1]=d[v],d[v]=p,p=u[v+1],u[v+1]=u[v],u[v]=p)}else i=1,r.push(0),s.push(new vt(0,0,0,0));var g=this.re.replace(/{num}/g,""+i),g=new ji({uniforms:{colorTexture:{value:null},color:{value:new M(this.T)},isColor:{value:!0},repeat:{value:this.O},opacity:{value:this.A},isGradient:{value:e},direction:{value:t},gradientLength:{value:i},gradientPercent:{value:r},gradientColor:{value:s}},transparent:!0,depthWrite:!0,depthTest:!0,vertexShader:this.ie,fragmentShader:g});return g.isNoEffect=!0,g},ne(e){var t=this.oe(e),i=document.createElement("canvas"),r=(i.width=512,i.height=1024,i.getContext("2d")),e=(r.drawImage(e,0,0,512,512),r.drawImage(t,0,512,512,512),this.W(this.he(i),this.O));this.D.material.uniforms.colorTexture&&(this.D.material.uniforms.colorTexture.value=e),this.D.material.uniforms.isColor&&(this.D.material.uniforms.isColor.value=!1),this.D.material.uniforms.isGradient.value=void 0!==this.Z,this.D.material.uniforms.repeat.value=this.O,this.D.material.visible=!0,this.V()},he(e){var t=document.createElement("canvas"),i=(t.width=e.width,t.height=e.height,t.getContext("2d"));return i.translate(t.width,0),i.scale(-1,1),i.drawImage(e,0,0,t.width,t.height),t},oe(e){var t=document.createElement("canvas"),i=(t.width=512,t.height=512,t.getContext("2d"));return i.translate(256,256),i.rotate(Math.PI),i.drawImage(e,-256,-256),this.he(t)}});class nr extends kt{constructor(e){super(),this.isMeshLambertMaterial=!0,this.type="MeshLambertMaterial",this.color=new M(16777215),this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.emissive=new M(0),this.emissiveIntensity=1,this.emissiveMap=null,this.bumpMap=null,this.bumpScale=1,this.normalMap=null,this.normalMapType=Pe,this.normalScale=new D(1,1),this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.specularMap=null,this.alphaMap=null,this.envMap=null,this.envMapRotation=new $e,this.combine=Me,this.reflectivity=1,this.refractionRatio=.98,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap="round",this.wireframeLinejoin="round",this.flatShading=!1,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.emissive.copy(e.emissive),this.emissiveMap=e.emissiveMap,this.emissiveIntensity=e.emissiveIntensity,this.bumpMap=e.bumpMap,this.bumpScale=e.bumpScale,this.normalMap=e.normalMap,this.normalMapType=e.normalMapType,this.normalScale.copy(e.normalScale),this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this.specularMap=e.specularMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.envMapRotation.copy(e.envMapRotation),this.combine=e.combine,this.reflectivity=e.reflectivity,this.refractionRatio=e.refractionRatio,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.flatShading=e.flatShading,this.fog=e.fog,this}}class or extends nr{constructor(e){super(e),this.type="FMMeshLambertMaterial",this.mapMixColor=!1,this.heatCenter=null,this.heatSize=null,this.isMask=!1,this.maskType=0,this.maskPolygons=[],this.maskHolePogygons=[],this.maskHeight=0,this.maskExtrudeHeight=0,this.boundCenter=null,this.boundSize=null,this.maskOpacity=null,this.maskNodeHeight=0,this.maskParam="",this.maskHoleParam="",this.isJsonModel=!1}clone(){var e=(new this.constructor).copy(this);return e.mapMixColor=this.mapMixColor,e.heatCenter=this.heatCenter,e.heatSize=this.heatSize,e.isMask=this.isMask,e.maskType=this.maskType,e.maskPolygons=this.maskPolygons,e.maskHolePogygons=this.maskHolePogygons,e.maskHeight=this.maskHeight,e.maskExtrudeHeight=this.maskExtrudeHeight,e.boundCenter=this.boundCenter,e.boundSize=this.boundSize,e.maskOpacity=this.maskOpacity,e.maskNodeHeight=this.maskNodeHeight,e.maskParam=this.maskParam,e.maskHoleParam=this.maskHoleParam,e.isJsonModel=this.isJsonModel,e}}class hr extends fengmap.FMMarker{constructor(e){super(e),this.tool=null,this.update=this.update.bind(this),this.resize=this.resize.bind(this)}set count(e){this.tool.O=e,this.type!==fengmap.FMType.LINE3D_MARKER?this.tool.D.material.map&&(this.tool.D.material.map.repeat.set(this.tool.O,1),this.tool.D.material.needsUpdate=!0):this.tool.D.material.map&&(this.tool.le=!1,this.tool.D.material.repeat=new D(this.tool.O,1)),this.tool.V()}get count(){return this.tool.O}get opacity(){return this.tool.A}set opacity(e){this.tool.A=e,this.tool.D&&(this.tool.D.material.opacity=this.tool.A,this.tool.V())}get points(){return this.tool.L}set points(e){this.tool.L=e,this.reCreateObject()}get color(){return this.tool.T}set color(e){this.tool.T=e,this.type!==fengmap.FMType.WALL_MARKER?this.tool.D.material.color=new M(e):this.tool.D.material.uniforms.color&&(this.tool.D.material.uniforms.color.value=new M(e)),this.tool.V()}get bound(){return!0===super.needUpdateBound&&(this.tool.F.reset(),this.tool.F.expandByCoords(this.tool.L),super.needUpdateBound=!1),this.tool.F.clone()}get x(){return this.bound.center.x}get y(){return this.bound.center.y}set url(e){this.tool.R=e,"ShaderMaterial"===this.tool.D.material.type?this.tool.K.getMaterial(this,e=>{this.tool.D.material.dispose(),this.tool.D.material=e}):this.tool.R&&this.tool.G(this.tool.R,e=>{this.type!==fengmap.FMType.WALL_MARKER?this.tool.j(e):this.tool.ne(e)})}get url(){return this.tool.R}set radius(e){this.tool.P=e,this.reCreateObject(),this.updateLineMaterial(),this.tool.V()}get radius(){return this.tool.P}get height(){return this.tool.N}set height(e){this.tool.N=e,this.reCreateObject(),this.updateLineMaterial(),this.tool.V()}get visible(){return super.visible}set visible(e){super.visible=e,this.tool.D&&(this.tool.D.visible=e),this.tool.V()}addTo(e){this.isInit=!0,super.addTo(e),this.tool.I=e.parent.parent,this.tool.U=e,this.tool.se(),this.parent.scene.add(this.tool.D)}remove(){var e,t=this.tool.I;t&&((e=this.tool.D.parent)&&e.remove(this.tool.D),this.parent&&this.parent.remove(this),t)&&(t.enableUpdateRender(),this.tool.$&&t.off("update",this.update),this.type===fengmap.FMType.LINE3D_MARKER)&&t.off("resize",this.resize)}getRenderNode(){return this.tool.D}update(){var e,t;this.type!==fengmap.FMType.SPHERE_MARKER?null!==this.tool.K&&(this.type===fengmap.FMType.LINE3D_MARKER?void 0!==this.tool.O&&(e=this.tool.K.speed/this.tool.O,(t=this.tool.D.material.offset).x=t.x+e/1e3,this.tool.D.material.offset=t,this.tool.V()):("ShaderMaterial"!==this.tool.D.material.type&&this.tool.K.getMaterial(this,e=>{this.tool.D.material.dispose(),this.tool.D.material=e}),this.tool.D.material.uniforms&&(this.tool.K.update(this),this.tool.V()))):null!==this.tool.ce&&("ShaderMaterial"!==this.tool.D.material.type&&this.tool.ce.getMaterial(this,e=>{this.tool.D.material.dispose(),this.tool.D.material=e}),this.tool.D.material.uniforms)&&(this.tool.ce.update(this.tool.D),this.tool.V())}resize(){let e=window.innerWidth,t=window.innerHeight;var i=this.tool.I;i&&(e=i.getContainer().clientWidth,t=i.getContainer().clientHeight),this.tool.D.material.resolution=new D(e,t),this.tool.V()}addEffect(e,t,i){let r=this.tool.I;r&&"FMFlowEffect"===e.type&&(void 0===this.tool.R?console.error("没有图片不能加特效"):this.type!==fengmap.FMType.LINE3D_MARKER?(this.tool.K=e,this.tool.K.getMaterial(this,e=>{this.tool.$||(this.tool.D.material.dispose(),this.tool.D.material=e,this.tool.ee=!0,r.on("update",this.update),this.tool.$=!0)})):(void 0!==i&&(this.tool.D.material.isbackground=!0,this.tool.D.material.bgcolor=new M(i)),void 0!==t&&(this.tool.D.material.markerluminance=t),this.tool.de=i,this.tool.ue=t,this.tool.K=e,this.tool.$=!0,r.on("update",this.update)))}removeEffect(e){"FMFlowEffect"===e.type&&(this.tool.K=null),this.tool.$=!1,null===this.tool.K&&(e=this.tool.I)&&(e.off("update",this._update),this.tool.D.material.dispose(),this.type===fengmap.FMType.TUBE_MARKER?(e=new or({color:new M(this.tool.T),opacity:this.tool.A,side:me,transparent:!0}),this.tool.D.material=e,void 0!==this.tool.R&&this.tool.G(this.tool.R,e=>{e=new tr(e);e.repeat.set(this.tool.O,1),this.tool.D.material.color=null,e.wrapS=e.wrapT=we,this.tool.D.material.map=e,this.tool.D.material.needsUpdate=!0,this.tool.V()}),this.tool.V()):this.type===fengmap.FMType.WALL_MARKER?(e=this.tool.ae(),this.tool.D.material=e,void 0!==this.tool.R&&this.tool.G(this.tool.R,e=>{this.tool.ne(e)}),this.tool.V()):(this.tool.D.material.offset=new D(1,1),this.tool.D.material.isbackground=!1,this.tool.D.material.markerluminance=1))}reCreateObject(){var e=this.tool.D.parent;e.remove(this.tool.D),this.tool.D.geometry.dispose(),this.tool.D.material.dispose(),this.tool.se(),e.add(this.tool.D),this.tool.V()}updateLineMaterial(){this.type===fengmap.FMType.LINE3D_MARKER&&(void 0!==this.tool.de&&(this.tool.D.material.isbackground=!0,this.tool.D.material.bgcolor=new M(this.tool.de)),void 0!==this.tool.ue)&&(this.tool.D.material.markerluminance=this.tool.ue)}}class lr extends hr{constructor(e){super(e),super.setType(t.WALL_MARKER),this.tool=new ar(e,this)}set extrudeHeight(e){this.tool.q=e;let t=null;this.tool.D.material.isNoEffect||(t=this.tool.K).remove(this),this.reCreateObject(),null!==t&&t.add(this)}get extrudeHeight(){return this.tool.q}set gradient(e){var t;this.tool.D&&(this.tool.Z=e,e=this.tool.ae(),(t=this.tool.D).material.isNoEffect?(t.material.dispose(),t.material=e):(t.material.uniforms.isGradient.value=e.uniforms.isGradient.value,t.material.uniforms.gradientLength.value=e.uniforms.gradientLength.value,t.material.uniforms.direction.value=e.uniforms.direction.value,t.material.uniforms.gradientPercent.value=e.uniforms.gradientPercent.value,t.material.uniforms.gradientColor.value=e.uniforms.gradientColor.value),this.tool.V())}get gradient(){return this.tool.Z}set radius(e){}get radius(){return null}set url(e){this.tool.R=e,this.tool.D.material.isNoEffect?(e=this.tool.ae(),this.tool.D.material.dispose(),this.tool.D.material=e,this.tool.G(this.tool.R,(e,t,i)=>{this.tool.O=this.tool.k(t,i,this.tool.q,this.tool.L),this.tool.ne(e)})):((e=this.tool.K).remove(this),e.add(this))}get url(){return this.tool.R}set count(e){this.tool.O=e,this.tool.D.material.uniforms.repeat.value=e,this.tool.V()}get count(){return this.tool.O}get color(){return this.tool.T}set color(e){this.tool.T=e,this.tool.D.material.uniforms.color&&(this.tool.D.material.uniforms.color.value=new M(e)),this.tool.V()}get height(){return this.tool.N}set height(e){this.tool.N=e;let t=null;this.tool.D.material.isNoEffect||(t=this.tool.K).remove(this),this.reCreateObject(),this.tool.V(),t&&t.add(this)}get points(){return this.tool.L}set points(e){let t=null;this.tool.D.material.isNoEffect||(t=this.tool.K).remove(this),this.tool.L=e,this.reCreateObject(),t&&t.add(this)}get opacity(){return this.tool.A}set opacity(e){this.tool.A=e,this.tool.D&&(this.tool.D.material.uniforms.opacity&&(this.tool.D.material.uniforms.opacity.value=e),this.tool.V())}}class cr extends L{constructor(n=new yi([new N(-1,-1,0),new N(-1,1,0),new N(1,1,0)]),o=void 0,h=.3,l=8,e=!1){super(),this.type="TubePath",this.parameters={path:n,uMappingFrames:o,radius:h,radialSegments:l,closed:e},o=o||cr.pathToUMapping(n);let t=this.computeFrenetFrames(n,o,e),c=(this.tangents=t.tangents,this.normals=t.normals,this.binormals=t.binormals,new N),d=new N,r=new D,u=new N,s=0,f=[],m=[],a=[],i=[];for(let e=0;e<o.length-1;e++)y(e);for(let e=1;e<o.length-1;e++){var p=new N,v=(p=n.getPointAt(o[e],p),new N),p=(v=n.getPointAt(o[e-1],v),p.distanceTo(v));s+=p}y(!1===e?o.length-1:0);{let i=0;for(let t=0;t<=o.length-1;t++){var g,_;0<t&&(g=new N,g=n.getPointAt(o[t],g),_=new N,_=n.getPointAt(o[t-1],_),i+=g.distanceTo(_));for(let e=0;e<=l;e++)0!==s?r.x=i/s:r.x=t/(o.length-1),r.y=e/l,a.push(r.x,r.y)}}for(let t=1;t<=o.length-1;t++)for(let e=1;e<=l;e++){var x=(l+1)*(t-1)+(e-1),M=(l+1)*t+(e-1),S=(l+1)*t+e,w=(l+1)*(t-1)+e;i.push(x,M,w),i.push(M,S,w)}function y(e){u=n.getPointAt(o[e],u);var i=t.normals[e],r=t.binormals[e];for(let t=0;t<=l;t++){let e=t/l*Math.PI*2;4===l&&(e=t*Math.PI/2+Math.PI/4);var s=Math.sin(e),a=-Math.cos(e);d.x=a*i.x+s*r.x,d.y=a*i.y+s*r.y,d.z=a*i.z+s*r.z,d.normalize(),m.push(d.x,d.y,d.z),c.x=u.x+h*d.x,c.y=u.y+h*d.y,c.z=u.z+h*d.z,f.push(c.x,c.y,c.z)}}this.setIndex(i),this.setAttribute("position",new E(f,3)),this.setAttribute("normal",new E(m,3)),this.setAttribute("uv",new E(a,2))}computeFrenetFrames(t,i,e){var r=new N,s=[],a=[],n=[],o=new N,h=new _,l=i.length-1;for(let e=0;e<=l;e++){var c=i[e];s[e]=t.getTangentAt(c,new N)}a[0]=new N,n[0]=new N;let d=Number.MAX_VALUE;var u,f=Math.abs(s[0].x),m=Math.abs(s[0].y),p=Math.abs(s[0].z);f<=d&&(d=f,r.set(1,0,0)),m<=d&&(d=m,r.set(0,1,0)),p<=d&&r.set(0,0,1),o.crossVectors(s[0],r).normalize(),a[0].crossVectors(s[0],o),n[0].crossVectors(s[0],a[0]);for(let e=1;e<=l;e++)a[e]=a[e-1].clone(),n[e]=n[e-1].clone(),o.crossVectors(s[e-1],s[e]),o.length()>Number.EPSILON&&(o.normalize(),u=Math.acos(v(s[e-1].dot(s[e]),-1,1)),a[e].applyMatrix4(h.makeRotationAxis(o,u))),n[e].crossVectors(s[e],a[e]);if(!0===e){let t=Math.acos(v(a[0].dot(a[l]),-1,1));t/=l,0<s[0].dot(o.crossVectors(a[0],a[l]))&&(t=-t);for(let e=1;e<=l;e++)a[e].applyMatrix4(h.makeRotationAxis(s[e],t*e)),n[e].crossVectors(s[e],a[e])}return{tangents:s,normals:a,binormals:n}}toJSON(){var e=super.toJSON();return e.path=this.parameters.path.toJSON(),e}static fromJSON(e){return new cr((new mi[e.path.type]).fromJSON(e.path),e.uMappingFrames,e.radius,e.radialSegments,e.closed)}static pathToUMapping(e=new yi([new N(-1,-1,0),new N(-1,1,0),new N(1,1,0)]),o=2,h=.1,l=2){let c=[0];return e.points.forEach((e,i,r)=>{if(0<i){var s=c.at(-1),e=e.distanceTo(r[i-1]);let t=h;l<e&&(t=l/o);var a=s+e,n=Math.min(o,e/2/t-1);if(1<i)for(let e=1;e<=n;++e)c.push(s+e*t);if(i<r.length-1)for(let e=n;1<=e;--e)c.push(a-e*t);c.push(a)}}),c.map(e=>e/c.at(-1))}}class dr extends sr{constructor(e,t){super(e,t),void 0===this.P&&(this.P=2),this.fe=e.tubularSegments,void 0===this.fe&&(this.fe=2),this.me=e.radialSegments,void 0===this.me&&(this.me=8),void 0===this.O&&(this.O=1),this.D=null,this.K=null,this.te=null,this.$=!1,this.ee=!1}}Object.assign(dr.prototype,{se(){var e=this.B(this.L,2*this.P,this.N),e=new yi(e),e=new cr(e,cr.pathToUMapping(e,this.fe,.1,this.P),this.P,this.me,!1);return this.D=this.X(this.H,e,this.T,this.A,this.R,this.O),this.V(),!0},pe(t){let r=this;var i=[];for(let e=0;e<t.length-1;e++){var s,a=new N(t[e].x,t[e].y,t[e].z),n=new N(t[e+1].x,t[e+1].y,t[e+1].z),a=(0===e?(i.push(a),null!==(s=o(a,n))&&i.push(s)):null!==(s=o(a,n))&&i.push(s),o(n,a));null!==a&&i.push(a),i.push(n)}return i;function o(e,t){let i=r.P/e.distanceTo(t);return.5<i&&(i=.1),new N(e.x+(t.x-e.x)*i,e.y+(t.y-e.y)*i,e.z+(t.z-e.z)*i)}}});class ur extends hr{constructor(e){super(e),super.setType(t.TUBE_MARKER),this.tool=new dr(e,this)}get tubularSegments(){return this.tool.fe}set tubularSegments(e){this.tool.fe=e,this.reCreateObject()}get radialSegments(){return this.tool.me}set radialSegments(e){this.tool.me=e,this.reCreateObject()}}class fr extends kt{constructor(e){super(),this.isLineBasicMaterial=!0,this.type="LineBasicMaterial",this.color=new M(16777215),this.map=null,this.linewidth=1,this.linecap="round",this.linejoin="round",this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.linewidth=e.linewidth,this.linecap=e.linecap,this.linejoin=e.linejoin,this.fog=e.fog,this}}let mr=new N,pr=new N,vr=new _,gr=new de,_r=new se,xr=new N,Mr=new N;class Sr extends u{constructor(e=new L,t=new fr){super(),this.isLine=!0,this.type="Line",this.geometry=e,this.material=t,this.updateMorphTargets()}copy(e,t){return super.copy(e,t),this.material=Array.isArray(e.material)?e.material.slice():e.material,this.geometry=e.geometry,this}computeLineDistances(){var e=this.geometry;if(null===e.index){var i=e.attributes.position,r=[0];for(let e=1,t=i.count;e<t;e++)mr.fromBufferAttribute(i,e-1),pr.fromBufferAttribute(i,e),r[e]=r[e-1],r[e]+=mr.distanceTo(pr);e.setAttribute("lineDistance",new E(r,1))}else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");return this}raycast(i,r){var s=this.geometry,a=this.matrixWorld,e=i.params.Line.threshold,t=s.drawRange;if(null===s.boundingSphere&&s.computeBoundingSphere(),_r.copy(s.boundingSphere),_r.applyMatrix4(a),_r.radius+=e,!1!==i.ray.intersectsSphere(_r)){vr.copy(a).invert(),gr.copy(i.ray).applyMatrix4(vr);var a=e/((this.scale.x+this.scale.y+this.scale.z)/3),n=a*a,o=this.isLineSegments?2:1,h=s.index,e=s.attributes.position;if(null!==h){var a=Math.max(0,t.start),s=Math.min(h.count,t.start+t.count);for(let e=a,t=s-1;e<t;e+=o){var l=h.getX(e),c=h.getX(e+1),l=wr(this,i,gr,n,l,c);l&&r.push(l)}this.isLineLoop&&(s=h.getX(s-1),a=h.getX(a),s=wr(this,i,gr,n,s,a))&&r.push(s)}else{a=Math.max(0,t.start),s=Math.min(e.count,t.start+t.count);for(let e=a,t=s-1;e<t;e+=o){var d=wr(this,i,gr,n,e,e+1);d&&r.push(d)}this.isLineLoop&&(e=wr(this,i,gr,n,s-1,a))&&r.push(e)}}}updateMorphTargets(){var e=this.geometry.morphAttributes,t=Object.keys(e);if(0<t.length){var i=e[t[0]];if(void 0!==i){this.morphTargetInfluences=[],this.morphTargetDictionary={};for(let e=0,t=i.length;e<t;e++){var r=i[e].name||String(e);this.morphTargetInfluences.push(0),this.morphTargetDictionary[r]=e}}}}}function wr(e,t,i,r,s,a){var n=e.geometry.attributes.position,n=(mr.fromBufferAttribute(n,s),pr.fromBufferAttribute(n,a),i.distanceSqToSegment(mr,pr,xr,Mr));if(!(r<n)){xr.applyMatrix4(e.matrixWorld);a=t.ray.origin.distanceTo(xr);if(!(a<t.near||a>t.far))return{distance:a,point:Mr.clone().applyMatrix4(e.matrixWorld),index:s,face:null,faceIndex:null,barycoord:null,object:e}}}let yr=new N,br=new N;class Er extends Sr{constructor(e,t){super(e,t),this.isLineSegments=!0,this.type="LineSegments"}computeLineDistances(){var e=this.geometry;if(null===e.index){var i=e.attributes.position,r=[];for(let e=0,t=i.count;e<t;e+=2)yr.fromBufferAttribute(i,e),br.fromBufferAttribute(i,e+1),r[e]=0===e?0:r[e-1],r[e+1]=r[e]+yr.distanceTo(br);e.setAttribute("lineDistance",new E(r,1))}else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");return this}}var Cr=`
#ifdef USE_ALPHAHASH

	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;

#endif
`,Lr=`
#ifdef USE_ALPHAHASH

	/**
	 * See: https://casual-effects.com/research/Wyman2017Hashed/index.html
	 */

	const float ALPHA_HASH_SCALE = 0.05; // Derived from trials only, and may be changed.

	float hash2D( vec2 value ) {

		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );

	}

	float hash3D( vec3 value ) {

		return hash2D( vec2( hash2D( value.xy ), value.z ) );

	}

	float getAlphaHashThreshold( vec3 position ) {

		// Find the discretized derivatives of our coordinates
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );

		// Find two nearest log-discretized noise scales
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);

		// Compute alpha thresholds at our two noise scales
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);

		// Factor to interpolate lerp with
		float lerpFactor = fract( log2( pixScale ) );

		// Interpolate alpha threshold from noise at two scales
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;

		// Pass into CDF to compute uniformly distrib threshold
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);

		// Find our final, uniformly distributed alpha threshold (ατ)
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;

		// Avoids ατ == 0. Could also do ατ =1-ατ
		return clamp( threshold , 1.0e-6, 1.0 );

	}

#endif
`,Tr=`
#ifdef USE_ALPHAMAP

	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;

#endif
`,Ar=`
#ifdef USE_ALPHAMAP

	uniform sampler2D alphaMap;

#endif
`,Pr=`
#ifdef USE_ALPHATEST

	#ifdef ALPHA_TO_COVERAGE

	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;

	#else

	if ( diffuseColor.a < alphaTest ) discard;

	#endif

#endif
`,Nr=`
#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif
`,Dr=`
#ifdef USE_AOMAP

	// reads channel R, compatible with a combined OcclusionRoughnessMetallic (RGB) texture
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;

	reflectedLight.indirectDiffuse *= ambientOcclusion;

	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif

	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif

	#if defined( USE_ENVMAP ) && defined( STANDARD )

		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );

		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );

	#endif

#endif
`,Rr=`
#ifdef USE_AOMAP

	uniform sampler2D aoMap;
	uniform float aoMapIntensity;

#endif
`,Ir=`
#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif

	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {

		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );

	}

	float getIndirectIndex( const in int i ) {

		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );

	}

#endif

#ifdef USE_BATCHING_COLOR

	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {

		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;

	}

#endif
`,Ur=`
#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif
`,Or=`
vec3 transformed = vec3( position );

#ifdef USE_ALPHAHASH

	vPosition = vec3( position );

#endif
`,Fr=`
vec3 objectNormal = vec3( normal );

#ifdef USE_TANGENT

	vec3 objectTangent = vec3( tangent.xyz );

#endif
`,Hr=`

float G_BlinnPhong_Implicit( /* const in float dotNL, const in float dotNV */ ) {

	// geometry term is (n dot l)(n dot v) / 4(n dot l)(n dot v)
	return 0.25;

}

float D_BlinnPhong( const in float shininess, const in float dotNH ) {

	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );

}

vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {

	vec3 halfDir = normalize( lightDir + viewDir );

	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );

	vec3 F = F_Schlick( specularColor, 1.0, dotVH );

	float G = G_BlinnPhong_Implicit( /* dotNL, dotNV */ );

	float D = D_BlinnPhong( shininess, dotNH );

	return F * ( G * D );

} // validated

`,Vr=`

#ifdef USE_IRIDESCENCE

	// XYZ to linear-sRGB color space
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);

	// Assume air interface for top
	// Note: We don't handle the case fresnel0 == 1
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {

		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );

	}

	// Conversion FO/IOR
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {

		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );

	}

	// ior is a value between 1.0 and 3.0. 1.0 is air interface
	float IorToFresnel0( float transmittedIor, float incidentIor ) {

		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));

	}

	// Fresnel equations for dielectric/dielectric interfaces.
	// Ref: https://belcour.github.io/blog/research/2017/05/01/brdf-thin-film.html
	// Evaluation XYZ sensitivity curves in Fourier space
	vec3 evalSensitivity( float OPD, vec3 shift ) {

		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );

		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;

		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;

	}

	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {

		vec3 I;

		// Force iridescenceIOR -> outsideIOR when thinFilmThickness -> 0.0
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		// Evaluate the cosTheta on the base layer (Snell law)
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );

		// Handle TIR:
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {

			return vec3( 1.0 );

		}

		float cosTheta2 = sqrt( cosTheta2Sq );

		// First interface
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;

		// Second interface
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) ); // guard against 1.0
		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;

		// Phase shift
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;

		// Compound terms
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );

		// Reflectance term for m = 0 (DC term amplitude)
		vec3 C0 = R12 + Rs;
		I = C0;

		// Reflectance term for m > 0 (pairs of diracs)
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {

			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;

		}

		// Since out of gamut colors might be produced, negative color values are clamped to 0.
		return max( I, vec3( 0.0 ) );

	}

#endif

`,Gr=`
#ifdef USE_BUMPMAP

	uniform sampler2D bumpMap;
	uniform float bumpScale;

	// Bump Mapping Unparametrized Surfaces on the GPU by Morten S. Mikkelsen
	// https://mmikk.github.io/papers3d/mm_sfgrad_bump.pdf

	// Evaluate the derivative of the height w.r.t. screen-space using forward differencing (listing 2)

	vec2 dHdxy_fwd() {

		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );

		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;

		return vec2( dBx, dBy );

	}

	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {

		// normalize is done to ensure that the bump map looks the same regardless of the texture's scale
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm; // normalized

		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );

		float fDet = dot( vSigmaX, R1 ) * faceDirection;

		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );

	}

#endif
`,kr=`
#if NUM_CLIPPING_PLANES > 0

	vec4 plane;

	#ifdef ALPHA_TO_COVERAGE

		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;

		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {

			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );

			if ( clipOpacity == 0.0 ) discard;

		}
		#pragma unroll_loop_end

		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES

			float unionClipOpacity = 1.0;

			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {

				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );

			}
			#pragma unroll_loop_end

			clipOpacity *= 1.0 - unionClipOpacity;

		#endif

		diffuseColor.a *= clipOpacity;

		if ( diffuseColor.a == 0.0 ) discard;

	#else

		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {

			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;

		}
		#pragma unroll_loop_end

		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES

			bool clipped = true;

			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {

				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;

			}
			#pragma unroll_loop_end

			if ( clipped ) discard;

		#endif

	#endif

#endif
`,zr=`
#if NUM_CLIPPING_PLANES > 0

	varying vec3 vClipPosition;

	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];

#endif
`,Br=`
#if NUM_CLIPPING_PLANES > 0

	varying vec3 vClipPosition;

#endif
`,Wr=`
#if NUM_CLIPPING_PLANES > 0

	vClipPosition = - mvPosition.xyz;

#endif
`,Yr=`
#if defined( USE_COLOR_ALPHA )

	diffuseColor *= vColor;

#elif defined( USE_COLOR )

	diffuseColor.rgb *= vColor;

#endif
`,Xr=`
#if defined( USE_COLOR_ALPHA )

	varying vec4 vColor;

#elif defined( USE_COLOR )

	varying vec3 vColor;

#endif
`,jr=`
#if defined( USE_COLOR_ALPHA )

	varying vec4 vColor;

#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )

	varying vec3 vColor;

#endif
`,qr=`
#if defined( USE_COLOR_ALPHA )

	vColor = vec4( 1.0 );

#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )

	vColor = vec3( 1.0 );

#endif

#ifdef USE_COLOR

	vColor *= color;

#endif

#ifdef USE_INSTANCING_COLOR

	vColor.xyz *= instanceColor.xyz;

#endif

#ifdef USE_BATCHING_COLOR

	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );

	vColor.xyz *= batchingColor.xyz;

#endif
`,Zr=`
#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6

#ifndef saturate
// <tonemapping_pars_fragment> may have defined saturate() already
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )

float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }

// expects values in the range of [0,1]x[0,1], returns values in the [0,1] range.
// do not collapse into a single function per: http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/
highp float rand( const in vec2 uv ) {

	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );

	return fract( sin( sn ) * c );

}

#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif

struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};

struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};

#ifdef USE_ALPHAHASH

	varying vec3 vPosition;

#endif

vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

}

vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {

	// dir can be either a direction vector or a normal vector
	// upper-left 3x3 of matrix is assumed to be orthogonal

	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );

}

mat3 transposeMat3( const in mat3 m ) {

	mat3 tmp;

	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );

	return tmp;

}

bool isPerspectiveMatrix( mat4 m ) {

	return m[ 2 ][ 3 ] == - 1.0;

}

vec2 equirectUv( in vec3 dir ) {

	// dir is assumed to be unit length

	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;

	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;

	return vec2( u, v );

}

vec3 BRDF_Lambert( const in vec3 diffuseColor ) {

	return RECIPROCAL_PI * diffuseColor;

} // validated

vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {

	// Original approximation by Christophe Schlick '94
	// float fresnel = pow( 1.0 - dotVH, 5.0 );

	// Optimized variant (presented by Epic at SIGGRAPH '13)
	// https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );

	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );

} // validated

float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {

	// Original approximation by Christophe Schlick '94
	// float fresnel = pow( 1.0 - dotVH, 5.0 );

	// Optimized variant (presented by Epic at SIGGRAPH '13)
	// https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );

	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );

} // validated
`,Jr=`
#ifdef ENVMAP_TYPE_CUBE_UV

	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0

	// These shader functions convert between the UV coordinates of a single face of
	// a cubemap, the 0-5 integer index of a cube face, and the direction vector for
	// sampling a textureCube (not generally normalized ).

	float getFace( vec3 direction ) {

		vec3 absDirection = abs( direction );

		float face = - 1.0;

		if ( absDirection.x > absDirection.z ) {

			if ( absDirection.x > absDirection.y )

				face = direction.x > 0.0 ? 0.0 : 3.0;

			else

				face = direction.y > 0.0 ? 1.0 : 4.0;

		} else {

			if ( absDirection.z > absDirection.y )

				face = direction.z > 0.0 ? 2.0 : 5.0;

			else

				face = direction.y > 0.0 ? 1.0 : 4.0;

		}

		return face;

	}

	// RH coordinate system; PMREM face-indexing convention
	vec2 getUV( vec3 direction, float face ) {

		vec2 uv;

		if ( face == 0.0 ) {

			uv = vec2( direction.z, direction.y ) / abs( direction.x ); // pos x

		} else if ( face == 1.0 ) {

			uv = vec2( - direction.x, - direction.z ) / abs( direction.y ); // pos y

		} else if ( face == 2.0 ) {

			uv = vec2( - direction.x, direction.y ) / abs( direction.z ); // pos z

		} else if ( face == 3.0 ) {

			uv = vec2( - direction.z, direction.y ) / abs( direction.x ); // neg x

		} else if ( face == 4.0 ) {

			uv = vec2( - direction.x, direction.z ) / abs( direction.y ); // neg y

		} else {

			uv = vec2( direction.x, direction.y ) / abs( direction.z ); // neg z

		}

		return 0.5 * ( uv + 1.0 );

	}

	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {

		float face = getFace( direction );

		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );

		mipInt = max( mipInt, cubeUV_minMipLevel );

		float faceSize = exp2( mipInt );

		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0; // #25071

		if ( face > 2.0 ) {

			uv.y += faceSize;

			face -= 3.0;

		}

		uv.x += face * faceSize;

		uv.x += filterInt * 3.0 * cubeUV_minTileSize;

		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );

		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;

		#ifdef texture2DGradEXT

			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb; // disable anisotropic filtering

		#else

			return texture2D( envMap, uv ).rgb;

		#endif

	}

	// These defines must match with PMREMGenerator

	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0

	float roughnessToMip( float roughness ) {

		float mip = 0.0;

		if ( roughness >= cubeUV_r1 ) {

			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;

		} else if ( roughness >= cubeUV_r4 ) {

			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;

		} else if ( roughness >= cubeUV_r5 ) {

			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;

		} else if ( roughness >= cubeUV_r6 ) {

			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;

		} else {

			mip = - 2.0 * log2( 1.16 * roughness ); // 1.16 = 1.79^0.25
		}

		return mip;

	}

	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {

		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );

		float mipF = fract( mip );

		float mipInt = floor( mip );

		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );

		if ( mipF == 0.0 ) {

			return vec4( color0, 1.0 );

		} else {

			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );

			return vec4( mix( color0, color1, mipF ), 1.0 );

		}

	}

#endif
`,Kr=`

vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT

	vec3 transformedTangent = objectTangent;

#endif

#ifdef USE_BATCHING

	// this is in lieu of a per-instance normal-matrix
	// shear transforms in the instance matrix are not supported

	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;

	#ifdef USE_TANGENT

		transformedTangent = bm * transformedTangent;

	#endif

#endif

#ifdef USE_INSTANCING

	// this is in lieu of a per-instance normal-matrix
	// shear transforms in the instance matrix are not supported

	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;

	#ifdef USE_TANGENT

		transformedTangent = im * transformedTangent;

	#endif

#endif

transformedNormal = normalMatrix * transformedNormal;

#ifdef FLIP_SIDED

	transformedNormal = - transformedNormal;

#endif

#ifdef USE_TANGENT

	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;

	#ifdef FLIP_SIDED

		transformedTangent = - transformedTangent;

	#endif

#endif
`,Qr=`
#ifdef USE_DISPLACEMENTMAP

	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;

#endif
`,$r=`
#ifdef USE_DISPLACEMENTMAP

	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );

#endif
`,es=`
#ifdef USE_EMISSIVEMAP

	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );

	totalEmissiveRadiance *= emissiveColor.rgb;

#endif
`,ts=`
#ifdef USE_EMISSIVEMAP

	uniform sampler2D emissiveMap;

#endif
`,is=`
gl_FragColor = linearToOutputTexel( gl_FragColor );
`,rs=`

// http://www.russellcottrell.com/photo/matrixCalculator.htm

// Linear sRGB => XYZ => Linear Display P3
const mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(
	vec3( 0.8224621, 0.177538, 0.0 ),
	vec3( 0.0331941, 0.9668058, 0.0 ),
	vec3( 0.0170827, 0.0723974, 0.9105199 )
);

// Linear Display P3 => XYZ => Linear sRGB
const mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(
	vec3( 1.2249401, - 0.2249404, 0.0 ),
	vec3( - 0.0420569, 1.0420571, 0.0 ),
	vec3( - 0.0196376, - 0.0786361, 1.0982735 )
);

vec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {
	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );
}

vec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {
	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );
}

vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}

vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}

`,ss=`
#ifdef USE_ENVMAP

	#ifdef ENV_WORLDPOS

		vec3 cameraToFrag;

		if ( isOrthographic ) {

			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );

		} else {

			cameraToFrag = normalize( vWorldPosition - cameraPosition );

		}

		// Transforming Normal Vectors with the Inverse Transformation
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );

		#ifdef ENVMAP_MODE_REFLECTION

			vec3 reflectVec = reflect( cameraToFrag, worldNormal );

		#else

			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );

		#endif

	#else

		vec3 reflectVec = vReflect;

	#endif

	#ifdef ENVMAP_TYPE_CUBE

		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );

	#else

		vec4 envColor = vec4( 0.0 );

	#endif

	#ifdef ENVMAP_BLENDING_MULTIPLY

		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );

	#elif defined( ENVMAP_BLENDING_MIX )

		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );

	#elif defined( ENVMAP_BLENDING_ADD )

		outgoingLight += envColor.xyz * specularStrength * reflectivity;

	#endif

#endif
`,as=`
#ifdef USE_ENVMAP

	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;

	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif
`,ns=`
#ifdef USE_ENVMAP

	uniform float reflectivity;

	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )

		#define ENV_WORLDPOS

	#endif

	#ifdef ENV_WORLDPOS

		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif

#endif
`,os=`
#ifdef USE_ENVMAP

	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )

		#define ENV_WORLDPOS

	#endif

	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;

	#else

		varying vec3 vReflect;
		uniform float refractionRatio;

	#endif

#endif
`,hs=`
#ifdef USE_ENVMAP

	#ifdef ENV_WORLDPOS

		vWorldPosition = worldPosition.xyz;

	#else

		vec3 cameraToVertex;

		if ( isOrthographic ) {

			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );

		} else {

			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );

		}

		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );

		#ifdef ENVMAP_MODE_REFLECTION

			vReflect = reflect( cameraToVertex, worldNormal );

		#else

			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );

		#endif

	#endif

#endif
`,ls=`
#ifdef USE_FOG

	vFogDepth = - mvPosition.z;

#endif
`,cs=`
#ifdef USE_FOG

	varying float vFogDepth;

#endif
`,ds=`
#ifdef USE_FOG

	#ifdef FOG_EXP2

		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );

	#else

		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );

	#endif

	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );

#endif
`,us=`
#ifdef USE_FOG

	uniform vec3 fogColor;
	varying float vFogDepth;

	#ifdef FOG_EXP2

		uniform float fogDensity;

	#else

		uniform float fogNear;
		uniform float fogFar;

	#endif

#endif
`,fs=`

#ifdef USE_GRADIENTMAP

	uniform sampler2D gradientMap;

#endif

vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {

	// dotNL will be from -1.0 to 1.0
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );

	#ifdef USE_GRADIENTMAP

		return vec3( texture2D( gradientMap, coord ).r );

	#else

		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );

	#endif

}
`,ms=`
#ifdef USE_LIGHTMAP

	uniform sampler2D lightMap;
	uniform float lightMapIntensity;

#endif
`,ps=`
LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;
`,vs=`
varying vec3 vViewPosition;

struct LambertMaterial {

	vec3 diffuseColor;
	float specularStrength;

};

void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {

	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = vec3(dotNL) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {

	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert
`,gs=`
uniform bool receiveShadow;
uniform vec3 ambientLightColor;

#if defined( USE_LIGHT_PROBES )

	uniform vec3 lightProbe[ 9 ];

#endif

// get the irradiance (radiance convolved with cosine lobe) at the point 'normal' on the unit sphere
// source: https://graphics.stanford.edu/papers/envmap/envmap.pdf
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {

	// normal is assumed to have unit length

	float x = normal.x, y = normal.y, z = normal.z;

	// band 0
	vec3 result = shCoefficients[ 0 ] * 0.886227;

	// band 1
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;

	// band 2
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );

	return result;

}

vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {

	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );

	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );

	return irradiance;

}

vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {

	vec3 irradiance = ambientLightColor;

	return irradiance;

}

float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {

	// based upon Frostbite 3 Moving to Physically-based Rendering
	// page 32, equation 26: E[window1]
	// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );

	if ( cutoffDistance > 0.0 ) {

		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );

	}

	return distanceFalloff;

}

float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {

	return smoothstep( coneCosine, penumbraCosine, angleCosine );

}

#if NUM_DIR_LIGHTS > 0

	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};

	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];

	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {

		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;

	}

#endif


#if NUM_POINT_LIGHTS > 0

	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};

	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];

	// light is an out parameter as having it as a return value caused compiler errors on some devices
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {

		vec3 lVector = pointLight.position - geometryPosition;

		light.direction = normalize( lVector );

		float lightDistance = length( lVector );

		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );

	}

#endif


#if NUM_SPOT_LIGHTS > 0

	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};

	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];

	// light is an out parameter as having it as a return value caused compiler errors on some devices
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {

		vec3 lVector = spotLight.position - geometryPosition;

		light.direction = normalize( lVector );

		float angleCos = dot( light.direction, spotLight.direction );

		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );

		if ( spotAttenuation > 0.0 ) {

			float lightDistance = length( lVector );

			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );

		} else {

			light.color = vec3( 0.0 );
			light.visible = false;

		}

	}

#endif


#if NUM_RECT_AREA_LIGHTS > 0

	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};

	// Pre-computed values of LinearTransformedCosine approximation of BRDF
	// BRDF approximation Texture is 64x64
	uniform sampler2D ltc_1; // RGBA Float
	uniform sampler2D ltc_2; // RGBA Float

	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];

#endif


#if NUM_HEMI_LIGHTS > 0

	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};

	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];

	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {

		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;

		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );

		return irradiance;

	}

#endif
`,_s=`
#ifdef USE_ENVMAP

	vec3 getIBLIrradiance( const in vec3 normal ) {

		#ifdef ENVMAP_TYPE_CUBE_UV

			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );

			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );

			return PI * envMapColor.rgb * envMapIntensity;

		#else

			return vec3( 0.0 );

		#endif

	}

	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {

		#ifdef ENVMAP_TYPE_CUBE_UV

			vec3 reflectVec = reflect( - viewDir, normal );

			// Mixing the reflection with the normal is more accurate and keeps rough objects from gathering light from behind their tangent plane.
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );

			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );

			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );

			return envMapColor.rgb * envMapIntensity;

		#else

			return vec3( 0.0 );

		#endif

	}

	#ifdef USE_ANISOTROPY

		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {

			#ifdef ENVMAP_TYPE_CUBE_UV

			  // https://google.github.io/filament/Filament.md.html#lighting/imagebasedlights/anisotropy
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );

				return getIBLRadiance( viewDir, bentNormal, roughness );

			#else

				return vec3( 0.0 );

			#endif

		}

	#endif

#endif
`,xs=`
ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;
`,Ms=`
varying vec3 vViewPosition;

struct ToonMaterial {

	vec3 diffuseColor;

};

void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {

	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;

	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {

	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon
`,Ss=`
BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;
`,ws=`
varying vec3 vViewPosition;

struct BlinnPhongMaterial {

	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;

};

void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {

	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;

	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;

}

void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {

	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong
`,ys=`
PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );

vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );

material.roughness = max( roughnessFactor, 0.0525 );// 0.0525 corresponds to the base mip of a 256 cubemap.
material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );

#ifdef IOR

	material.ior = ior;

	#ifdef USE_SPECULAR

		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;

		#ifdef USE_SPECULAR_COLORMAP

			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;

		#endif

		#ifdef USE_SPECULAR_INTENSITYMAP

			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;

		#endif

		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );

	#else

		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;

	#endif

	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );

#else

	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;

#endif

#ifdef USE_CLEARCOAT

	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;

	#ifdef USE_CLEARCOATMAP

		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;

	#endif

	#ifdef USE_CLEARCOAT_ROUGHNESSMAP

		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;

	#endif

	material.clearcoat = saturate( material.clearcoat ); // Burley clearcoat model
	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );

#endif

#ifdef USE_DISPERSION

	material.dispersion = dispersion;

#endif

#ifdef USE_IRIDESCENCE

	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;

	#ifdef USE_IRIDESCENCEMAP

		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;

	#endif

	#ifdef USE_IRIDESCENCE_THICKNESSMAP

		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;

	#else

		material.iridescenceThickness = iridescenceThicknessMaximum;

	#endif

#endif

#ifdef USE_SHEEN

	material.sheenColor = sheenColor;

	#ifdef USE_SHEEN_COLORMAP

		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;

	#endif

	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );

	#ifdef USE_SHEEN_ROUGHNESSMAP

		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;

	#endif

#endif

#ifdef USE_ANISOTROPY

	#ifdef USE_ANISOTROPYMAP

		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;

	#else

		vec2 anisotropyV = anisotropyVector;

	#endif

	material.anisotropy = length( anisotropyV );

	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}

	// Roughness along the anisotropy bitangent is the material roughness, while the tangent roughness increases with anisotropy.
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );

	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;

#endif
`,bs=`

struct PhysicalMaterial {

	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;

	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif

	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif

	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif

	#ifdef IOR
		float ior;
	#endif

	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif

	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif

};

// temporary
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );

vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );

    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}

// Moving Frostbite to Physically Based Rendering 3.0 - page 12, listing 2
// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {

	float a2 = pow2( alpha );

	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );

	return 0.5 / max( gv + gl, EPSILON );

}

// Microfacet Models for Refraction through Rough Surfaces - equation (33)
// http://graphicrants.blogspot.com/2013/08/specular-brdf-reference.html
// alpha is "roughness squared" in Disney’s reparameterization
float D_GGX( const in float alpha, const in float dotNH ) {

	float a2 = pow2( alpha );

	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0; // avoid alpha = 0 with dotNH = 1

	return RECIPROCAL_PI * a2 / pow2( denom );

}

// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
#ifdef USE_ANISOTROPY

	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {

		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );

		return saturate(v);

	}

	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {

		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;

		return RECIPROCAL_PI * a2 * pow2 ( w2 );

	}

#endif

#ifdef USE_CLEARCOAT

	// GGX Distribution, Schlick Fresnel, GGX_SmithCorrelated Visibility
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {

		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;

		float alpha = pow2( roughness ); // UE4's roughness

		vec3 halfDir = normalize( lightDir + viewDir );

		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );

		vec3 F = F_Schlick( f0, f90, dotVH );

		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );

		float D = D_GGX( alpha, dotNH );

		return F * ( V * D );

	}

#endif

vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {

	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;

	float alpha = pow2( roughness ); // UE4's roughness

	vec3 halfDir = normalize( lightDir + viewDir );

	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );

	vec3 F = F_Schlick( f0, f90, dotVH );

	#ifdef USE_IRIDESCENCE

		F = mix( F, material.iridescenceFresnel, material.iridescence );

	#endif

	#ifdef USE_ANISOTROPY

		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );

		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );

		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );

	#else

		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );

		float D = D_GGX( alpha, dotNH );

	#endif

	return F * ( V * D );

}

// Rect Area Light

// Real-Time Polygonal-Light Shading with Linearly Transformed Cosines
// by Eric Heitz, Jonathan Dupuy, Stephen Hill and David Neubelt
// code: https://github.com/selfshadow/ltc_code/

vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {

	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;

	float dotNV = saturate( dot( N, V ) );

	// texture parameterized by sqrt( GGX alpha ) and sqrt( 1 - cos( theta ) )
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );

	uv = uv * LUT_SCALE + LUT_BIAS;

	return uv;

}

float LTC_ClippedSphereFormFactor( const in vec3 f ) {

	// Real-Time Area Lighting: a Journey from Research to Production (p.102)
	// An approximation of the form factor of a horizon-clipped rectangle.

	float l = length( f );

	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );

}

vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {

	float x = dot( v1, v2 );

	float y = abs( x );

	// rational polynomial approximation to theta / sin( theta ) / 2PI
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;

	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;

	return cross( v1, v2 ) * theta_sintheta;

}

vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {

	// bail if point is on back side of plane of light
	// assumes ccw winding order of light vertices
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );

	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );

	// construct orthonormal basis around N
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 ); // negated from paper; possibly due to a different handedness of world coordinate system

	// compute transform
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );

	// transform rect
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );

	// project rect onto sphere
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );

	// calculate vector form factor
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );

	// adjust for horizon clipping
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );

/*
	// alternate method of adjusting for horizon clipping (see referece)
	// refactoring required
	float len = length( vectorFormFactor );
	float z = vectorFormFactor.z / len;

	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;

	// tabulated horizon-clipped sphere, apparently...
	vec2 uv = vec2( z * 0.5 + 0.5, len );
	uv = uv * LUT_SCALE + LUT_BIAS;

	float scale = texture2D( ltc_2, uv ).w;

	float result = len * scale;
*/

	return vec3( result );

}

// End Rect Area Light

#if defined( USE_SHEEN )

// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
float D_Charlie( float roughness, float dotNH ) {

	float alpha = pow2( roughness );

	// Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF"
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 ); // 2^(-14/2), so sin2h^2 > 0 in fp16

	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );

}

// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
float V_Neubelt( float dotNV, float dotNL ) {

	// Neubelt and Pettineo 2013, "Crafting a Next-gen Material Pipeline for The Order: 1886"
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );

}

vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {

	vec3 halfDir = normalize( lightDir + viewDir );

	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );

	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );

	return sheenColor * ( D * V );

}

#endif

// This is a curve-fit approxmation to the "Charlie sheen" BRDF integrated over the hemisphere from 
// Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF". The analysis can be found
// in the Sheen section of https://drive.google.com/file/d/1T0D1VSyR4AllqIJTQAraEIzjlb5h4FKH/view?usp=sharing
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {

	float dotNV = saturate( dot( normal, viewDir ) );

	float r2 = roughness * roughness;

	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;

	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;

	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );

	return saturate( DG * RECIPROCAL_PI );

}

// Analytical approximation of the DFG LUT, one half of the
// split-sum approximation used in indirect specular lighting.
// via 'environmentBRDF' from "Physically Based Shading on Mobile"
// https://www.unrealengine.com/blog/physically-based-shading-on-mobile
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {

	float dotNV = saturate( dot( normal, viewDir ) );

	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );

	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );

	vec4 r = roughness * c0 + c1;

	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;

	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;

	return fab;

}

vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {

	vec2 fab = DFGApprox( normal, viewDir, roughness );

	return specularColor * fab.x + specularF90 * fab.y;

}

// Fdez-Agüera's "Multiple-Scattering Microfacet Model for Real-Time Image Based Lighting"
// Approximates multiscattering in order to preserve energy.
// http://www.jcgt.org/published/0008/01/03/
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif

	vec2 fab = DFGApprox( normal, viewDir, roughness );

	#ifdef USE_IRIDESCENCE

		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );

	#else

		vec3 Fr = specularColor;

	#endif

	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;

	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;

	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619; // 1/21
	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );

	singleScatter += FssEss;
	multiScatter += Fms * Ems;

}

#if NUM_RECT_AREA_LIGHTS > 0

	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {

		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;

		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight; // counterclockwise; light shines in local neg z direction
		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;

		vec2 uv = LTC_Uv( normal, viewDir, roughness );

		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );

		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);

		// LTC Fresnel Approximation by Stephen Hill
		// http://blog.selfshadow.com/publications/s2016-advances/s2016_ltc_fresnel.pdf
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );

		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );

		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );

	}

#endif

void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {

	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );

	vec3 irradiance = dotNL * directLight.color;

	#ifdef USE_CLEARCOAT

		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );

		vec3 ccIrradiance = dotNLcc * directLight.color;

		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );

	#endif

	#ifdef USE_SHEEN

		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );

	#endif

	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );

	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}

void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {

	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {

	#ifdef USE_CLEARCOAT

		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );

	#endif

	#ifdef USE_SHEEN

		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );

	#endif

	// Both indirect specular and indirect diffuse light accumulate here

	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;

	#ifdef USE_IRIDESCENCE

		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );

	#else

		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );

	#endif

	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );

	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;

	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;

}

#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical

// ref: https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {

	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );

}
`,Es=`
/**
 * This is a template that can be used to light a material, it uses pluggable
 * RenderEquations (RE)for specific lighting scenarios.
 *
 * Instructions for use:
 * - Ensure that both RE_Direct, RE_IndirectDiffuse and RE_IndirectSpecular are defined
 * - Create a material parameter that is to be passed as the third parameter to your lighting functions.
 *
 * TODO:
 * - Add area light support.
 * - Add sphere light support.
 * - Add diffuse light probe (irradiance cubemap) support.
 */

vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );

vec3 geometryClearcoatNormal = vec3( 0.0 );

#ifdef USE_CLEARCOAT

	geometryClearcoatNormal = clearcoatNormal;

#endif

#ifdef USE_IRIDESCENCE

	float dotNVi = saturate( dot( normal, geometryViewDir ) );

	if ( material.iridescenceThickness == 0.0 ) {

		material.iridescence = 0.0;

	} else {

		material.iridescence = saturate( material.iridescence );

	}

	if ( material.iridescence > 0.0 ) {

		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );

		// Iridescence F0 approximation
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );

	}

#endif

IncidentLight directLight;

#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )

	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {

		pointLight = pointLights[ i ];

		getPointLightInfo( pointLight, geometryPosition, directLight );

		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif

		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )

	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;

	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {

		spotLight = spotLights[ i ];

		getSpotLightInfo( spotLight, geometryPosition, directLight );

		// spot lights are ordered [shadows with maps, shadows without maps, maps without shadows, none]
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif

		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif

		#undef SPOT_LIGHT_MAP_INDEX

		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif

		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )

	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {

		directionalLight = directionalLights[ i ];

		getDirectionalLightInfo( directionalLight, directLight );

		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif

		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )

	RectAreaLight rectAreaLight;

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {

		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if defined( RE_IndirectDiffuse )

	vec3 iblIrradiance = vec3( 0.0 );

	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );

	#if defined( USE_LIGHT_PROBES )

		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );

	#endif

	#if ( NUM_HEMI_LIGHTS > 0 )

		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {

			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );

		}
		#pragma unroll_loop_end

	#endif

#endif

#if defined( RE_IndirectSpecular )

	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );

#endif
`,Cs=`
#if defined( RE_IndirectDiffuse )

	#ifdef USE_LIGHTMAP

		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;

		irradiance += lightMapIrradiance;

	#endif

	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )

		iblIrradiance += getIBLIrradiance( geometryNormal );

	#endif

#endif

#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )

	#ifdef USE_ANISOTROPY

		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );

	#else

		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );

	#endif

	#ifdef USE_CLEARCOAT

		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );

	#endif

#endif
`,Ls=`
#if defined( RE_IndirectDiffuse )

	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );

#endif

#if defined( RE_IndirectSpecular )

	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );

#endif
`,Ts=`
#if defined( USE_LOGDEPTHBUF )

	// Doing a strict comparison with == 1.0 can cause noise artifacts
	// on some platforms. See issue #17623.
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;

#endif
`,As=`
#if defined( USE_LOGDEPTHBUF )

	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;

#endif
`,Ps=`
#ifdef USE_LOGDEPTHBUF

	varying float vFragDepth;
	varying float vIsPerspective;

#endif
`,Ns=`
#ifdef USE_LOGDEPTHBUF

	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );

#endif
`,Ds=`
#ifdef USE_MAP

	vec4 sampledDiffuseColor = texture2D( map, vMapUv );

	#ifdef DECODE_VIDEO_TEXTURE

		// use inline sRGB decode until browsers properly support SRGB8_ALPHA8 with video textures (#26516)

		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );

	#endif

	diffuseColor *= sampledDiffuseColor;

#endif
`,Rs=`
#ifdef USE_MAP

	uniform sampler2D map;

#endif
`,Is=`
#if defined( USE_MAP ) || defined( USE_ALPHAMAP )

	#if defined( USE_POINTS_UV )

		vec2 uv = vUv;

	#else

		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;

	#endif

#endif

#ifdef USE_MAP

	diffuseColor *= texture2D( map, uv );

#endif

#ifdef USE_ALPHAMAP

	diffuseColor.a *= texture2D( alphaMap, uv ).g;

#endif
`,Us=`
#if defined( USE_POINTS_UV )

	varying vec2 vUv;

#else

	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )

		uniform mat3 uvTransform;

	#endif

#endif

#ifdef USE_MAP

	uniform sampler2D map;

#endif

#ifdef USE_ALPHAMAP

	uniform sampler2D alphaMap;

#endif
`,Os=`
float metalnessFactor = metalness;

#ifdef USE_METALNESSMAP

	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );

	// reads channel B, compatible with a combined OcclusionRoughnessMetallic (RGB) texture
	metalnessFactor *= texelMetalness.b;

#endif
`,Fs=`
#ifdef USE_METALNESSMAP

	uniform sampler2D metalnessMap;

#endif
`,Hs=`
#ifdef USE_INSTANCING_MORPH

	float morphTargetInfluences[ MORPHTARGETS_COUNT ];

	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;

	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;

	}
#endif
`,Vs=`
#if defined( USE_MORPHCOLORS )

	// morphTargetBaseInfluence is set based on BufferGeometry.morphTargetsRelative value:
	// When morphTargetsRelative is false, this is set to 1 - sum(influences); this results in normal = sum((target - base) * influence)
	// When morphTargetsRelative is true, this is set to 1; as a result, all morph targets are simply added to the base after weighting
	vColor *= morphTargetBaseInfluence;

	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

		#if defined( USE_COLOR_ALPHA )

			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];

		#elif defined( USE_COLOR )

			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];

		#endif

	}

#endif
`,Gs=`
#ifdef USE_MORPHNORMALS

	// morphTargetBaseInfluence is set based on BufferGeometry.morphTargetsRelative value:
	// When morphTargetsRelative is false, this is set to 1 - sum(influences); this results in normal = sum((target - base) * influence)
	// When morphTargetsRelative is true, this is set to 1; as a result, all morph targets are simply added to the base after weighting
	objectNormal *= morphTargetBaseInfluence;

	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];

	}

#endif
`,ks=`
#ifdef USE_MORPHTARGETS

	#ifndef USE_INSTANCING_MORPH

		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];

	#endif

	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;

	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {

		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;

		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );

	}

#endif
`,zs=`
#ifdef USE_MORPHTARGETS

	// morphTargetBaseInfluence is set based on BufferGeometry.morphTargetsRelative value:
	// When morphTargetsRelative is false, this is set to 1 - sum(influences); this results in position = sum((target - base) * influence)
	// When morphTargetsRelative is true, this is set to 1; as a result, all morph targets are simply added to the base after weighting
	transformed *= morphTargetBaseInfluence;

	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];

	}

#endif
`,Bs=`
float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;

#ifdef FLAT_SHADED

	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );

#else

	vec3 normal = normalize( vNormal );

	#ifdef DOUBLE_SIDED

		normal *= faceDirection;

	#endif

#endif

#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )

	#ifdef USE_TANGENT

		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );

	#else

		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);

	#endif

	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )

		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;

	#endif

#endif

#ifdef USE_CLEARCOAT_NORMALMAP

	#ifdef USE_TANGENT

		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );

	#else

		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );

	#endif

	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )

		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;

	#endif

#endif

// non perturbed normal for clearcoat among others

vec3 nonPerturbedNormal = normal;

`,Ws=`

#ifdef USE_NORMALMAP_OBJECTSPACE

	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0; // overrides both flatShading and attribute normals

	#ifdef FLIP_SIDED

		normal = - normal;

	#endif

	#ifdef DOUBLE_SIDED

		normal = normal * faceDirection;

	#endif

	normal = normalize( normalMatrix * normal );

#elif defined( USE_NORMALMAP_TANGENTSPACE )

	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;

	normal = normalize( tbn * mapN );

#elif defined( USE_BUMPMAP )

	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );

#endif
`,Ys=`
#ifndef FLAT_SHADED

	varying vec3 vNormal;

	#ifdef USE_TANGENT

		varying vec3 vTangent;
		varying vec3 vBitangent;

	#endif

#endif
`,Xs=`
#ifndef FLAT_SHADED

	varying vec3 vNormal;

	#ifdef USE_TANGENT

		varying vec3 vTangent;
		varying vec3 vBitangent;

	#endif

#endif
`,js=`
#ifndef FLAT_SHADED // normal is computed with derivatives when FLAT_SHADED

	vNormal = normalize( transformedNormal );

	#ifdef USE_TANGENT

		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );

	#endif

#endif
`,qs=`
#ifdef USE_NORMALMAP

	uniform sampler2D normalMap;
	uniform vec2 normalScale;

#endif

#ifdef USE_NORMALMAP_OBJECTSPACE

	uniform mat3 normalMatrix;

#endif

#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )

	// Normal Mapping Without Precomputed Tangents
	// http://www.thetenthplanet.de/archives/1180

	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {

		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );

		vec3 N = surf_norm; // normalized

		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );

		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;

		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );

		return mat3( T * scale, B * scale, N );

	}

#endif
`,Zs=`
#ifdef USE_CLEARCOAT

	vec3 clearcoatNormal = nonPerturbedNormal;

#endif
`,Js=`
#ifdef USE_CLEARCOAT_NORMALMAP

	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;

	clearcoatNormal = normalize( tbn2 * clearcoatMapN );

#endif
`,Ks=`

#ifdef USE_CLEARCOATMAP

	uniform sampler2D clearcoatMap;

#endif

#ifdef USE_CLEARCOAT_NORMALMAP

	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;

#endif

#ifdef USE_CLEARCOAT_ROUGHNESSMAP

	uniform sampler2D clearcoatRoughnessMap;

#endif
`,Qs=`

#ifdef USE_IRIDESCENCEMAP

	uniform sampler2D iridescenceMap;

#endif

#ifdef USE_IRIDESCENCE_THICKNESSMAP

	uniform sampler2D iridescenceThicknessMap;

#endif
`,$s=`
#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif

#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif

gl_FragColor = vec4( outgoingLight, diffuseColor.a );
`,ea=`
vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}

vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}

const float PackUpscale = 256. / 255.; // fraction -> 0..1 (including 1)
const float UnpackDownscale = 255. / 256.; // 0..1 -> fraction (excluding 1)
const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;

const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );

const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );

vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}

vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	// the 0.9999 tweak is unimportant, very tiny empirical improvement
	// return vec3( vuf * Inv255, gf * PackUpscale, bf * 0.9999 );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}

vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}

float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}

float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}

float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}

vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}

vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}

// NOTE: viewZ, the z-coordinate in camera space, is negative for points in front of the camera

float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	// -near maps to 0; -far maps to 1
	return ( viewZ + near ) / ( near - far );
}

float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	// maps orthographic depth in [ 0, 1 ] to viewZ
	return depth * ( near - far ) - near;
}

// NOTE: https://twitter.com/gonnavis/status/1377183786949959682

float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	// -near maps to 0; -far maps to 1
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}

float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	// maps perspective depth in [ 0, 1 ] to viewZ
	return ( near * far ) / ( ( far - near ) * depth - far );
}
`,ta=`
#ifdef PREMULTIPLIED_ALPHA

	// Get get normal blending with premultipled, use with CustomBlending, OneFactor, OneMinusSrcAlphaFactor, AddEquation.
	gl_FragColor.rgb *= gl_FragColor.a;

#endif
`,ia=`
vec4 mvPosition = vec4( transformed, 1.0 );

#ifdef USE_BATCHING

	mvPosition = batchingMatrix * mvPosition;

#endif

#ifdef USE_INSTANCING

	mvPosition = instanceMatrix * mvPosition;

#endif

mvPosition = modelViewMatrix * mvPosition;

gl_Position = projectionMatrix * mvPosition;
`,ra=`
#ifdef DITHERING

	gl_FragColor.rgb = dithering( gl_FragColor.rgb );

#endif
`,sa=`
#ifdef DITHERING

	// based on https://www.shadertoy.com/view/MslGR8
	vec3 dithering( vec3 color ) {
		//Calculate grid position
		float grid_position = rand( gl_FragCoord.xy );

		//Shift the individual colors differently, thus making it even harder to see the dithering pattern
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );

		//modify shift according to grid position.
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );

		//shift the color by dither_shift
		return color + dither_shift_RGB;
	}

#endif
`,aa=`
float roughnessFactor = roughness;

#ifdef USE_ROUGHNESSMAP

	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );

	// reads channel G, compatible with a combined OcclusionRoughnessMetallic (RGB) texture
	roughnessFactor *= texelRoughness.g;

#endif
`,na=`
#ifdef USE_ROUGHNESSMAP

	uniform sampler2D roughnessMap;

#endif
`,oa=`
#if NUM_SPOT_LIGHT_COORDS > 0

	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];

#endif

#if NUM_SPOT_LIGHT_MAPS > 0

	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];

#endif

#ifdef USE_SHADOWMAP

	#if NUM_DIR_LIGHT_SHADOWS > 0

		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];

		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};

		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];

	#endif

	#if NUM_SPOT_LIGHT_SHADOWS > 0

		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];

		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};

		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];

	#endif

	#if NUM_POINT_LIGHT_SHADOWS > 0

		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];

		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};

		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];

	#endif

	/*
	#if NUM_RECT_AREA_LIGHTS > 0

		// TODO (abelnation): create uniforms for area light shadows

	#endif
	*/

	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {

		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );

	}

	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {

		return unpackRGBATo2Half( texture2D( shadow, uv ) );

	}

	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){

		float occlusion = 1.0;

		vec2 distribution = texture2DDistribution( shadow, uv );

		float hard_shadow = step( compare , distribution.x ); // Hard Shadow

		if (hard_shadow != 1.0 ) {

			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance ); // Chebeyshevs inequality
			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 ); // 0.3 reduces light bleed
			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );

		}
		return occlusion;

	}

	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {

		float shadow = 1.0;

		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;

		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;

		if ( frustumTest ) {

		#if defined( SHADOWMAP_TYPE_PCF )

			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;

			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;

			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );

		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )

			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;

			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;

			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );

		#elif defined( SHADOWMAP_TYPE_VSM )

			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );

		#else // no percentage-closer filtering:

			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );

		#endif

		}

		return mix( 1.0, shadow, shadowIntensity );

	}

	// cubeToUV() maps a 3D direction vector suitable for cube texture mapping to a 2D
	// vector suitable for 2D texture mapping. This code uses the following layout for the
	// 2D texture:
	//
	// xzXZ
	//  y Y
	//
	// Y - Positive y direction
	// y - Negative y direction
	// X - Positive x direction
	// x - Negative x direction
	// Z - Positive z direction
	// z - Negative z direction
	//
	// Source and test bed:
	// https://gist.github.com/tschw/da10c43c467ce8afd0c4

	vec2 cubeToUV( vec3 v, float texelSizeY ) {

		// Number of texels to avoid at the edge of each square

		vec3 absV = abs( v );

		// Intersect unit cube

		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;

		// Apply scale to avoid seams

		// two texels less per square (one texel will do for NEAREST)
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );

		// Unwrap

		// space: -1 ... 1 range for each square
		//
		// #X##		dim    := ( 4 , 2 )
		//  # #		center := ( 1 , 1 )

		vec2 planar = v.xy;

		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;

		if ( absV.z >= almostOne ) {

			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;

		} else if ( absV.x >= almostOne ) {

			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;

		} else if ( absV.y >= almostOne ) {

			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;

		}

		// Transform to UV space

		// scale := 0.5 / dim
		// translate := ( center + 0.5 ) / dim
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );

	}

	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {

		float shadow = 1.0;

		// for point lights, the uniform @vShadowCoord is re-purposed to hold
		// the vector from the light to the world-space position of the fragment.
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );

		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {

			// dp = normalized distance from light to fragment position
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear ); // need to clamp?
			dp += shadowBias;

			// bd3D = base direction 3D
			vec3 bd3D = normalize( lightToPosition );

			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );

			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )

				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;

				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );

			#else // no percentage-closer filtering

				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );

			#endif

		}

		return mix( 1.0, shadow, shadowIntensity );

	}

#endif
`,ha=`

#if NUM_SPOT_LIGHT_COORDS > 0

	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];

#endif

#ifdef USE_SHADOWMAP

	#if NUM_DIR_LIGHT_SHADOWS > 0

		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];

		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};

		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];

	#endif

	#if NUM_SPOT_LIGHT_SHADOWS > 0

		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};

		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];

	#endif

	#if NUM_POINT_LIGHT_SHADOWS > 0

		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];

		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};

		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];

	#endif

	/*
	#if NUM_RECT_AREA_LIGHTS > 0

		// TODO (abelnation): uniforms for area light shadows

	#endif
	*/

#endif
`,la=`

#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )

	// Offsetting the position used for querying occlusion along the world normal can be used to reduce shadow acne.
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;

#endif

#if defined( USE_SHADOWMAP )

	#if NUM_DIR_LIGHT_SHADOWS > 0

		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {

			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;

		}
		#pragma unroll_loop_end

	#endif

	#if NUM_POINT_LIGHT_SHADOWS > 0

		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {

			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;

		}
		#pragma unroll_loop_end

	#endif

	/*
	#if NUM_RECT_AREA_LIGHTS > 0

		// TODO (abelnation): update vAreaShadowCoord with area light info

	#endif
	*/

#endif

// spot lights can be evaluated without active shadow mapping (when SpotLight.map is used)

#if NUM_SPOT_LIGHT_COORDS > 0

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {

		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;

	}
	#pragma unroll_loop_end

#endif


`,ca=`
float getShadowMask() {

	float shadow = 1.0;

	#ifdef USE_SHADOWMAP

	#if NUM_DIR_LIGHT_SHADOWS > 0

	DirectionalLightShadow directionalLight;

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {

		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;

	}
	#pragma unroll_loop_end

	#endif

	#if NUM_SPOT_LIGHT_SHADOWS > 0

	SpotLightShadow spotLight;

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {

		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;

	}
	#pragma unroll_loop_end

	#endif

	#if NUM_POINT_LIGHT_SHADOWS > 0

	PointLightShadow pointLight;

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {

		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;

	}
	#pragma unroll_loop_end

	#endif

	/*
	#if NUM_RECT_AREA_LIGHTS > 0

		// TODO (abelnation): update shadow for Area light

	#endif
	*/

	#endif

	return shadow;

}
`,da=`
#ifdef USE_SKINNING

	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );

#endif
`,ua=`
#ifdef USE_SKINNING

	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;

	uniform highp sampler2D boneTexture;

	mat4 getBoneMatrix( const in float i ) {

		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );

		return mat4( v1, v2, v3, v4 );

	}

#endif
`,fa=`
#ifdef USE_SKINNING

	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );

	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;

	transformed = ( bindMatrixInverse * skinned ).xyz;

#endif
`,ma=`
#ifdef USE_SKINNING

	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;

	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;

	#ifdef USE_TANGENT

		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;

	#endif

#endif
`,pa=`
float specularStrength;

#ifdef USE_SPECULARMAP

	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;

#else

	specularStrength = 1.0;

#endif
`,va=`
#ifdef USE_SPECULARMAP

	uniform sampler2D specularMap;

#endif
`,ga=`
#if defined( TONE_MAPPING )

	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );

#endif
`,_a=`
#ifndef saturate
// <common> may have defined saturate() already
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif

uniform float toneMappingExposure;

// exposure only
vec3 LinearToneMapping( vec3 color ) {

	return saturate( toneMappingExposure * color );

}

// source: https://www.cs.utah.edu/docs/techreports/2002/pdf/UUCS-02-001.pdf
vec3 ReinhardToneMapping( vec3 color ) {

	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );

}

// source: http://filmicworlds.com/blog/filmic-tonemapping-operators/
vec3 CineonToneMapping( vec3 color ) {

	// filmic operator by Jim Hejl and Richard Burgess-Dawson
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );

}

// source: https://github.com/selfshadow/ltc_code/blob/master/webgl/shaders/ltc/ltc_blit.fs
vec3 RRTAndODTFit( vec3 v ) {

	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;

}

// this implementation of ACES is modified to accommodate a brighter viewing environment.
// the scale factor of 1/0.6 is subjective. see discussion in #19621.

vec3 ACESFilmicToneMapping( vec3 color ) {

	// sRGB => XYZ => D65_2_D60 => AP1 => RRT_SAT
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ), // transposed from source
		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);

	// ODT_SAT => XYZ => D60_2_D65 => sRGB
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ), // transposed from source
		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);

	color *= toneMappingExposure / 0.6;

	color = ACESInputMat * color;

	// Apply RRT and ODT
	color = RRTAndODTFit( color );

	color = ACESOutputMat * color;

	// Clamp to [0, 1]
	return saturate( color );

}

// Matrices for rec 2020 <> rec 709 color space conversion
// matrix provided in row-major order so it has been transposed
// https://www.itu.int/pub/R-REP-BT.2407-2017
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);

const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);

// https://iolite-engine.com/blog_posts/minimal_agx_implementation
// Mean error^2: 3.6705141e-06
vec3 agxDefaultContrastApprox( vec3 x ) {

	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;

	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;

}

// AgX Tone Mapping implementation based on Filament, which in turn is based
// on Blender's implementation using rec 2020 primaries
// https://github.com/google/filament/pull/7236
// Inputs and outputs are encoded as Linear-sRGB.

vec3 AgXToneMapping( vec3 color ) {

	// AgX constants
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);

	// explicit AgXOutsetMatrix generated from Filaments AgXOutsetMatrixInv
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);

	// LOG2_MIN      = -10.0
	// LOG2_MAX      =  +6.5
	// MIDDLE_GRAY   =  0.18
	const float AgxMinEv = - 12.47393;  // log2( pow( 2, LOG2_MIN ) * MIDDLE_GRAY )
	const float AgxMaxEv = 4.026069;    // log2( pow( 2, LOG2_MAX ) * MIDDLE_GRAY )

	color *= toneMappingExposure;

	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;

	color = AgXInsetMatrix * color;

	// Log2 encoding
	color = max( color, 1e-10 ); // avoid 0 or negative numbers for log2
	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );

	color = clamp( color, 0.0, 1.0 );

	// Apply sigmoid
	color = agxDefaultContrastApprox( color );

	// Apply AgX look
	// v = agxLook(v, look);

	color = AgXOutsetMatrix * color;

	// Linearize
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );

	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;

	// Gamut mapping. Simple clamp for now.
	color = clamp( color, 0.0, 1.0 );

	return color;

}

// https://modelviewer.dev/examples/tone-mapping

vec3 NeutralToneMapping( vec3 color ) {

	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;

	color *= toneMappingExposure;

	float x = min( color.r, min( color.g, color.b ) );

	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;

	color -= offset;

	float peak = max( color.r, max( color.g, color.b ) );

	if ( peak < StartCompression ) return color;

	float d = 1. - StartCompression;

	float newPeak = 1. - d * d / ( peak + d - StartCompression );

	color *= newPeak / peak;

	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );

	return mix( color, vec3( newPeak ), g );

}

vec3 CustomToneMapping( vec3 color ) { return color; }
`,xa=`
#ifdef USE_TRANSMISSION

	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;

	#ifdef USE_TRANSMISSIONMAP

		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;

	#endif

	#ifdef USE_THICKNESSMAP

		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;

	#endif

	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );

	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );

	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );

	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );

#endif
`,Ma=`
#ifdef USE_TRANSMISSION

	// Transmission code is based on glTF-Sampler-Viewer
	// https://github.com/KhronosGroup/glTF-Sample-Viewer

	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;

	#ifdef USE_TRANSMISSIONMAP

		uniform sampler2D transmissionMap;

	#endif

	#ifdef USE_THICKNESSMAP

		uniform sampler2D thicknessMap;

	#endif

	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;

	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;

	varying vec3 vWorldPosition;

	// Mipped Bicubic Texture Filtering by N8
	// https://www.shadertoy.com/view/Dl2SDW

	float w0( float a ) {

		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );

	}

	float w1( float a ) {

		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );

	}

	float w2( float a ){

		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );

	}

	float w3( float a ) {

		return ( 1.0 / 6.0 ) * ( a * a * a );

	}

	// g0 and g1 are the two amplitude functions
	float g0( float a ) {

		return w0( a ) + w1( a );

	}

	float g1( float a ) {

		return w2( a ) + w3( a );

	}

	// h0 and h1 are the two offset functions
	float h0( float a ) {

		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );

	}

	float h1( float a ) {

		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );

	}

	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {

		uv = uv * texelSize.zw + 0.5;

		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );

		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );

		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;

		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );

	}

	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {

		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );

	}

	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {

		// Direction of refracted light.
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );

		// Compute rotation-independant scaling of the model matrix.
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );

		// The thickness is specified in local space.
		return normalize( refractionVector ) * thickness * modelScale;

	}

	float applyIorToRoughness( const in float roughness, const in float ior ) {

		// Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
		// an IOR of 1.5 results in the default amount of microfacet refraction.
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );

	}

	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {

		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );

	}

	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {

		if ( isinf( attenuationDistance ) ) {

			// Attenuation distance is +∞, i.e. the transmitted color is not attenuated at all.
			return vec3( 1.0 );

		} else {

			// Compute light attenuation using Beer's law.
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance ); // Beer's law
			return transmittance;

		}

	}

	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {

		vec4 transmittedLight;
		vec3 transmittance;

		#ifdef USE_DISPERSION

			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );

			for ( int i = 0; i < 3; i ++ ) {

				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
		
				// Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
		
				// Sample framebuffer to get pixel the refracted ray hits.
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;

				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];

			}

			transmittedLight.a /= 3.0;
		
		#else
		
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;

			// Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;

			// Sample framebuffer to get pixel the refracted ray hits.
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		
		#endif

		vec3 attenuatedColor = transmittance * transmittedLight.rgb;

		// Get the specular component.
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );

		// As less light is transmitted, the opacity should be increased. This simple approximation does a decent job 
		// of modulating a CSS background, and has no effect when the buffer is opaque, due to a solid object or clear color.
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;

		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );

	}
#endif
`,Sa=`
#if defined( USE_UV ) || defined( USE_ANISOTROPY )

	varying vec2 vUv;

#endif
#ifdef USE_MAP

	varying vec2 vMapUv;

#endif
#ifdef USE_ALPHAMAP

	varying vec2 vAlphaMapUv;

#endif
#ifdef USE_LIGHTMAP

	varying vec2 vLightMapUv;

#endif
#ifdef USE_AOMAP

	varying vec2 vAoMapUv;

#endif
#ifdef USE_BUMPMAP

	varying vec2 vBumpMapUv;

#endif
#ifdef USE_NORMALMAP

	varying vec2 vNormalMapUv;

#endif
#ifdef USE_EMISSIVEMAP

	varying vec2 vEmissiveMapUv;

#endif
#ifdef USE_METALNESSMAP

	varying vec2 vMetalnessMapUv;

#endif
#ifdef USE_ROUGHNESSMAP

	varying vec2 vRoughnessMapUv;

#endif
#ifdef USE_ANISOTROPYMAP

	varying vec2 vAnisotropyMapUv;

#endif
#ifdef USE_CLEARCOATMAP

	varying vec2 vClearcoatMapUv;

#endif
#ifdef USE_CLEARCOAT_NORMALMAP

	varying vec2 vClearcoatNormalMapUv;

#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP

	varying vec2 vClearcoatRoughnessMapUv;

#endif
#ifdef USE_IRIDESCENCEMAP

	varying vec2 vIridescenceMapUv;

#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP

	varying vec2 vIridescenceThicknessMapUv;

#endif
#ifdef USE_SHEEN_COLORMAP

	varying vec2 vSheenColorMapUv;

#endif
#ifdef USE_SHEEN_ROUGHNESSMAP

	varying vec2 vSheenRoughnessMapUv;

#endif
#ifdef USE_SPECULARMAP

	varying vec2 vSpecularMapUv;

#endif
#ifdef USE_SPECULAR_COLORMAP

	varying vec2 vSpecularColorMapUv;

#endif
#ifdef USE_SPECULAR_INTENSITYMAP

	varying vec2 vSpecularIntensityMapUv;

#endif
#ifdef USE_TRANSMISSIONMAP

	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;

#endif
#ifdef USE_THICKNESSMAP

	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;

#endif
`,wa=`
#if defined( USE_UV ) || defined( USE_ANISOTROPY )

	varying vec2 vUv;

#endif
#ifdef USE_MAP

	uniform mat3 mapTransform;
	varying vec2 vMapUv;

#endif
#ifdef USE_ALPHAMAP

	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;

#endif
#ifdef USE_LIGHTMAP

	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;

#endif
#ifdef USE_AOMAP

	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;

#endif
#ifdef USE_BUMPMAP

	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;

#endif
#ifdef USE_NORMALMAP

	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;

#endif
#ifdef USE_DISPLACEMENTMAP

	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;

#endif
#ifdef USE_EMISSIVEMAP

	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;

#endif
#ifdef USE_METALNESSMAP

	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;

#endif
#ifdef USE_ROUGHNESSMAP

	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;

#endif
#ifdef USE_ANISOTROPYMAP

	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;

#endif
#ifdef USE_CLEARCOATMAP

	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;

#endif
#ifdef USE_CLEARCOAT_NORMALMAP

	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;

#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP

	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;

#endif
#ifdef USE_SHEEN_COLORMAP

	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;

#endif
#ifdef USE_SHEEN_ROUGHNESSMAP

	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;

#endif
#ifdef USE_IRIDESCENCEMAP

	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;

#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP

	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;

#endif
#ifdef USE_SPECULARMAP

	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;

#endif
#ifdef USE_SPECULAR_COLORMAP

	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;

#endif
#ifdef USE_SPECULAR_INTENSITYMAP

	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;

#endif
#ifdef USE_TRANSMISSIONMAP

	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;

#endif
#ifdef USE_THICKNESSMAP

	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;

#endif
`,ya=`
#if defined( USE_UV ) || defined( USE_ANISOTROPY )

	vUv = vec3( uv, 1 ).xy;

#endif
#ifdef USE_MAP

	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;

#endif
#ifdef USE_ALPHAMAP

	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_LIGHTMAP

	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_AOMAP

	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_BUMPMAP

	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_NORMALMAP

	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_DISPLACEMENTMAP

	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_EMISSIVEMAP

	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_METALNESSMAP

	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_ROUGHNESSMAP

	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_ANISOTROPYMAP

	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_CLEARCOATMAP

	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_CLEARCOAT_NORMALMAP

	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP

	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_IRIDESCENCEMAP

	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP

	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_SHEEN_COLORMAP

	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_SHEEN_ROUGHNESSMAP

	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_SPECULARMAP

	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_SPECULAR_COLORMAP

	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_SPECULAR_INTENSITYMAP

	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_TRANSMISSIONMAP

	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;

#endif
#ifdef USE_THICKNESSMAP

	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;

#endif
`,ba=`
#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0

	vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_BATCHING

		worldPosition = batchingMatrix * worldPosition;

	#endif

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif

	worldPosition = modelMatrix * worldPosition;

#endif
`;let Ea=`
varying vec2 vUv;
uniform mat3 uvTransform;

void main() {

	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;

	gl_Position = vec4( position.xy, 1.0, 1.0 );

}
`,Ca=`
uniform sampler2D t2D;
uniform float backgroundIntensity;

varying vec2 vUv;

void main() {

	vec4 texColor = texture2D( t2D, vUv );

	#ifdef DECODE_VIDEO_TEXTURE

		// use inline sRGB decode until browsers properly support SRGB8_APLHA8 with video textures

		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );

	#endif

	texColor.rgb *= backgroundIntensity;

	gl_FragColor = texColor;

	#include <tonemapping_fragment>
	#include <colorspace_fragment>

}
`,La=`
varying vec3 vWorldDirection;

#include <common>

void main() {

	vWorldDirection = transformDirection( position, modelMatrix );

	#include <begin_vertex>
	#include <project_vertex>

	gl_Position.z = gl_Position.w; // set z to camera.far

}
`,Ta=`

#ifdef ENVMAP_TYPE_CUBE

	uniform samplerCube envMap;

#elif defined( ENVMAP_TYPE_CUBE_UV )

	uniform sampler2D envMap;

#endif

uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;

varying vec3 vWorldDirection;

#include <cube_uv_reflection_fragment>

void main() {

	#ifdef ENVMAP_TYPE_CUBE

		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );

	#elif defined( ENVMAP_TYPE_CUBE_UV )

		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );

	#else

		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );

	#endif

	texColor.rgb *= backgroundIntensity;

	gl_FragColor = texColor;

	#include <tonemapping_fragment>
	#include <colorspace_fragment>

}
`,Aa=`
varying vec3 vWorldDirection;

#include <common>

void main() {

	vWorldDirection = transformDirection( position, modelMatrix );

	#include <begin_vertex>
	#include <project_vertex>

	gl_Position.z = gl_Position.w; // set z to camera.far

}
`,Pa=`
uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;

varying vec3 vWorldDirection;

void main() {

	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );

	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;

	#include <tonemapping_fragment>
	#include <colorspace_fragment>

}
`,Na=`
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

// This is used for computing an equivalent of gl_FragCoord.z that is as high precision as possible.
// Some platforms compute gl_FragCoord at a lower precision which makes the manually computed value better for
// depth-based postprocessing effects. Reproduced on iPad with A10 processor / iPadOS 13.3.1.
varying vec2 vHighPrecisionZW;

void main() {

	#include <uv_vertex>

	#include <batching_vertex>
	#include <skinbase_vertex>

	#include <morphinstance_vertex>

	#ifdef USE_DISPLACEMENTMAP

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	vHighPrecisionZW = gl_Position.zw;

}
`,Da=`
#if DEPTH_PACKING == 3200

	uniform float opacity;

#endif

#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

varying vec2 vHighPrecisionZW;

void main() {

	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>

	#if DEPTH_PACKING == 3200

		diffuseColor.a = opacity;

	#endif

	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>

	#include <logdepthbuf_fragment>

	// Higher precision equivalent of gl_FragCoord.z. This assumes depthRange has been left to its default values.
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;

	#if DEPTH_PACKING == 3200

		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );

	#elif DEPTH_PACKING == 3201

		gl_FragColor = packDepthToRGBA( fragCoordZ );

	#elif DEPTH_PACKING == 3202

		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );

	#elif DEPTH_PACKING == 3203

		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );

	#endif

}
`,Ra=`
#define DISTANCE

varying vec3 vWorldPosition;

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>

	#include <batching_vertex>
	#include <skinbase_vertex>

	#include <morphinstance_vertex>

	#ifdef USE_DISPLACEMENTMAP

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>

	vWorldPosition = worldPosition.xyz;

}
`,Ia=`
#define DISTANCE

uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;

#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>

void main () {

	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>

	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>

	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist ); // clamp to [ 0, 1 ]

	gl_FragColor = packDepthToRGBA( dist );

}
`,Ua=`
varying vec3 vWorldDirection;

#include <common>

void main() {

	vWorldDirection = transformDirection( position, modelMatrix );

	#include <begin_vertex>
	#include <project_vertex>

}
`,Oa=`
uniform sampler2D tEquirect;

varying vec3 vWorldDirection;

#include <common>

void main() {

	vec3 direction = normalize( vWorldDirection );

	vec2 sampleUV = equirectUv( direction );

	gl_FragColor = texture2D( tEquirect, sampleUV );

	#include <tonemapping_fragment>
	#include <colorspace_fragment>

}
`,Fa=`
uniform float scale;
attribute float lineDistance;

varying float vLineDistance;

#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	vLineDistance = scale * lineDistance;

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>

}
`,Ha=`
uniform vec3 diffuse;
uniform float opacity;

uniform float dashSize;
uniform float totalSize;

varying float vLineDistance;

#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	if ( mod( vLineDistance, totalSize ) > dashSize ) {

		discard;

	}

	vec3 outgoingLight = vec3( 0.0 );

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>

	outgoingLight = diffuseColor.rgb; // simple shader

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>

}
`,Va=`
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>

}
`,Ga=`
uniform vec3 diffuse;
uniform float opacity;

#ifndef FLAT_SHADED

	varying vec3 vNormal;

#endif

#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );

	// accumulation (baked indirect lighting only)
	#ifdef USE_LIGHTMAP

		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;

	#else

		reflectedLight.indirectDiffuse += vec3( 1.0 );

	#endif

	// modulation
	#include <aomap_fragment>

	reflectedLight.indirectDiffuse *= diffuseColor.rgb;

	vec3 outgoingLight = reflectedLight.indirectDiffuse;

	#include <envmap_fragment>

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

}
`,ka=`
#define LAMBERT

varying vec3 vViewPosition;

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	vViewPosition = - mvPosition.xyz;

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>

}
`,za=`
#define LAMBERT

uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;

#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// accumulation
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>

	// modulation
	#include <aomap_fragment>

	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;

	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}
`,Ba=`
#define MATCAP

varying vec3 vViewPosition;

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>

#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>

	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>

	vViewPosition = - mvPosition.xyz;

}
`,Wa=`
#define MATCAP

uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;

varying vec3 vViewPosition;

#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>

	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5; // 0.495 to remove artifacts caused by undersized matcap disks

	#ifdef USE_MATCAP

		vec4 matcapColor = texture2D( matcap, uv );

	#else

		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 ); // default if matcap is missing

	#endif

	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

}
`,Ya=`
#define NORMAL

#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )

	varying vec3 vViewPosition;

#endif

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )

	vViewPosition = - mvPosition.xyz;

#endif

}
`,Xa=`
#define NORMAL

uniform float opacity;

#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )

	varying vec3 vViewPosition;

#endif

#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );

	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>

	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );

	#ifdef OPAQUE

		gl_FragColor.a = 1.0;

	#endif

}
`,ja=`
#define PHONG

varying vec3 vViewPosition;

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	vViewPosition = - mvPosition.xyz;

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>

}
`,qa=`
#define PHONG

uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;

#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// accumulation
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>

	// modulation
	#include <aomap_fragment>

	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;

	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

}
`,Za=`
#define STANDARD

varying vec3 vViewPosition;

#ifdef USE_TRANSMISSION

	varying vec3 vWorldPosition;

#endif

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	vViewPosition = - mvPosition.xyz;

	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>

#ifdef USE_TRANSMISSION

	vWorldPosition = worldPosition.xyz;

#endif
}
`,Ja=`
#define STANDARD

#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif

uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;

#ifdef IOR
	uniform float ior;
#endif

#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;

	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif

	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif

#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif

#ifdef USE_DISPERSION
	uniform float dispersion;
#endif

#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif

#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;

	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif

	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif

#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;

	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif

varying vec3 vViewPosition;

#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>

	// accumulation
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>

	// modulation
	#include <aomap_fragment>

	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;

	#include <transmission_fragment>

	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;

	#ifdef USE_SHEEN

		// Sheen energy compensation approximation calculation can be found at the end of
		// https://drive.google.com/file/d/1T0D1VSyR4AllqIJTQAraEIzjlb5h4FKH/view?usp=sharing
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );

		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;

	#endif

	#ifdef USE_CLEARCOAT

		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );

		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );

		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;

	#endif

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

}
`,Ka=`
#define TOON

varying vec3 vViewPosition;

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	vViewPosition = - mvPosition.xyz;

	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>

}
`,Qa=`
#define TOON

uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;

#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// accumulation
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>

	// modulation
	#include <aomap_fragment>

	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

}
`,$a=`
uniform float size;
uniform float scale;

#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

#ifdef USE_POINTS_UV

	varying vec2 vUv;
	uniform mat3 uvTransform;

#endif

void main() {

	#ifdef USE_POINTS_UV

		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;

	#endif

	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>

	gl_PointSize = size;

	#ifdef USE_SIZEATTENUATION

		bool isPerspective = isPerspectiveMatrix( projectionMatrix );

		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );

	#endif

	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>

}
`,en=`
uniform vec3 diffuse;
uniform float opacity;

#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	vec3 outgoingLight = vec3( 0.0 );

	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>

	outgoingLight = diffuseColor.rgb;

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>

}
`,tn=`
#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>

void main() {

	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>

	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>

}
`,rn=`
uniform vec3 color;
uniform float opacity;

#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>

void main() {

	#include <logdepthbuf_fragment>

	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );

	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>

}
`,sn=`
uniform float rotation;
uniform vec2 center;

#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>

	vec4 mvPosition = modelViewMatrix[ 3 ];

	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );

	#ifndef USE_SIZEATTENUATION

		bool isPerspective = isPerspectiveMatrix( projectionMatrix );

		if ( isPerspective ) scale *= - mvPosition.z;

	#endif

	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;

	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;

	mvPosition.xy += rotatedPosition;

	gl_Position = projectionMatrix * mvPosition;

	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>

}
`,an=`
uniform vec3 diffuse;
uniform float opacity;

#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	vec3 outgoingLight = vec3( 0.0 );

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>

	outgoingLight = diffuseColor.rgb;

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>

}
`,nn=`
#define LAMBERT

varying vec3 vViewPosition;
varying vec3 heatPosition;

// fengmap
varying float vIsPerspectiveCamera;

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#include <fengmap_mask_vertex1>

void main() {
	heatPosition = vec3(modelMatrix * vec4( position, 1.0 ));
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fengmap_mask_vertex2>

	vViewPosition = - mvPosition.xyz;

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>

	// fengmap
	vIsPerspectiveCamera = isPerspectiveMatrix( projectionMatrix ) ? 1.0 : 0.0;
}
`,on=`
#define LAMBERT

// fengmap
varying float vIsPerspectiveCamera;

varying vec3 heatPosition;
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
uniform bool mapMixColor;
uniform vec2 heatCenter;
uniform vec2 heatSize;

uniform bool isJsonModel;


#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <fengmap_lights_pars_begin>
#include <normal_pars_fragment>
#include <fengmap_lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
#include <fengmap_mask_fragment1>

vec3 rgb2hsb(vec3 c) {
    float maxVal = max(c.r, max(c.g, c.b));
    float minVal = min(c.r, min(c.g, c.b));
    float delta = maxVal - minVal;

    float h = 0.0;
    if (delta > 0.0) {
        if (maxVal == c.r) {
            h = mod((c.g - c.b) / delta, 6.0);
        } else if (maxVal == c.g) {
            h = (c.b - c.r) / delta + 2.0;
        } else {
            h = (c.r - c.g) / delta + 4.0;
        }
        h /= 6.0; // Normalize to range [0,1]
    }

    float s = (maxVal == 0.0) ? 0.0 : delta / maxVal;
    float b = maxVal;

    return vec3(h, s, b);
}

vec3 hsb2rgb(vec3 c) {
    float h = c.x * 6.0;
    float s = c.y;
    float b = c.z;

    float i = floor(h);
    float f = h - i;
    float p = b * (1.0 - s);
    float q = b * (1.0 - f * s);
    float t = b * (1.0 - (1.0 - f) * s);

    if (i == 0.0) return vec3(b, t, p);
    if (i == 1.0) return vec3(q, b, p);
    if (i == 2.0) return vec3(p, b, t);
    if (i == 3.0) return vec3(p, q, b);
    if (i == 4.0) return vec3(t, p, b);
    return vec3(b, p, q);
}

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );

	#include <clipping_planes_fragment>
	#include <fengmap_mask_fragment2>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;

	#include <logdepthbuf_fragment>
	#include <fengmap_map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// accumulation
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>

	// modulation
	#include <aomap_fragment>

	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#ifdef IGNORE_LIGHTING
	  if(vIsPerspectiveCamera == 0.0) {
			outgoingLight = diffuseColor.rgb;
		}
	#endif

	#ifdef USE_MODEL_SIDE_GRADIENT
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		if (dot(vec3(0.0, 1.0, 0.0), worldNormal) < 0.8) {
			vec3 hsb = rgb2hsb(outgoingLight);
			hsb.y = clamp(hsb.y * 1.5, 0.0, 1.0);
			hsb.z = clamp(hsb.z * 0.8, 0.0, 1.0);
			outgoingLight = mix(hsb2rgb(hsb), outgoingLight, vUv.y);
		}
	#endif

	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}
`,hn=`
#define STANDARD

varying vec3 vViewPosition;

#ifdef USE_TRANSMISSION

	varying vec3 vWorldPosition;

#endif

#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#include <fengmap_sweep_pars_common>
#include <fengmap_mask_vertex1>


void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fengmap_mask_vertex2>

	vViewPosition = - mvPosition.xyz;

	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>

#ifdef USE_TRANSMISSION

	vWorldPosition = worldPosition.xyz;

#endif

	//fengmap
	#include <fengmap_sweep_vertex>
}
`,ln=`
#define STANDARD

#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif

uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;

#ifdef IOR
	uniform float ior;
#endif

#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;

	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif

	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif

#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif

#ifdef USE_DISPERSION
	uniform float dispersion;
#endif

#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif

#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;

	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif

	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif

#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;

	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif

varying vec3 vViewPosition;

#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <fengmap_lights_pars_begin>
#include <normal_pars_fragment>
#include <fengmap_lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
#include <fengmap_mask_fragment1>
#include <fengmap_sweep_pars_common>
#include <fengmap_sweep_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <fengmap_mask_fragment2>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>

	// accumulation
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>

	// modulation
	#include <aomap_fragment>

	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;

	#include <transmission_fragment>

	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;

	#ifdef USE_SHEEN

		// Sheen energy compensation approximation calculation can be found at the end of
		// https://drive.google.com/file/d/1T0D1VSyR4AllqIJTQAraEIzjlb5h4FKH/view?usp=sharing
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );

		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;

	#endif

	#ifdef USE_CLEARCOAT

		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );

		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );

		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;

	#endif

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
	#include <fengmap_sweep_fragment>
}
`,cn=`
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#include <fengmap_mask_vertex1>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>

	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fengmap_mask_vertex2>

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>

}
`,dn=`
uniform vec3 diffuse;
uniform float opacity;

#ifndef FLAT_SHADED

	varying vec3 vNormal;

#endif

#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
#include <fengmap_mask_fragment1>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <fengmap_mask_fragment2>

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );

	// accumulation (baked indirect lighting only)
	#ifdef USE_LIGHTMAP

		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;

	#else

		reflectedLight.indirectDiffuse += vec3( 1.0 );

	#endif

	// modulation
	#include <aomap_fragment>

	reflectedLight.indirectDiffuse *= diffuseColor.rgb;

	vec3 outgoingLight = reflectedLight.indirectDiffuse;

	#include <envmap_fragment>

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

}
`;var un=`

struct PhysicalMaterial {

	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;

	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif

	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif

	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif

	#ifdef IOR
		float ior;
	#endif

	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif

	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif

};

// temporary
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );

vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );

    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}

// Moving Frostbite to Physically Based Rendering 3.0 - page 12, listing 2
// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {

	float a2 = pow2( alpha );

	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );

	return 0.5 / max( gv + gl, EPSILON );

}

// Microfacet Models for Refraction through Rough Surfaces - equation (33)
// http://graphicrants.blogspot.com/2013/08/specular-brdf-reference.html
// alpha is "roughness squared" in Disney’s reparameterization
float D_GGX( const in float alpha, const in float dotNH ) {

	float a2 = pow2( alpha );

	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0; // avoid alpha = 0 with dotNH = 1

	return RECIPROCAL_PI * a2 / pow2( denom );

}

// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
#ifdef USE_ANISOTROPY

	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {

		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );

		return saturate(v);

	}

	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {

		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;

		return RECIPROCAL_PI * a2 * pow2 ( w2 );

	}

#endif

#ifdef USE_CLEARCOAT

	// GGX Distribution, Schlick Fresnel, GGX_SmithCorrelated Visibility
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {

		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;

		float alpha = pow2( roughness ); // UE4's roughness

		vec3 halfDir = normalize( lightDir + viewDir );

		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );

		vec3 F = F_Schlick( f0, f90, dotVH );

		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );

		float D = D_GGX( alpha, dotNH );

		return F * ( V * D );

	}

#endif

vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {

	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;

	float alpha = pow2( roughness ); // UE4's roughness

	vec3 halfDir = normalize( lightDir + viewDir );

	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );

	vec3 F = F_Schlick( f0, f90, dotVH );

	#ifdef USE_IRIDESCENCE

		F = mix( F, material.iridescenceFresnel, material.iridescence );

	#endif

	#ifdef USE_ANISOTROPY

		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );

		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );

		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );

	#else

		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );

		float D = D_GGX( alpha, dotNH );

	#endif

	return F * ( V * D );

}

// Rect Area Light

// Real-Time Polygonal-Light Shading with Linearly Transformed Cosines
// by Eric Heitz, Jonathan Dupuy, Stephen Hill and David Neubelt
// code: https://github.com/selfshadow/ltc_code/

vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {

	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;

	float dotNV = saturate( dot( N, V ) );

	// texture parameterized by sqrt( GGX alpha ) and sqrt( 1 - cos( theta ) )
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );

	uv = uv * LUT_SCALE + LUT_BIAS;

	return uv;

}

float LTC_ClippedSphereFormFactor( const in vec3 f ) {

	// Real-Time Area Lighting: a Journey from Research to Production (p.102)
	// An approximation of the form factor of a horizon-clipped rectangle.

	float l = length( f );

	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );

}

vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {

	float x = dot( v1, v2 );

	float y = abs( x );

	// rational polynomial approximation to theta / sin( theta ) / 2PI
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;

	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;

	return cross( v1, v2 ) * theta_sintheta;

}

vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {

	// bail if point is on back side of plane of light
	// assumes ccw winding order of light vertices
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );

	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );

	// construct orthonormal basis around N
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 ); // negated from paper; possibly due to a different handedness of world coordinate system

	// compute transform
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );

	// transform rect
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );

	// project rect onto sphere
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );

	// calculate vector form factor
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );

	// adjust for horizon clipping
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );

/*
	// alternate method of adjusting for horizon clipping (see referece)
	// refactoring required
	float len = length( vectorFormFactor );
	float z = vectorFormFactor.z / len;

	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;

	// tabulated horizon-clipped sphere, apparently...
	vec2 uv = vec2( z * 0.5 + 0.5, len );
	uv = uv * LUT_SCALE + LUT_BIAS;

	float scale = texture2D( ltc_2, uv ).w;

	float result = len * scale;
*/

	return vec3( result );

}

// End Rect Area Light

#if defined( USE_SHEEN )

// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
float D_Charlie( float roughness, float dotNH ) {

	float alpha = pow2( roughness );

	// Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF"
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 ); // 2^(-14/2), so sin2h^2 > 0 in fp16

	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );

}

// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
float V_Neubelt( float dotNV, float dotNL ) {

	// Neubelt and Pettineo 2013, "Crafting a Next-gen Material Pipeline for The Order: 1886"
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );

}

vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {

	vec3 halfDir = normalize( lightDir + viewDir );

	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );

	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );

	return sheenColor * ( D * V );

}

#endif

// This is a curve-fit approxmation to the "Charlie sheen" BRDF integrated over the hemisphere from
// Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF". The analysis can be found
// in the Sheen section of https://drive.google.com/file/d/1T0D1VSyR4AllqIJTQAraEIzjlb5h4FKH/view?usp=sharing
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {

	float dotNV = saturate( dot( normal, viewDir ) );

	float r2 = roughness * roughness;

	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;

	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;

	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );

	return saturate( DG * RECIPROCAL_PI );

}

// Analytical approximation of the DFG LUT, one half of the
// split-sum approximation used in indirect specular lighting.
// via 'environmentBRDF' from "Physically Based Shading on Mobile"
// https://www.unrealengine.com/blog/physically-based-shading-on-mobile
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {

	float dotNV = saturate( dot( normal, viewDir ) );

	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );

	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );

	vec4 r = roughness * c0 + c1;

	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;

	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;

	return fab;

}

vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {

	vec2 fab = DFGApprox( normal, viewDir, roughness );

	return specularColor * fab.x + specularF90 * fab.y;

}

// Fdez-Agüera's "Multiple-Scattering Microfacet Model for Real-Time Image Based Lighting"
// Approximates multiscattering in order to preserve energy.
// http://www.jcgt.org/published/0008/01/03/
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif

	vec2 fab = DFGApprox( normal, viewDir, roughness );

	#ifdef USE_IRIDESCENCE

		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );

	#else

		vec3 Fr = specularColor;

	#endif

	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;

	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;

	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619; // 1/21
	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );

	singleScatter += FssEss;
	multiScatter += Fms * Ems;

}

#if NUM_RECT_AREA_LIGHTS > 0

	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {

		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;

		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight; // counterclockwise; light shines in local neg z direction
		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;

		vec2 uv = LTC_Uv( normal, viewDir, roughness );

		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );

		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);

		// LTC Fresnel Approximation by Stephen Hill
		// http://blog.selfshadow.com/publications/s2016-advances/s2016_ltc_fresnel.pdf
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );

		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );

		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );

	}

#endif

void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {

	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );

	vec3 irradiance = dotNL * directLight.color;
	#ifndef PHYSICALLY_CORRECT_LIGHTS

			irradiance *= PI; // punctual light


	#endif
	#ifdef USE_CLEARCOAT

		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );

		vec3 ccIrradiance = dotNLcc * directLight.color;

		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );

	#endif

	#ifdef USE_SHEEN

		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );

	#endif

	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );

	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}

void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {

	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {

	#ifdef USE_CLEARCOAT

		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );

	#endif

	#ifdef USE_SHEEN

		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );

	#endif

	// Both indirect specular and indirect diffuse light accumulate here

	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;

	#ifdef USE_IRIDESCENCE

		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );

	#else

		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );

	#endif

	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );

	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;

	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;

}

#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical

// ref: https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {

	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );

}
`,fn=`
uniform bool receiveShadow;
uniform vec3 ambientLightColor;

#if defined( USE_LIGHT_PROBES )

	uniform vec3 lightProbe[ 9 ];

#endif

// get the irradiance (radiance convolved with cosine lobe) at the point 'normal' on the unit sphere
// source: https://graphics.stanford.edu/papers/envmap/envmap.pdf
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {

	// normal is assumed to have unit length

	float x = normal.x, y = normal.y, z = normal.z;

	// band 0
	vec3 result = shCoefficients[ 0 ] * 0.886227;

	// band 1
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;

	// band 2
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );

	return result;

}

vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {

	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );

	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );

	return irradiance;

}

vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {

	vec3 irradiance = ambientLightColor;
	#ifndef PHYSICALLY_CORRECT_LIGHTS
		irradiance *= PI;
	#endif
	return irradiance;

}

// fengmap r115
float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
    #if defined ( PHYSICALLY_CORRECT_LIGHTS )
        float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
        if( cutoffDistance > 0.0 ) {
            distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
        }
        return distanceFalloff;
    #else

        if( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
            return pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );
        }
        return 1.0;
    #endif
}

float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {

	// based upon Frostbite 3 Moving to Physically-based Rendering
	// page 32, equation 26: E[window1]
	// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );

	if ( cutoffDistance > 0.0 ) {

		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );

	}

	return distanceFalloff;

}

float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {

	return smoothstep( coneCosine, penumbraCosine, angleCosine );

}

#if NUM_DIR_LIGHTS > 0

	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};

	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];

	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {

		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;

	}

#endif


#if NUM_POINT_LIGHTS > 0

	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};

	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];

	// light is an out parameter as having it as a return value caused compiler errors on some devices
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {

		vec3 lVector = pointLight.position - geometryPosition;

		light.direction = normalize( lVector );

		float lightDistance = length( lVector );

		light.color = pointLight.color;
		light.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );

	}

#endif


#if NUM_SPOT_LIGHTS > 0

	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};

	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];

	// light is an out parameter as having it as a return value caused compiler errors on some devices
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {

		vec3 lVector = spotLight.position - geometryPosition;

		light.direction = normalize( lVector );

		float angleCos = dot( light.direction, spotLight.direction );

		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );

		if ( spotAttenuation > 0.0 ) {

			float lightDistance = length( lVector );

			light.color = spotLight.color * spotAttenuation;
			light.color *= punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );

		} else {

			light.color = vec3( 0.0 );
			light.visible = false;

		}

	}

#endif


#if NUM_RECT_AREA_LIGHTS > 0

	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};

	// Pre-computed values of LinearTransformedCosine approximation of BRDF
	// BRDF approximation Texture is 64x64
	uniform sampler2D ltc_1; // RGBA Float
	uniform sampler2D ltc_2; // RGBA Float

	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];

#endif


#if NUM_HEMI_LIGHTS > 0

	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};

	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];

	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {

		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;

		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );

		return irradiance;

	}

#endif
`,mn=`
varying vec3 vViewPosition;

struct LambertMaterial {

	vec3 diffuseColor;
	float specularStrength;

};

void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {

	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = vec3(dotNL) * directLight.color;
	irradiance *= 3.1415926;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {

	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );

}

#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert
`,pn=`
#ifdef USE_MAP

vec4 sampledDiffuseColor = texture2D( map, vMapUv );
  bool needMultiply = true;
	if(!isJsonModel){
		if (vMapUv.x < 0.0 || vMapUv.x > 1.0 || vMapUv.y < 0.0 || vMapUv.y > 1.0) {
			sampledDiffuseColor = diffuseColor;
			needMultiply = false;
		}
	}
	

	#ifdef DECODE_VIDEO_TEXTURE
		// use inline sRGB decode until browsers properly support SRGB8_ALPHA8 with video textures (#26516)
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	#endif

	if(mapMixColor){
		vec2 uvHeat=vec2((heatPosition.x -  (heatCenter.x - heatSize.x/2.0)) / heatSize.x , (heatPosition.z - (heatCenter.y-heatSize.y/2.0)) / heatSize.y);
		vec4 heatColor=texture2D( map, uvHeat );
		diffuseColor = heatColor*heatColor.a + diffuseColor*(1.0-heatColor.a);
	} else if(needMultiply){
		diffuseColor *= sampledDiffuseColor;
	}
#endif
`,vn=`
if(isRect&&isEnable){
  vec2 v = vec2(v_position.x - moveP.x, v_position.z - moveP.y);
  if(isInRectW(v,se2N,sweepW) && isInRectH(v,se2RN,sweepH)){
    gl_FragColor = vec4(mix(gl_FragColor.rgb, sweepStrength*color_a.rgb, 0.5),gl_FragColor.a);
  }
}

if(isAnnulus&&isEnable){
  if(isMaxCircle(v_position.xyz,circleC,maxR) && isMinCircle(v_position.xyz,circleC,minR)){
    if(isSweepTexture){
      vec2 uv = vec2((v_position.x-(circleC.x-maxR))/(2.0*maxR),(v_position.z-(circleC.y-maxR))/(2.0*maxR));
      vec4 tex = texture2D( sweepTexture, uv );
      tex = mapTexelToLinear( tex );
      float d2 = pow(v_position.x-circleC.x,2.0) + pow(v_position.z-circleC.y,2.0);
      float a = smoothstep(0.0, pow(maxR,2.0), d2);
      a = 1.0 - a;
      tex.a = a;
      gl_FragColor = vec4(mix(gl_FragColor.rgb, sweepStrength*tex.rgb, 0.2),gl_FragColor.a);
    } else {
      gl_FragColor = vec4(mix(gl_FragColor.rgb, sweepStrength*color_a.rgb, 0.5),gl_FragColor.a);
    }
  }

}
`,gn=`
	uniform bool isRect;
	uniform bool isAnnulus;

	uniform float sweepW;
	uniform float sweepH;
	uniform vec2 se2N;
	uniform vec2 se2RN;
	uniform vec2 moveP;
	uniform vec3 color_r;

	uniform vec2 circleC;
	uniform float maxR;
	uniform float minR;
	uniform vec3 color_a;

	uniform bool isSweepTexture;
	uniform sampler2D sweepTexture;
	uniform float sweepStrength;

  uniform bool isEnable;

	bool isInRectW(vec2 v, vec2 a, float w){
		float a1 = abs(dot(v,a));
		return a1 < w;
	}

	bool isInRectH(vec2 v, vec2 a, float h){
		float a1 = abs(dot(v,a));
		return a1 < h;
	}

	bool isMaxCircle(vec3 a, vec2 b, float r){
		float c = pow((a.x-b.x),2.0)+pow((a.z-b.y),2.0);
		return c <= pow(r,2.0);
	}

	bool isMinCircle(vec3 a, vec2 b, float r){
		float c = pow((a.x-b.x),2.0)+pow((a.z-b.y),2.0);
		return c > pow(r,2.0);
	}

	vec4 mapTexelToLinear( vec4 value ) {
		return value;
	}
`,_n=`
 varying vec3 v_position;
`,xn=`
  v_position = vec3(modelMatrix * vec4( position, 1.0 ));
`,Mn=`
    #if NUM_MASK_POLYGON > 0
        varying vec3 maskPosition;
    #endif
`,Sn=`
    #if NUM_MASK_POLYGON > 0
        maskPosition = vec3(modelMatrix * vec4( position, 1.0 ));
    #endif
`,wn=`
    #if NUM_MASK_POLYGON > 0
        varying vec3 maskPosition;
        varying float v_positionHeight;
        uniform vec2 maskPolygons[ NUM_MASK_POLYGON ];
        uniform int maskType;
        uniform bool isMask;
        uniform float maskHeight;
        uniform float maskExtrudeHeight;
        uniform vec2 boundCenter;
	    uniform vec2 boundSize;
        uniform float maskOpacity;
        uniform float maskNodeHeight;
        bool isPointInsidePolygon(vec2 point,vec2 polygon2[NUM_MASK_POLYGON], int count) {
            if(count==1){
                return false;
            }
            if(count==2){
                return true;
            }
            <#ISPOINTINSIDEPOLYGON#>
        }
    #endif
     #if NUM_MASK_HOLE_POLYGON>0
        uniform vec2 maskHolePogygons[ NUM_MASK_HOLE_POLYGON ];
        bool isPointInsideHolePolygon(vec2 point,vec2 polygon2[NUM_MASK_HOLE_POLYGON], int count) {
            if(count==1){
                return false;
            }
            if(count==2){
                return true;
            }
            <#ISPOINTINSIDEHOLEPOLYGON#>
        }
     #endif
`,yn=`
    #if NUM_MASK_POLYGON > 0
    if(isMask){
            vec2 uvMesk=vec2((maskPosition.x -  (boundCenter.x - boundSize.x/2.0)) / boundSize.x , (maskPosition.z - (boundCenter.y-boundSize.y/2.0)) / boundSize.y);
            bool isDiscard=false;
    
            if(maskType==0){
                if(!isPointInsidePolygon(uvMesk,maskPolygons,NUM_MASK_POLYGON)){
                    isDiscard=true;            
                }
            } else {
                if(isPointInsidePolygon(uvMesk,maskPolygons,NUM_MASK_POLYGON)){
                    isDiscard=true;            
                }
            }
    
    #if NUM_MASK_HOLE_POLYGON > 0
        if(maskType==0){
            if(!isDiscard && isPointInsideHolePolygon(uvMesk,maskHolePogygons,NUM_MASK_HOLE_POLYGON)){
                isDiscard=true;            
            }
        } else {
            if(isDiscard && isPointInsideHolePolygon(uvMesk,maskHolePogygons,NUM_MASK_HOLE_POLYGON)){
                isDiscard=false;             
            }
        }
            
    #endif
        if(isDiscard){
            if(maskPosition.y >= maskNodeHeight + maskHeight && maskPosition.y <= maskNodeHeight + maskHeight + maskExtrudeHeight){
                if(maskOpacity == 0.0){
                    discard;
                } else {
                    diffuseColor.a = maskOpacity;
                }
            }
        }
    }
    #endif
`;let T={alphahash_fragment:Cr,alphahash_pars_fragment:Lr,alphamap_fragment:Tr,alphamap_pars_fragment:Ar,alphatest_fragment:Pr,alphatest_pars_fragment:Nr,aomap_fragment:Dr,aomap_pars_fragment:Rr,batching_pars_vertex:Ir,batching_vertex:Ur,begin_vertex:Or,beginnormal_vertex:Fr,bsdfs:Hr,iridescence_fragment:Vr,bumpmap_pars_fragment:Gr,clipping_planes_fragment:kr,clipping_planes_pars_fragment:zr,clipping_planes_pars_vertex:Br,clipping_planes_vertex:Wr,color_fragment:Yr,color_pars_fragment:Xr,color_pars_vertex:jr,color_vertex:qr,common:Zr,cube_uv_reflection_fragment:Jr,defaultnormal_vertex:Kr,displacementmap_pars_vertex:Qr,displacementmap_vertex:$r,emissivemap_fragment:es,emissivemap_pars_fragment:ts,colorspace_fragment:is,colorspace_pars_fragment:rs,envmap_fragment:ss,envmap_common_pars_fragment:as,envmap_pars_fragment:ns,envmap_pars_vertex:os,envmap_physical_pars_fragment:_s,envmap_vertex:hs,fog_vertex:ls,fog_pars_vertex:cs,fog_fragment:ds,fog_pars_fragment:us,gradientmap_pars_fragment:fs,lightmap_pars_fragment:ms,lights_lambert_fragment:ps,lights_lambert_pars_fragment:vs,lights_pars_begin:gs,lights_toon_fragment:xs,lights_toon_pars_fragment:Ms,lights_phong_fragment:Ss,lights_phong_pars_fragment:ws,lights_physical_fragment:ys,lights_physical_pars_fragment:bs,lights_fragment_begin:Es,lights_fragment_maps:Cs,lights_fragment_end:Ls,logdepthbuf_fragment:Ts,logdepthbuf_pars_fragment:As,logdepthbuf_pars_vertex:Ps,logdepthbuf_vertex:Ns,map_fragment:Ds,map_pars_fragment:Rs,map_particle_fragment:Is,map_particle_pars_fragment:Us,metalnessmap_fragment:Os,metalnessmap_pars_fragment:Fs,morphinstance_vertex:Hs,morphcolor_vertex:Vs,morphnormal_vertex:Gs,morphtarget_pars_vertex:ks,morphtarget_vertex:zs,normal_fragment_begin:Bs,normal_fragment_maps:Ws,normal_pars_fragment:Ys,normal_pars_vertex:Xs,normal_vertex:js,normalmap_pars_fragment:qs,clearcoat_normal_fragment_begin:Zs,clearcoat_normal_fragment_maps:Js,clearcoat_pars_fragment:Ks,iridescence_pars_fragment:Qs,opaque_fragment:$s,packing:ea,premultiplied_alpha_fragment:ta,project_vertex:ia,dithering_fragment:ra,dithering_pars_fragment:sa,roughnessmap_fragment:aa,roughnessmap_pars_fragment:na,shadowmap_pars_fragment:oa,shadowmap_pars_vertex:ha,shadowmap_vertex:la,shadowmask_pars_fragment:ca,skinbase_vertex:da,skinning_pars_vertex:ua,skinning_vertex:fa,skinnormal_vertex:ma,specularmap_fragment:pa,specularmap_pars_fragment:va,tonemapping_fragment:ga,tonemapping_pars_fragment:_a,transmission_fragment:xa,transmission_pars_fragment:Ma,uv_pars_fragment:Sa,uv_pars_vertex:wa,uv_vertex:ya,worldpos_vertex:ba,fengmap_map_fragment:pn,fengmap_lights_pars_begin:fn,fengmap_lights_lambert_pars_fragment:mn,fengmap_lights_physical_pars_fragment:un,fengmap_sweep_fragment:vn,fengmap_sweep_pars_fragment:gn,fengmap_sweep_pars_common:_n,fengmap_sweep_vertex:xn,fengmap_mask_vertex1:Mn,fengmap_mask_vertex2:Sn,fengmap_mask_fragment1:wn,fengmap_mask_fragment2:yn,background_vert:Ea,background_frag:Ca,backgroundCube_vert:La,backgroundCube_frag:Ta,cube_vert:Aa,cube_frag:Pa,depth_vert:Na,depth_frag:Da,distanceRGBA_vert:Ra,distanceRGBA_frag:Ia,equirect_vert:Ua,equirect_frag:Oa,linedashed_vert:Fa,linedashed_frag:Ha,meshbasic_vert:Va,meshbasic_frag:Ga,meshlambert_vert:ka,meshlambert_frag:za,meshmatcap_vert:Ba,meshmatcap_frag:Wa,meshnormal_vert:Ya,meshnormal_frag:Xa,meshphong_vert:ja,meshphong_frag:qa,meshphysical_vert:Za,meshphysical_frag:Ja,meshtoon_vert:Ka,meshtoon_frag:Qa,points_vert:$a,points_frag:en,shadow_vert:tn,shadow_frag:rn,sprite_vert:sn,sprite_frag:an,fmMeshlambert_vert:nn,fmMeshlambert_frag:on,fmMeshphysical_vert:hn,fmMeshphysical_frag:ln,fmMeshBasic_vert:cn,fmMeshBasic_frag:dn},bn={common:{diffuse:{value:new M(16777215)},opacity:{value:1},map:{value:null},mapTransform:{value:new c},alphaMap:{value:null},alphaMapTransform:{value:new c},alphaTest:{value:0}},specularmap:{specularMap:{value:null},specularMapTransform:{value:new c}},envmap:{envMap:{value:null},envMapRotation:{value:new c},flipEnvMap:{value:-1},reflectivity:{value:1},ior:{value:1.5},refractionRatio:{value:.98}},aomap:{aoMap:{value:null},aoMapIntensity:{value:1},aoMapTransform:{value:new c}},lightmap:{lightMap:{value:null},lightMapIntensity:{value:1},lightMapTransform:{value:new c}},bumpmap:{bumpMap:{value:null},bumpMapTransform:{value:new c},bumpScale:{value:1}},normalmap:{normalMap:{value:null},normalMapTransform:{value:new c},normalScale:{value:new D(1,1)}},displacementmap:{displacementMap:{value:null},displacementMapTransform:{value:new c},displacementScale:{value:1},displacementBias:{value:0}},emissivemap:{emissiveMap:{value:null},emissiveMapTransform:{value:new c}},metalnessmap:{metalnessMap:{value:null},metalnessMapTransform:{value:new c}},roughnessmap:{roughnessMap:{value:null},roughnessMapTransform:{value:new c}},gradientmap:{gradientMap:{value:null}},fog:{fogDensity:{value:25e-5},fogNear:{value:1},fogFar:{value:2e3},fogColor:{value:new M(16777215)}},lights:{ambientLightColor:{value:[]},lightProbe:{value:[]},directionalLights:{value:[],properties:{direction:{},color:{}}},directionalLightShadows:{value:[],properties:{shadowIntensity:1,shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{}}},directionalShadowMap:{value:[]},directionalShadowMatrix:{value:[]},spotLights:{value:[],properties:{color:{},position:{},direction:{},distance:{},coneCos:{},penumbraCos:{},decay:{}}},spotLightShadows:{value:[],properties:{shadowIntensity:1,shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{}}},spotLightMap:{value:[]},spotShadowMap:{value:[]},spotLightMatrix:{value:[]},pointLights:{value:[],properties:{color:{},position:{},decay:{},distance:{}}},pointLightShadows:{value:[],properties:{shadowIntensity:1,shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{},shadowCameraNear:{},shadowCameraFar:{}}},pointShadowMap:{value:[]},pointShadowMatrix:{value:[]},hemisphereLights:{value:[],properties:{direction:{},skyColor:{},groundColor:{}}},rectAreaLights:{value:[],properties:{color:{},position:{},width:{},height:{}}},ltc_1:{value:null},ltc_2:{value:null}},points:{diffuse:{value:new M(16777215)},opacity:{value:1},size:{value:1},scale:{value:1},map:{value:null},alphaMap:{value:null},alphaMapTransform:{value:new c},alphaTest:{value:0},uvTransform:{value:new c}},sprite:{diffuse:{value:new M(16777215)},opacity:{value:1},center:{value:new D(.5,.5)},rotation:{value:0},map:{value:null},mapTransform:{value:new c},alphaMap:{value:null},alphaMapTransform:{value:new c},alphaTest:{value:0}}};class A extends L{constructor(){super(),this.isMeshLine=!0,this.type="MeshLine",this.positions=[],this.previous=[],this.next=[],this.side=[],this.width=[],this.indices_array=[],this.uvs=[],this.counters=[],this.L=[],this.ve=null,this.widthCallback=null,this.matrixWorld=new _,Object.defineProperties(this,{geometry:{enumerable:!0,get:function(){return this}},geom:{enumerable:!0,get:function(){return this.ve},set:function(e){this.setGeometry(e,this.widthCallback)}},points:{enumerable:!0,get:function(){return this.L},set:function(e){this.setPoints(e,this.widthCallback)}}})}}function En(e,t){var i=new _,r=new de,s=new se,a=new N,n=this.geometry;if(n.boundingSphere||n.computeBoundingSphere(),s.copy(n.boundingSphere),s.applyMatrix4(this.matrixWorld),!1!==e.ray.intersectSphere(s,a)){i.copy(this.matrixWorld).invert(),r.copy(e.ray).applyMatrix4(i);var o=new N,h=new N,l=new N,c=this instanceof Er?2:1,s=n.index,i=n.attributes;if(null!==s)for(var d=s.array,u=i.position.array,f=i.width.array,m=0,p=d.length-1;m<p;m+=c){var v=d[m],g=d[m+1],v=(o.fromArray(u,3*v),h.fromArray(u,3*g),void 0!==f[Math.floor(m/3)]?f[Math.floor(m/3)]:1),g=e.params.Line.threshold+this.material.lineWidth*v/2;g*g<r.distanceSqToSegment(o,h,a,l)||(a.applyMatrix4(this.matrixWorld),(v=e.ray.origin.distanceTo(a))<e.near)||v>e.far||(t.push({distance:v,point:l.clone().applyMatrix4(this.matrixWorld),index:m,face:null,faceIndex:null,object:this}),m=p)}}}function Cn(e,t,i,r,s){var a;if(e=e.subarray||e.slice?e:e.buffer,i=i.subarray||i.slice?i:i.buffer,e=t?e.subarray?e.subarray(t,s&&t+s):e.slice(t,s&&t+s):e,i.set)i.set(e,r);else for(a=0;a<e.length;a++)i[a+r]=e[a];return i}A.prototype.setMatrixWorld=function(e){this.matrixWorld=e},A.prototype.setGeometry=function(e,t){this.ge=e,this.setPoints(e.getAttribute("position").array,t)},A.prototype.setPoints=function(e,t){if(e instanceof Float32Array||e instanceof Array){if(this.L=e,this.widthCallback=t,this.positions=[],this.counters=[],e.length&&e[0]instanceof N)for(var i=0;i<e.length;i++){var r=e[i],s=i/e.length;this.positions.push(r.x,r.y,r.z),this.positions.push(r.x,r.y,r.z),this.counters.push(s),this.counters.push(s)}else for(i=0;i<e.length;i+=3){s=i/e.length;this.positions.push(e[i],e[i+1],e[i+2]),this.positions.push(e[i],e[i+1],e[i+2]),this.counters.push(s),this.counters.push(s)}this.process()}else console.error("ERROR: The BufferArray of points is not instancied correctly.")},A.prototype.raycast=En,A.prototype.compareV3=function(e,t){e*=6,t*=6;return this.positions[e]===this.positions[t]&&this.positions[1+e]===this.positions[1+t]&&this.positions[2+e]===this.positions[2+t]},A.prototype.copyV3=function(e){e*=6;return[this.positions[e],this.positions[1+e],this.positions[2+e]]},A.prototype.process=function(){var e,t=this.positions.length/6;this.previous=[],this.next=[],this.side=[],this.width=[],this.indices_array=[],this.uvs=[],e=this.compareV3(0,t-1)?this.copyV3(t-2):this.copyV3(0),this.previous.push(e[0],e[1],e[2]),this.previous.push(e[0],e[1],e[2]);for(var i,r=0;r<t;r++)this.side.push(1),this.side.push(-1),i=this.widthCallback?this.widthCallback(r/(t-1)):1,this.width.push(i),this.width.push(i),this.uvs.push(r/(t-1),0),this.uvs.push(r/(t-1),1),r<t-1&&(e=this.copyV3(r),this.previous.push(e[0],e[1],e[2]),this.previous.push(e[0],e[1],e[2]),this.indices_array.push(i=2*r,1+i,2+i),this.indices_array.push(2+i,1+i,3+i)),0<r&&(e=this.copyV3(r),this.next.push(e[0],e[1],e[2]),this.next.push(e[0],e[1],e[2]));e=this.compareV3(t-1,0)?this.copyV3(1):this.copyV3(t-1),this.next.push(e[0],e[1],e[2]),this.next.push(e[0],e[1],e[2]),this._e&&this._e.position.count===this.positions.length?(this._e.position.copyArray(new Float32Array(this.positions)),this._e.position.needsUpdate=!0,this._e.previous.copyArray(new Float32Array(this.previous)),this._e.previous.needsUpdate=!0,this._e.next.copyArray(new Float32Array(this.next)),this._e.next.needsUpdate=!0,this._e.side.copyArray(new Float32Array(this.side)),this._e.side.needsUpdate=!0,this._e.width.copyArray(new Float32Array(this.width)),this._e.width.needsUpdate=!0,this._e.uv.copyArray(new Float32Array(this.uvs)),this._e.uv.needsUpdate=!0,this._e.index.copyArray(new Uint16Array(this.indices_array)),this._e.index.needsUpdate=!0):this._e={position:new R(new Float32Array(this.positions),3),previous:new R(new Float32Array(this.previous),3),next:new R(new Float32Array(this.next),3),side:new R(new Float32Array(this.side),1),width:new R(new Float32Array(this.width),1),uv:new R(new Float32Array(this.uvs),2),index:new R(new Uint16Array(this.indices_array),1),counters:new R(new Float32Array(this.counters),1)},this.setAttribute("position",this._e.position),this.setAttribute("previous",this._e.previous),this.setAttribute("next",this._e.next),this.setAttribute("side",this._e.side),this.setAttribute("width",this._e.width),this.setAttribute("uv",this._e.uv),this.setAttribute("counters",this._e.counters),this.setIndex(this._e.index),this.computeBoundingSphere(),this.computeBoundingBox()},A.prototype.advance=function(e){var t=this._e.position.array,i=this._e.previous.array,r=this._e.next.array,s=t.length;Cn(t,0,i,0,s),Cn(t,6,t,0,s-6),t[s-6]=e.x,t[s-5]=e.y,t[s-4]=e.z,t[s-3]=e.x,t[s-2]=e.y,t[s-1]=e.z,Cn(t,6,r,0,s-6),r[s-6]=e.x,r[s-5]=e.y,r[s-4]=e.z,r[s-3]=e.x,r[s-2]=e.y,r[s-1]=e.z,this._e.position.needsUpdate=!0,this._e.previous.needsUpdate=!0,this._e.next.needsUpdate=!0},T.meshline_vert=["",T.common,T.logdepthbuf_pars_vertex,T.fog_pars_vertex,"","attribute vec3 previous;","attribute vec3 next;","attribute float side;","attribute float width;","attribute float counters;","","uniform vec2 resolution;","uniform float lineWidth;","uniform vec3 color;","uniform float opacity;","uniform float sizeAttenuation;","uniform vec2 offset;","","varying vec2 vUV;","varying vec4 vColor;","varying float vCounters;","","vec2 fix( vec4 i, float aspect ) {","","    vec2 res = i.xy / i.w;","    res.x *= aspect;","\t vCounters = counters;","    return res;","","}","","void main() {","","    float aspect = resolution.x / resolution.y;","","    vColor = vec4( color, opacity );","    vUV = uv + offset;","","    mat4 m = projectionMatrix * modelViewMatrix;","    vec4 finalPosition = m * vec4( position, 1.0 );","    vec4 prevPos = m * vec4( previous, 1.0 );","    vec4 nextPos = m * vec4( next, 1.0 );","","    vec2 currentP = fix( finalPosition, aspect );","    vec2 prevP = fix( prevPos, aspect );","    vec2 nextP = fix( nextPos, aspect );","","    float w = lineWidth * width;","","    vec2 dir;","    if( nextP == currentP ) dir = normalize( currentP - prevP );","    else if( prevP == currentP ) dir = normalize( nextP - currentP );","    else {","        vec2 dir1 = normalize( currentP - prevP );","        vec2 dir2 = normalize( nextP - currentP );","        dir = normalize( dir1 + dir2 );","","        vec2 perp = vec2( -dir1.y, dir1.x );","        vec2 miter = vec2( -dir.y, dir.x );","        //w = clamp( w / dot( miter, perp ), 0., 4. * lineWidth * width );","","    }","","    //vec2 normal = ( cross( vec3( dir, 0. ), vec3( 0., 0., 1. ) ) ).xy;","    vec4 normal = vec4( -dir.y, dir.x, 0., 1. );","    normal.xy *= .5 * w;","    normal *= projectionMatrix;","    if( sizeAttenuation == 0. ) {","        normal.xy *= finalPosition.w;","        normal.xy /= ( vec4( resolution, 0., 1. ) * projectionMatrix ).xy;","    }","","    finalPosition.xy += normal.xy * side;","","    gl_Position = finalPosition;","",T.logdepthbuf_vertex,"    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",T.fog_vertex,"}"].join("\n"),T.meshline_frag=["",T.fog_pars_fragment,T.logdepthbuf_pars_fragment,"","uniform sampler2D map;","uniform sampler2D alphaMap;","uniform float useMap;","uniform float useAlphaMap;","uniform float useDash;","uniform float dashArray;","uniform float dashOffset;","uniform float dashRatio;","uniform float visibility;","uniform float alphaTest;","uniform vec2 repeat;","uniform float markerluminance;","uniform bool isbackground;","uniform vec3 bgcolor;","","varying vec2 vUV;","varying vec4 vColor;","varying float vCounters;","","void main() {","",T.logdepthbuf_fragment,"","    vec4 c = vColor;","    if( useMap == 1. ) {","\t \tc = texture2D( map, vUV * repeat );","\t } else {","       c = vColor;","\t }","\t c.r = c.r * c.a * markerluminance;","    c.g = c.g * c.a * markerluminance;","    c.b = c.b * c.a * markerluminance;","    if(isbackground){","\t\tc=vec4(vec3(mix(c,vec4(bgcolor,1.0),1.0-c.a)),1.0);","    }","\t c.a = c.a * vColor.a;","    if( useAlphaMap == 1. ) c.a *= texture2D( alphaMap, vUV * repeat ).a;","    if( c.a < alphaTest ) discard;","    if( useDash == 1. ){","        c.a *= ceil(mod(vCounters + dashOffset, dashArray) - (dashArray * dashRatio));","    }","    gl_FragColor = c;","    gl_FragColor.a *= step(vCounters, visibility);","",T.fog_fragment,"}"].join("\n");class Ln extends ji{constructor(e){super({uniforms:Object.assign({},bn.fog,{lineWidth:{value:1},map:{value:null},useMap:{value:0},alphaMap:{value:null},useAlphaMap:{value:0},color:{value:new M(16777215)},opacity:{value:1},resolution:{value:new D(1,1)},sizeAttenuation:{value:1},dashArray:{value:0},dashOffset:{value:0},dashRatio:{value:.5},useDash:{value:0},visibility:{value:1},alphaTest:{value:0},repeat:{value:new D(1,1)},offset:{value:new D(1,1)},markerluminance:{value:1},isbackground:{value:!1},bgcolor:{value:new M(16777215)}}),vertexShader:T.meshline_vert,fragmentShader:T.meshline_frag}),this.isMeshLineMaterial=!0,this.type="MeshLineMaterial",Object.defineProperties(this,{lineWidth:{enumerable:!0,get:function(){return this.uniforms.lineWidth.value},set:function(e){this.uniforms.lineWidth.value=e}},map:{enumerable:!0,get:function(){return this.uniforms.map.value},set:function(e){this.uniforms.map.value=e}},useMap:{enumerable:!0,get:function(){return this.uniforms.useMap.value},set:function(e){this.uniforms.useMap.value=e}},alphaMap:{enumerable:!0,get:function(){return this.uniforms.alphaMap.value},set:function(e){this.uniforms.alphaMap.value=e}},useAlphaMap:{enumerable:!0,get:function(){return this.uniforms.useAlphaMap.value},set:function(e){this.uniforms.useAlphaMap.value=e}},color:{enumerable:!0,get:function(){return this.uniforms.color.value},set:function(e){this.uniforms.color.value=e}},opacity:{enumerable:!0,get:function(){return this.uniforms.opacity.value},set:function(e){this.uniforms.opacity.value=e}},resolution:{enumerable:!0,get:function(){return this.uniforms.resolution.value},set:function(e){this.uniforms.resolution.value.copy(e)}},sizeAttenuation:{enumerable:!0,get:function(){return this.uniforms.sizeAttenuation.value},set:function(e){this.uniforms.sizeAttenuation.value=e}},dashArray:{enumerable:!0,get:function(){return this.uniforms.dashArray.value},set:function(e){this.uniforms.dashArray.value=e,this.useDash=0!==e?1:0}},dashOffset:{enumerable:!0,get:function(){return this.uniforms.dashOffset.value},set:function(e){this.uniforms.dashOffset.value=e}},dashRatio:{enumerable:!0,get:function(){return this.uniforms.dashRatio.value},set:function(e){this.uniforms.dashRatio.value=e}},useDash:{enumerable:!0,get:function(){return this.uniforms.useDash.value},set:function(e){this.uniforms.useDash.value=e}},visibility:{enumerable:!0,get:function(){return this.uniforms.visibility.value},set:function(e){this.uniforms.visibility.value=e}},alphaTest:{enumerable:!0,get:function(){return this.uniforms.alphaTest.value},set:function(e){this.uniforms.alphaTest.value=e}},repeat:{enumerable:!0,get:function(){return this.uniforms.repeat.value},set:function(e){this.uniforms.repeat.value.copy(e)}},offset:{enumerable:!0,get:function(){return this.uniforms.offset.value},set:function(e){this.uniforms.offset.value.copy(e)}},markerluminance:{enumerable:!0,get:function(){return this.uniforms.markerluminance.value},set:function(e){this.uniforms.markerluminance.value=e}},isbackground:{enumerable:!0,get:function(){return this.uniforms.isbackground.value},set:function(e){this.uniforms.isbackground.value=e}},bgcolor:{enumerable:!0,get:function(){return this.uniforms.bgcolor.value},set:function(e){this.uniforms.bgcolor.value=e}}}),this.setValues(e)}}Ln.prototype.copy=function(e){return ji.prototype.copy.call(this,e),this.lineWidth=e.lineWidth,this.map=e.map,this.useMap=e.useMap,this.alphaMap=e.alphaMap,this.useAlphaMap=e.useAlphaMap,this.color.copy(e.color),this.opacity=e.opacity,this.resolution.copy(e.resolution),this.sizeAttenuation=e.sizeAttenuation,this.dashArray.copy(e.dashArray),this.dashOffset.copy(e.dashOffset),this.dashRatio.copy(e.dashRatio),this.useDash=e.useDash,this.visibility=e.visibility,this.alphaTest=e.alphaTest,this.repeat.copy(e.repeat),this};class Tn extends sr{constructor(e,t){super(e,t),void 0===this.P&&(this.P=1),this.xe=e.isFlat,void 0===this.xe&&(this.xe=!1),this.Me=e.isBezier,this.D=null,this.J=e.smoothparam,void 0===this.J&&(this.J=35),this.K=null,this.te=null,this.$=!1,this.ee=!1,this.O=e.count,this.Se=!1,void 0===this.O&&(this.le=!0,this.Me||(this.Se=!0)),this.we=e.sizeAttenuation,void 0!==this.we&&this.we?this.we=1:this.we=0,this.ye=e.depth,void 0===this.ye&&(this.ye=!0),this.be=null,this.de=void 0,this.ue=void 0}}Object.assign(Tn.prototype,{se(){var t=this.B(this.L,0,this.N);let i=new ki;if(this.Me)i=new Ui(t[0],t[1],t[2],t[3]);else for(let e=0;e<t.length-1;e++){var r=new pi(t[e],t[e+1]);i.curves.push(r)}let e=window.innerWidth,s=window.innerHeight;var a=this.I,a=(a&&(e=a.getContainer().clientWidth,s=a.getContainer().clientHeight,a.on("resize",this.H.resize)),new Ln({useMap:0,color:new M(this.T),opacity:this.A,resolution:new D(e,s),sizeAttenuation:this.we,lineWidth:2*this.P,transparent:!0,depthTest:this.ye})),n=(a.polygonOffset=!0,a.polygonOffsetFactor=-1,a.polygonOffsetUnits=-4,void 0!==this.R&&(a.visible=!1),new A);return this.Se?n.setPoints(this.Ee(t,i)):n.setPoints(i.getPoints(this.J)),this.D=new di(n.geometry,a),this.D.raycast=En,this.D.mapNode=this.H,void 0!==this.R&&this.G(this.R,(e,t,i)=>{this.le&&(1===this.we?this.O=this.k(t,i,2*this.P,this.L):(r=this.Ce(),this.be={width:t,height:i},this.O=this.k(t,i,2*this.P*r,this.L)));var r,t=this.W(e,1);t.wrapS=t.wrapT=we,this.D.material.color=new M("#FFFFFF"),this.D.material.useMap=1,this.D.material.map=t,this.D.material.repeat=new D(this.O,1),this.D.material.visible=!0,this.V()}),this.V(),!0},Ee(e,t){var i=[],r=new N,s=e.length*this.J;for(let e=0;e<s;e++)r=t.getPointAt(e/s,r),i.push(r);return i},Ce(){var e={x:document.body.clientWidth/2,y:document.body.clientHeight/2,z:this.U.height,buildingID:this.U.parent.buildingID},t={x:e.x+1,y:e.y,z:this.U.height,buildingID:this.U.parent.buildingID},e=fengmap.FMUtil.coordsScreenToMap(this.I,e),t=fengmap.FMUtil.coordsScreenToMap(this.I,t);return Math.sqrt((e.x-t.x)*(e.x-t.x)+(e.y-t.y)*(e.y-t.y))}});class An extends hr{constructor(e){super(e),super.setType(t.LINE3D_MARKER),this.tool=new Tn(e,this),this.updateZoom=this.updateZoom.bind(this)}get url(){return this.tool.R}set url(e){this.tool.R=e,void 0!==this.tool.R&&this.tool.G(this.tool.R,(e,t,i)=>{this.tool.le&&(1===this.tool.we?this.tool.O=this.tool.k(t,i,2*this.tool.P,this.tool.L):(r=this.tool.Ce(),this.tool.be={width:t,height:i},this.tool.O=this.tool.k(t,i,2*this.tool.P*r,this.tool.L)));var r,t=new tr(e);t.wrapS=t.wrapT=we,this.tool.D.material.color=new M("#FFFFFF"),this.tool.D.material.useMap=1,this.tool.D.material.map=t,this.tool.D.material.repeat=new D(this.tool.O,1),this.tool.V()})}get isBezier(){return this.tool.Me}set isBezier(e){e&&4!==this.tool.L.length?console.error("贝塞尔需要四个坐标点"):(this.tool.Me=e,this.reCreateObject())}get sizeAttenuation(){return 0!==this.tool.we}set sizeAttenuation(e){this.tool.we=e?1:0,this.tool.D.material.sizeAttenuation=this.tool.we,this.tool.V()}get depth(){return this.tool.ye}set depth(e){this.tool.ye=e,this.tool.D.material.depthTest=this.tool.ye,this.tool.V()}addTo(e){super.addTo(e),this.tool.I.on("zoom",this.updateZoom)}remove(){super.remove(),this.tool.I.off("zoom",this.updateZoom)}updateZoom(){var e;void 0!==this.tool.O&&0===this.tool.we&&this.tool.le&&(e=this.tool.Ce(),1<=(e=this.tool.k(this.tool.be.width,this.tool.be.height,2*this.tool.P*e,this.tool.L)))&&(this.tool.O=e,this.tool.D.material.repeat=new D(this.tool.O,1))}}class Pn extends L{constructor(i=1,r=32,s=16,a=0,n=2*Math.PI,o=0,h=Math.PI){super(),this.type="SphereGeometry",this.parameters={radius:i,widthSegments:r,heightSegments:s,phiStart:a,phiLength:n,thetaStart:o,thetaLength:h},r=Math.max(3,Math.floor(r)),s=Math.max(2,Math.floor(s));var l=Math.min(o+h,Math.PI);let c=0;var d=[],u=new N,f=new N,m=[],p=[],v=[],g=[];for(let e=0;e<=s;e++){var _=[],x=e/s;let t=0;0===e&&0===o?t=.5/r:e===s&&l===Math.PI&&(t=-.5/r);for(let e=0;e<=r;e++){var M=e/r;u.x=-i*Math.cos(a+M*n)*Math.sin(o+x*h),u.y=i*Math.cos(o+x*h),u.z=i*Math.sin(a+M*n)*Math.sin(o+x*h),p.push(u.x,u.y,u.z),f.copy(u).normalize(),v.push(f.x,f.y,f.z),g.push(M+t,1-x),_.push(c++)}d.push(_)}for(let t=0;t<s;t++)for(let e=0;e<r;e++){var S=d[t][e+1],w=d[t][e],y=d[t+1][e],b=d[t+1][e+1];(0!==t||0<o)&&m.push(S,w,b),(t!==s-1||l<Math.PI)&&m.push(w,y,b)}this.setIndex(m),this.setAttribute("position",new E(p,3)),this.setAttribute("normal",new E(v,3)),this.setAttribute("uv",new E(g,2))}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}static fromJSON(e){return new Pn(e.radius,e.widthSegments,e.heightSegments,e.phiStart,e.phiLength,e.thetaStart,e.thetaLength)}}class Nn extends sr{constructor(e,t){super(e,t),this.O=1,this.Le=e.isHemiSphere,void 0===this.Le&&(this.Le=!0),this.t=e.x,this.i=e.y,this.T=e.color,void 0===this.A&&(this.A=.5),void 0===this.P&&(this.P=8),this.L=[{x:this.t+this.P,y:this.i},{x:this.t-this.P,y:this.i},{x:this.t,y:this.i+this.P},{x:this.t,y:this.i-this.P}],this.Te=null,this.ce=null,this.$=!1,this.Ae=!1}}Object.assign(Nn.prototype,{se(){let e=null;return e=this.Le?new Pn(this.P,32,16,0,2*Math.PI,0,Math.PI/2):new Pn(this.P,32,16,0,2*Math.PI,0,Math.PI),this.D=this.X(this.H,e,this.T,this.A,this.R,1),this.V(),this.Pe(),!0},Pe(){var e=this.I;if(!e)return!1;this.Le?this.D.position.set(this.t-e.x,this.N,-this.i+e.y):this.D.position.set(this.t-e.x,this.N+this.P,-this.i+e.y)}});class Dn extends hr{constructor(e){super(e),super.setType(t.SPHERE_MARKER),this.tool=new Nn(e,this)}get points(){return this.tool.L}set points(e){}set count(e){}get count(){return 1}get color(){return this.tool.T}set color(e){this.tool.T=e,"ShaderMaterial"===this.tool.D.material.type?(this.tool.D.material.uniforms.color.value=new M(e),this.tool.D.material.uniforms.iscolor.value=!0):this.tool.D.material.color=new M(e),this.tool.V()}get height(){return this.tool.N}set height(e){this.tool.N=e,this.tool.Pe(),this.tool.V()}set radius(e){this.tool.P=e,this.reCreateObject()}get radius(){return this.tool.P}set x(e){this.tool.t=e,this.tool.Pe(),this.tool.V()}get x(){return this.tool.t}set y(e){this.tool.i=e,this.tool.Pe(),this.tool.V()}get y(){return this.tool.i}set isHemiSphere(e){this.tool.Le=e,this.reCreateObject()}get isHemiSphere(){return this.tool.Le}addEffect(e){if("FMDiffusion"!==e.type)console.error("半圆覆盖物只能添加扩散效果");else{let t=this.tool.I;t&&(this.tool.ce=e,this.tool.ce.getMaterial(this,e=>{this.tool.$||(this.tool.D.material.dispose(),this.tool.D.material=e,this.tool.Ae=!0,t.on("update",this.update),this.tool.$=!0)}))}}removeEffect(){this.tool.ce=null;var e=this.tool.I;e&&(e.off("update",this.update),e=new zt({color:new M(this.tool.T),opacity:this.tool.A,transparent:!0}),void 0!==this.tool.R&&(e.visible=!1),this.tool.D.material=e,this.tool.D.scale.set(1,1,1),void 0!==this.tool.R&&this.tool.G(this.tool.R,e=>{this.tool.j(e)}),this.tool.$=!1,this.tool.V())}}class Rn{constructor(e,t){this.isInterleavedBuffer=!0,this.array=e,this.stride=t,this.count=void 0!==e?e.length/t:0,this.usage=ze,this.updateRanges=[],this.version=0,this.uuid=O()}onUploadCallback(){}set needsUpdate(e){!0===e&&this.version++}setUsage(e){return this.usage=e,this}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}copy(e){return this.array=new e.array.constructor(e.array),this.count=e.count,this.stride=e.stride,this.usage=e.usage,this}copyAt(i,r,s){i*=this.stride,s*=r.stride;for(let e=0,t=this.stride;e<t;e++)this.array[i+e]=r.array[s+e];return this}set(e,t=0){return this.array.set(e,t),this}clone(e){void 0===e.arrayBuffers&&(e.arrayBuffers={}),void 0===this.array.buffer.Ne&&(this.array.buffer.Ne=O()),void 0===e.arrayBuffers[this.array.buffer.Ne]&&(e.arrayBuffers[this.array.buffer.Ne]=this.array.slice(0).buffer);e=new this.array.constructor(e.arrayBuffers[this.array.buffer.Ne]),e=new this.constructor(e,this.stride);return e.setUsage(this.usage),e}onUpload(e){return this.onUploadCallback=e,this}toJSON(e){return void 0===e.arrayBuffers&&(e.arrayBuffers={}),void 0===this.array.buffer.Ne&&(this.array.buffer.Ne=O()),void 0===e.arrayBuffers[this.array.buffer.Ne]&&(e.arrayBuffers[this.array.buffer.Ne]=Array.from(new Uint32Array(this.array.buffer))),{uuid:this.uuid,buffer:this.array.buffer.Ne,type:this.array.constructor.name,stride:this.stride}}}let P=new N;class In{constructor(e,t,i,r=!1){this.isInterleavedBufferAttribute=!0,this.name="",this.data=e,this.itemSize=t,this.offset=i,this.normalized=r}get count(){return this.data.count}get array(){return this.data.array}set needsUpdate(e){this.data.needsUpdate=e}applyMatrix4(i){for(let e=0,t=this.data.count;e<t;e++)P.fromBufferAttribute(this,e),P.applyMatrix4(i),this.setXYZ(e,P.x,P.y,P.z);return this}applyNormalMatrix(i){for(let e=0,t=this.count;e<t;e++)P.fromBufferAttribute(this,e),P.applyNormalMatrix(i),this.setXYZ(e,P.x,P.y,P.z);return this}transformDirection(i){for(let e=0,t=this.count;e<t;e++)P.fromBufferAttribute(this,e),P.transformDirection(i),this.setXYZ(e,P.x,P.y,P.z);return this}getComponent(e,t){let i=this.array[e*this.data.stride+this.offset+t];return i=this.normalized?r(i,this.array):i}setComponent(e,t,i){return this.normalized&&(i=a(i,this.array)),this.data.array[e*this.data.stride+this.offset+t]=i,this}setX(e,t){return this.normalized&&(t=a(t,this.array)),this.data.array[e*this.data.stride+this.offset]=t,this}setY(e,t){return this.normalized&&(t=a(t,this.array)),this.data.array[e*this.data.stride+this.offset+1]=t,this}setZ(e,t){return this.normalized&&(t=a(t,this.array)),this.data.array[e*this.data.stride+this.offset+2]=t,this}setW(e,t){return this.normalized&&(t=a(t,this.array)),this.data.array[e*this.data.stride+this.offset+3]=t,this}getX(e){let t=this.data.array[e*this.data.stride+this.offset];return t=this.normalized?r(t,this.array):t}getY(e){let t=this.data.array[e*this.data.stride+this.offset+1];return t=this.normalized?r(t,this.array):t}getZ(e){let t=this.data.array[e*this.data.stride+this.offset+2];return t=this.normalized?r(t,this.array):t}getW(e){let t=this.data.array[e*this.data.stride+this.offset+3];return t=this.normalized?r(t,this.array):t}setXY(e,t,i){return e=e*this.data.stride+this.offset,this.normalized&&(t=a(t,this.array),i=a(i,this.array)),this.data.array[e+0]=t,this.data.array[e+1]=i,this}setXYZ(e,t,i,r){return e=e*this.data.stride+this.offset,this.normalized&&(t=a(t,this.array),i=a(i,this.array),r=a(r,this.array)),this.data.array[e+0]=t,this.data.array[e+1]=i,this.data.array[e+2]=r,this}setXYZW(e,t,i,r,s){return e=e*this.data.stride+this.offset,this.normalized&&(t=a(t,this.array),i=a(i,this.array),r=a(r,this.array),s=a(s,this.array)),this.data.array[e+0]=t,this.data.array[e+1]=i,this.data.array[e+2]=r,this.data.array[e+3]=s,this}clone(e){if(void 0!==e)return void 0===e.interleavedBuffers&&(e.interleavedBuffers={}),void 0===e.interleavedBuffers[this.data.uuid]&&(e.interleavedBuffers[this.data.uuid]=this.data.clone(e)),new In(e.interleavedBuffers[this.data.uuid],this.itemSize,this.offset,this.normalized);var t=[];for(let e=0;e<this.count;e++){var i=e*this.data.stride+this.offset;for(let e=0;e<this.itemSize;e++)t.push(this.data.array[i+e])}return new R(new this.array.constructor(t),this.itemSize,this.normalized)}toJSON(e){if(void 0!==e)return void 0===e.interleavedBuffers&&(e.interleavedBuffers={}),void 0===e.interleavedBuffers[this.data.uuid]&&(e.interleavedBuffers[this.data.uuid]=this.data.toJSON(e)),{isInterleavedBufferAttribute:!0,itemSize:this.itemSize,data:this.data.uuid,offset:this.offset,normalized:this.normalized};var t=[];for(let e=0;e<this.count;e++){var i=e*this.data.stride+this.offset;for(let e=0;e<this.itemSize;e++)t.push(this.data.array[i+e])}return{itemSize:this.itemSize,type:this.array.constructor.name,array:t,normalized:this.normalized}}}class Un extends kt{constructor(e){super(),this.isSpriteMaterial=!0,this.type="SpriteMaterial",this.color=new M(16777215),this.map=null,this.alphaMap=null,this.rotation=0,this.sizeAttenuation=!0,this.transparent=!0,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.alphaMap=e.alphaMap,this.rotation=e.rotation,this.sizeAttenuation=e.sizeAttenuation,this.fog=e.fog,this}}let On,Fn=new N,Hn=new N,Vn=new N,Gn=new D,kn=new D,zn=new _,Bn=new N,Wn=new N,Yn=new N,Xn=new D,jn=new D,qn=new D;class Zn extends u{constructor(e=new Un){var t;super(),this.isSprite=!0,this.type="Sprite",void 0===On&&(On=new L,t=new Float32Array([-.5,-.5,0,0,0,.5,-.5,0,1,0,.5,.5,0,1,1,-.5,.5,0,0,1]),t=new Rn(t,5),On.setIndex([0,1,2,0,2,3]),On.setAttribute("position",new In(t,3,0,!1)),On.setAttribute("uv",new In(t,2,3,!1))),this.geometry=On,this.material=e,this.center=new D(.5,.5)}raycast(e,t){null===e.camera&&console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'),Hn.setFromMatrixScale(this.matrixWorld),zn.copy(e.camera.matrixWorld),this.modelViewMatrix.multiplyMatrices(e.camera.matrixWorldInverse,this.matrixWorld),Vn.setFromMatrixPosition(this.modelViewMatrix),e.camera.isPerspectiveCamera&&!1===this.material.sizeAttenuation&&Hn.multiplyScalar(-Vn.z);var i=this.material.rotation;let r,s;0!==i&&(s=Math.cos(i),r=Math.sin(i));var i=this.center,a=(Jn(Bn.set(-.5,-.5,0),Vn,i,Hn,r,s),Jn(Wn.set(.5,-.5,0),Vn,i,Hn,r,s),Jn(Yn.set(.5,.5,0),Vn,i,Hn,r,s),Xn.set(0,0),jn.set(1,0),qn.set(1,1),e.ray.intersectTriangle(Bn,Wn,Yn,!1,Fn));null===a&&(Jn(Wn.set(-.5,.5,0),Vn,i,Hn,r,s),jn.set(0,1),null===(a=e.ray.intersectTriangle(Bn,Yn,Wn,!1,Fn)))||(i=e.ray.origin.distanceTo(Fn))<e.near||i>e.far||t.push({distance:i,point:Fn.clone(),uv:g.getInterpolation(Fn,Bn,Wn,Yn,Xn,jn,qn,new D),face:null,object:this})}copy(e,t){return super.copy(e,t),void 0!==e.center&&this.center.copy(e.center),this.material=e.material,this}}function Jn(e,t,i,r,s,a){Gn.subVectors(e,i).addScalar(.5).multiply(r),void 0!==s?(kn.x=a*Gn.x-s*Gn.y,kn.y=s*Gn.x+a*Gn.y):kn.copy(Gn),e.copy(t),e.x+=kn.x,e.y+=kn.y,e.applyMatrix4(zn)}class Kn extends L{constructor(e=1,t=1,i=1,r=1){super(),this.type="PlaneGeometry",this.parameters={width:e,height:t,widthSegments:i,heightSegments:r};var s=e/2,a=t/2,n=Math.floor(i),o=Math.floor(r),h=n+1,l=o+1,c=e/n,d=t/o,u=[],f=[],m=[],p=[];for(let t=0;t<l;t++){var v=t*d-a;for(let e=0;e<h;e++){var g=e*c-s;f.push(g,-v,0),m.push(0,0,1),p.push(e/n),p.push(1-t/o)}}for(let t=0;t<o;t++)for(let e=0;e<n;e++){var _=e+h*t,x=e+h*(t+1),M=e+1+h*(t+1),S=e+1+h*t;u.push(_,x,S),u.push(x,M,S)}this.setIndex(u),this.setAttribute("position",new E(f,3)),this.setAttribute("normal",new E(m,3)),this.setAttribute("uv",new E(p,2))}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}static fromJSON(e){return new Kn(e.width,e.height,e.widthSegments,e.heightSegments)}}class Qn extends er{constructor(t,e,i,r,s,a,n,o,h){super(t,e,i,r,s,a,n,o,h),this.isVideoTexture=!0,this.minFilter=void 0!==a?a:Ee,this.magFilter=void 0!==s?s:Ee,this.generateMipmaps=!1;let l=this;"requestVideoFrameCallback"in t&&t.requestVideoFrameCallback(function e(){l.needsUpdate=!0,t.requestVideoFrameCallback(e)})}clone(){return new this.constructor(this.image).copy(this)}update(){var e=this.image;!1=="requestVideoFrameCallback"in e&&e.readyState>=e.HAVE_CURRENT_DATA&&(this.needsUpdate=!0)}}class $n extends L{constructor(){super();var e=new Float32Array([-.5,0,-.5,0,0,.5,0,-.5,1,0,.5,0,.5,1,1,-.5,0,.5,0,1]),e=new Rn(e,5);this.setIndex([0,1,2,0,2,3]),this.setAttribute("position",new In(e,3,0,!1)),this.setAttribute("uv",new In(e,2,3,!1))}}let I={RIGHT:2,LEFT:4,BOTTOM:8,TOP:16,RIGHT_BOTTOM:32,LEFT_BOTTOM:64,RIGHT_TOP:128,LEFT_TOP:256,CENTER:512};Object.freeze(I);class eo{constructor(){}static convertPointCoordsByCenter(e,t){return e.x=e.x-t.x,e.y=e.y-t.y,void 0!==e.z&&void 0!==t.z&&(e.z=e.z-t.z),e}static convertPointsCoordsByCenter(t,i){for(let e=0;e<t.length;e++)this.convertPointCoordsByCenter(t[e],i);return t}static getMapScaleInfo(){if(!eo.scaleInfo){let e;if(jt.environment===Xt.WX)return 96/2.54;var t;window.screen.deviceXDPI?e=window.screen.deviceXDPI:((t=document.createElement("DIV")).style.cssText="width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden",document.body.appendChild(t),e=parseInt(t.offsetWidth),t.parentNode.removeChild(t)),eo.scaleInfo=e/2.54}return eo.scaleInfo}static getCenterByAnchor(e){var t=new D(.5,.5);switch(e){case I.LEFT:t.setX(0);break;case I.RIGHT:t.setX(1);break;case I.TOP:t.setY(1);break;case I.BOTTOM:t.setY(0);break;case I.LEFT_TOP:t.set(0,1);break;case I.RIGHT_TOP:t.set(1,1);break;case I.LEFT_BOTTOM:t.set(0,0);break;case I.RIGHT_BOTTOM:t.set(1,0)}return t}static uniqWithArrayOne(e){let t=[];return e.forEach(e=>{t.includes(e)||t.push(e)}),t}static uniqWithArrayTwo(i){if(i.length<1)return[];i=JSON.parse(JSON.stringify(i));let r=[];for(let t=0;t<i.length;t++){let e=this.uniqWithArrayOne(i[t]);e=e.filter(e=>!r.includes(e)),i[t]=e,r=r.concat(e)}return i.filter(e=>0<e.length)}static compareArrays(t,i){if(t.length!==i.length)return!1;for(let e=0;e<t.length;e++){var r,s=t[e],a=i[e];if(Object.keys(s).length!==Object.keys(a).length)return!1;for(r in s)if(s[r]&&a[r]&&s[r]!==a[r])return!1}return!0}}let to={FOV:35,CAMERA_NEAR:1,CAMERA_FAR:1e5,ZOOM_UPPER_BOUND:30,TILT_UPPER_BOUND:90,THOUSAND:1e3,DEG2RAD:.0174532,RAD2DEG:57.2957795,DRAW_TIME:500,EPS:.001};Object.freeze(to);class io{constructor(e,t){this.H=e,this.De=t,this.Re=void 0!==t.depth&&t.depth,this.Ie=null,this.Ue=!1}createFlatMesh(e){var t=new zt,i=(t.visible=!1,new $n),i=new di(i,t);let r=this.De.tilt,s=(void 0===r&&(r=0),this.De.heading);void 0===s&&(s=0);var t=r%360*Math.PI/180,a=-s%360*Math.PI/180-Math.PI;return this.updateMeshAngle(i,t,a,-Math.PI),i.renderOrder=1,i.position.x=e.position.x,i.position.y=e.position.y,i.position.z=e.position.z,i.mapNode=this.H,i}createRectMesh(e){var i=this.De.rectangle,r=new zt,i=(r.visible=!1,new Kn(i.size.x,i.size.y)),i=new di(i,r);if(i.mapNode=this.H,"rectangle"===this.H.renderType){let e=this.De.tilt,t=(void 0===e&&(e=0),this.De.heading);void 0===t&&(t=0);var r=-Math.PI/2+e%360*Math.PI/180,s=t%360*Math.PI/180;this.updateMeshAngle(i,r,s)}return i.position.x=e.position.x,i.position.y=e.position.y,i.position.z=e.position.z,i}updateMeshAngle(e,t,i,r){var s=new V,s=(s.setFromAxisAngle(new N(1,0,0),t),e.quaternion.copy(s),e.userData.tilt=t,e.quaternion.clone()),t=new V;t.setFromAxisAngle(new N(0,1,0),i),e.quaternion.copy(t),e.quaternion.multiply(s).normalize(),e.userData.heading=i,void 0!==r&&(s=e.quaternion.clone(),(t=new V).setFromAxisAngle(new N(0,0,1),-Math.PI),e.quaternion.copy(t),e.quaternion.multiply(s).normalize())}editFlatMaterial(r,s){r.depthTest=!1,r.depthWrite=!1,r.transparent=!0,void 0!==this.De.opacity?r.opacity=this.De.opacity:r.opacity=1,r.side=me,this.editMaterial(r),this.H.url&&(0<=this.H.url.indexOf(".mp4")||0<=this.H.url.indexOf(".webm")||0<=this.H.url.indexOf(".ogg"))?this.createVideo(this.H.url,(e,t,i)=>{this.H.size=this.H.imagesize[0]*i/t,r.userData.scaleRatio=i/t,r.userData.mspriteScale=1,r.map=e,r.depthTest=this.Re,r.depthWrite=this.Re,"rectangle"===this.H.renderType&&(r.polygonOffset=!0,r.polygonOffsetFactor=-1,r.polygonOffsetUnits=-4,e=this.getRenderNodeScale({width:t,height:i}),this.H.myrenderNode.scale.x=e.x,this.H.myrenderNode.scale.y=e.y,this.H.myrenderNode.scaleinfo=e,t=this.H.myrenderNode.userData.tilt,this.H.myrenderNode.position.y=this.H.height+this.De.rectangle.size.y*e.y*Math.abs(Math.cos(t))/2),s(r)}):this.createCanvas(e=>{var t;this.editTexture(e,r),"image"!==this.De.layout.style&&"text"!==this.De.layout.style&&void 0!==this.De.media&&(this.H.size=e.size,r.userData.mspriteScale=1,r.userData.itHeightRatio=1,r.userData.style=void 0),r.depthTest=this.Re,r.depthWrite=this.Re,"rectangle"===this.H.renderType&&(r.polygonOffset=!0,r.polygonOffsetFactor=-1,r.polygonOffsetUnits=-4,e=this.getRenderNodeScale(e),this.H.myrenderNode.scale.x=e.x,this.H.myrenderNode.scale.y=e.y,this.H.myrenderNode.scaleinfo=e,t=this.H.myrenderNode.userData.tilt,this.H.myrenderNode.position.y=this.H.height+this.De.rectangle.size.y*e.y*Math.abs(Math.cos(t))/2),s&&s(r)})}createSprite(e){var t=new Un,t=(t.visible=!1,new Zn(t));return t.position.x=e.position.x,t.position.y=e.position.y,t.position.z=e.position.z,t.mapNode=this.H,t}editMaterial(e){"billboard"===this.H.renderType&&(e.sizeAttenuation=!1),e.depthTest=!1,e.depthWrite=!1,e.transparent=!0,void 0!==this.De.opacity?e.opacity=this.De.opacity:e.opacity=1,e.side=me}editTexture(e,t){var i=new tr(e);i.minFilter=Ee,i.generateMipmaps=!1,t.map=i,t.userData.scaleRatio=e.height/e.width,t.userData.mspriteScale=e.spriteScale}myUpdateMaterial(r){let s=new Un,a=("billboard"===this.H.renderType&&(s.sizeAttenuation=!1),this.editMaterial(s),this.H.getRenderNode());var e=a.parent;!r&&e&&a.parent.remove(a),this.H.url&&(0<=this.H.url.indexOf(".mp4")||0<=this.H.url.indexOf(".webm")||0<=this.H.url.indexOf(".ogg"))?this.createVideo(this.H.url,(e,t,i)=>{this.H.size=this.H.imagesize[0]*i/t,s.userData.scaleRatio=i/t,s.userData.media=!0,s.map=e,s.depthTest=this.Re,s.depthWrite=this.Re,a.material.map&&a.material.map.dispose(),a.material.dispose(),a.material=s;e=eo.getCenterByAnchor(this.H.myanchor.anchor);"fix_billboard"===this.H.renderType?(a.isNoScale=!0,t=this.getRenderNodeScale({width:t,height:i}),a.scale.x=t.x,a.scale.y=t.y,a.center.set(e.x,e.y)):(a.center.set(e.x,e.y),this.H.updateSize()),setTimeout(()=>{r||(this.H&&this.H.parent&&this.H.parent.scene.add(a),"billboard"===this.H.renderType&&(this.H.collision=this.De.collision)),this.H.map.collisionCheck(),this.H.map.enableUpdateRender()},0)}):this.createCanvas(e=>{this.editTexture(e,s),"image"!==this.De.layout.style&&"text"!==this.De.layout.style&&(s.userData.style=this.De.layout.style,s.userData.itHeightRatio=e.itHeightRatio,void 0!==this.De.media)&&(this.H.size=e.size,s.userData.mspriteScale=1,s.userData.itHeightRatio=1,s.userData.style=void 0,s.userData.media=!0),s.depthTest=this.Re,s.depthWrite=this.Re,a.material.map&&a.material.map.dispose(),a.material.dispose(),a.material=s,"fix_billboard"===this.H.renderType?(a.isNoScale=!0,e=this.getRenderNodeScale(e),a.scale.x=e.x,a.scale.y=e.y):this.H.updateSize(),setTimeout(()=>{r||(this.H&&this.H.parent&&this.H.parent.scene.add(a),this.H.collision=this.De.collision),this.H.map.collisionCheck(),this.H.map.enableUpdateRender()},0)})}getRenderNodeScale(e){var t,i=this.De.rectangle;let r=i.size.x,s=i.size.y;return r<s?(s=r*(e.height/e.width))>i.size.y&&(t=i.size.y/s,s=i.size.y,r*=t):(r=s*(e.width/e.height))>i.size.x&&(t=i.size.x/r,r=i.size.x,s*=t),"fix_billboard"===this.H.renderType?{x:r,y:s}:{x:r/i.size.x,y:s/i.size.y}}createVideo(r,s){let a=this,n=null;var e,t=r+"_div";let i=document.getElementById(t);i?(e=i.getAttribute("num"),e=parseInt(e),i.setAttribute("num",""+(e+1))):((i=document.createElement("div")).style.display="none",i.setAttribute("id",t),i.setAttribute("num","1"),i.innerHTML='<video id="'+r+'" loop crossOrigin="anonymous" muted><source src="'+r+'"></video>',document.body.appendChild(i)),function e(){var t,i=document.getElementById(r);i&&0!==i.videoWidth&&0!==i.videoHeight?(null!==n&&clearTimeout(n),i.play(),(t=new Qn(i)).video_id=r+"_div",s&&s(t,i.videoWidth,i.videoHeight),document.addEventListener("visibilitychange",a.H.visibilitychange),a.Ie=i,a.H.addFrameCallbacks(a.H.vodeoAnimate)):n=setTimeout(e,0)}()}createCanvas(e){this.Ue=!1,"image"===this.De.layout.style?this.createImageCanvas(e):"text"===this.De.layout.style?this.createTextCanvas(e):this.createImageTextCanvas(e),"billboard"!==this.H.renderType||"image"!==this.De.layout.style&&"text"!==this.De.layout.style||(e=eo.getCenterByAnchor(this.H.myanchor.anchor),this.H.getRenderNode().center.set(e.x,e.y))}getCenterByAnchor(t,i,r){if("flat"!==this.H.renderType&&"rectangle"!==this.H.renderType){var s=i.width/r.width,a=t.width/r.width,t=t.height/r.height;let e=null;return e="image"===this.H.myanchor.baseon?n(this.H.myanchor.anchor,s,i.height/r.height):"text"===this.H.myanchor.baseon?n(this.H.myanchor.anchor,a,t):eo.getCenterByAnchor(this.H.myanchor.anchor);function n(e,t,i){var r=new D(t/2,i/2);switch(e){case fengmap.FMMarkerAnchor.LEFT:r.setX(0);break;case fengmap.FMMarkerAnchor.RIGHT:r.setX(t);break;case fengmap.FMMarkerAnchor.TOP:r.setY(i);break;case fengmap.FMMarkerAnchor.BOTTOM:r.setY(0);break;case fengmap.FMMarkerAnchor.LEFT_TOP:r.set(0,i);break;case fengmap.FMMarkerAnchor.RIGHT_TOP:r.set(t,i);break;case fengmap.FMMarkerAnchor.LEFT_BOTTOM:r.set(0,0);break;case fengmap.FMMarkerAnchor.RIGHT_BOTTOM:r.set(t,0)}return r}}}createImageTextCanvas(r){void 0===this.De.layout.spacings&&(this.De.layout.spacings=0),void 0!==this.De.media&&(this.Ue=!0);let s=this.createTextCanvas();var e=s.height/s.factHeight;let a={width:s.factWidth,height:s.factHeight},n={width:this.H.imagesize[0],height:this.H.imagesize[1]};this.createImageCanvas(e=>{let t=null,i=0;i="limage-rtext"===this.De.layout.style||"ltext-rimage"===this.De.layout.style?(t=this.leftRight(s,e),this.leftRight(a,n,!0)):"timage-btext"===this.De.layout.style||"ttext-bimage"===this.De.layout.style?(t=this.topBottom(s,e),this.topBottom(a,n,!0)):(t=this.overlayText(s,e),this.overlayText(a,n,!0)),t.itHeightRatio=e.height/s.height,t.itWidthRatio=e.width/s.width,t.size=i,r&&r(t)},e)}overlayText(e,t,i){let r=this.De.layout.align,s=e.width,a=(s<t.width&&(s=t.width),e.height);if(a<t.height&&(a=t.height),i)return a;var i=document.createElement("canvas"),n=(i.width=s,i.height=a,i.getContext("2d"));let o=0,h=0,l=0,c=0;"center"===(r=void 0===r||r.indexOf("-")<0?"center-center":r).split("-")[0]?(h=a/2-e.height/2,c=a/2-t.height/2):"bottom"===r.split("-")[0]&&(h=a-e.height,c=a-t.height),"right"===r.split("-")[1]?(o=s-e.width,l=s-t.width):"center"===r.split("-")[1]&&(o=s/2-e.width/2,l=s/2-t.width/2);var d=this.getCenterByAnchor(e,t,i);return d&&("all"!==this.H.myanchor.baseon&&("image"===this.H.myanchor.baseon?(d.x=d.x+l/s,d.y=d.y+c/a):(d.x=d.x+o/s,d.y=d.y+h/a)),this.H.getRenderNode().center.set(d.x,d.y)),n.drawImage(t,l,c,t.width,t.height),n.drawImage(e,o,h,e.width,e.height),i.spriteScale=a/e.rowHeight,i}topBottom(e,t,i){var r=this.De.layout.spacings,s=t.height+e.height+r;let a=t.width;if(a<e.width&&(a=e.width),i)return s;var i=document.createElement("canvas"),n=(i.width=a,i.height=s,i.getContext("2d"));let o=this.De.layout.align;var h=this.De.layout.style;let l=0,c=0,d=("timage-btext"===h?c=t.height+r:"ttext-bimage"===h&&(l=e.height+r),(void 0===o||"left"!==o&&"center"!==o&&"right"!==o)&&(o="center"),0),u=0;e.width>t.width?d=(e.width-t.width)/2:e.width<t.width&&(u=(t.width-e.width)/2),"left"===o?(d=0,u=0):"right"===o&&(e.width>t.width?(d=e.width-t.width,u=0):e.width<t.width&&(u=t.width-e.width,d=0));h=this.getCenterByAnchor(e,t,i);return h&&("all"!==this.H.myanchor.baseon&&("image"===this.H.myanchor.baseon?(h.x=h.x+d/a,h.y=h.y+c/s):(h.x=h.x+u/a,h.y=h.y+l/s)),this.H.getRenderNode().center.set(h.x,h.y)),n.drawImage(t,d,l,t.width,t.height),n.drawImage(e,u,c,e.width,e.height),i.spriteScale=s/e.rowHeight,i}leftRight(e,t,i){var r=this.De.layout.spacings,s=t.width+e.width+r;let a=t.height;if(a<e.height&&(a=e.height),i)return a;var i=document.createElement("canvas"),n=(i.width=s,i.height=a,i.getContext("2d"));let o=this.De.layout.align;var h=this.De.layout.style;let l=0,c=0,d=("center"===(o=void 0===o||"top"!==o&&"center"!==o&&"bottom"!==o?"top":o)?t.height>e.height?(l=0,c=(t.height-e.height)/2):t.height<e.height&&(l=(e.height-t.height)/2,c=0):"bottom"===o&&(t.height>e.height?(l=0,c=t.height-e.height):t.height<e.height&&(l=e.height-t.height,c=0)),0),u=0;"limage-rtext"===h?u=t.width+r:"ltext-rimage"===h&&(d=e.width+r);h=this.getCenterByAnchor(e,t,i);return h&&("all"!==this.H.myanchor.baseon&&("image"===this.H.myanchor.baseon?(h.x=h.x+d/s,h.y=h.y+l/a):(h.x=h.x+u/s,h.y=h.y+c/a)),this.H.getRenderNode().center.set(h.x,h.y)),n.drawImage(t,d,l,t.width,t.height),n.drawImage(e,u,c,e.width,e.height),i.spriteScale=a/e.rowHeight,i}createImageCanvas(t,i){void 0===i&&(i=1);let r=document.createElement("canvas"),s=(r.width=this.H.imagesize[0]*i,r.height=this.H.imagesize[1]*i,r.spriteScale=1,r.getContext("2d"));if(this.H.url){let e=new Image;e.crossOrigin="Anonymous",e.onload=()=>{s.drawImage(e,0,0,this.H.imagesize[0]*i,this.H.imagesize[1]*i),t&&t(r)},e.src=this.H.url}else t&&t(r)}createTextCanvas(e){var t=this.getTextInfo(),i=this.getCanvasInfo(t),r=document.createElement("canvas"),s=(r.width=i.width,r.height=i.height,r.getContext("2d")),s=(this.drawText(s,t,i),this.drawPlate(r,i,t));let a=1;if((1<t.length||"text"!==this.De.layout.style)&&(a=r.height/i.rowHeight),s.spriteScale=a,s.rowHeight=i.rowHeight,this.H.size=i.size,!e)return s;e(s)}drawPlate(e,t,i){let r=this.De.text.padding;void 0===r&&(r=[0,0,0,0]);var s=this.De.text.plateColor,a=this.De.text.plateStrokeColor;let n=this.De.text.plateStrokeWidth,o=this.De.text.plateOpacity,h=this.De.text.plateStrokeRadius;if(void 0!==a&&void 0===n&&(n=1),void 0===o&&(o=1),void 0===h&&(h=0),void 0===s&&void 0===a)return e.factWidth=t.width,e.factHeight=t.height,this.Ue&&(l=this.getCanvasInfo(i,!0),e.factWidth=l.width,e.factHeight=l.height),e;var l=document.createElement("canvas");let c=0;void 0!==a?c=4*n:n=0,l.width=t.width+2*(r[1]+r[3])+c,l.height=t.height+2*(r[0]+r[2])+c,l.factWidth=t.width+2*(r[1]+r[3])+c,l.factHeight=t.height+2*(r[0]+r[2])+c,this.Ue&&(d=this.getCanvasInfo(i,!0),l.factWidth=d.width+(r[1]+r[3])+2*n,l.factHeight=d.height+(r[0]+r[2])+2*n);var d=l.getContext("2d");if(void 0!==s){if(0===h)d.rect(0,0,l.width,l.height);else{var u=2*n,f=l.width-u,m=l.height-u;let e=h;var p=u/2,u=u/2;m<2*(e=f<2*e?f/2:e)&&(e=m/2),d.beginPath(),d.moveTo(p+e,u),d.arcTo(p+f,u,p+f,u+m,e),d.arcTo(p+f,u+m,p,u+m,e),d.arcTo(p,u+m,p,u,e),d.arcTo(p,u,p+f,u,e)}d.fillStyle=v(s,o),d.fill()}if(void 0!==a){if(d.lineWidth=2*n,0===h)d.rect(d.lineWidth/2,d.lineWidth/2,l.width-d.lineWidth,l.height-d.lineWidth);else{m=l.width-d.lineWidth,p=l.height-d.lineWidth;let e=h;f=d.lineWidth/2,u=d.lineWidth/2;p<2*(e=m<2*e?m/2:e)&&(e=p/2),d.beginPath(),d.moveTo(f+e,u),d.arcTo(f+m,u,f+m,u+p,e),d.arcTo(f+m,u+p,f,u+p,e),d.arcTo(f,u+p,f,u,e),d.arcTo(f,u,f+m,u,e)}d.strokeStyle=v(a,o),d.stroke()}return d.drawImage(e,2*(r[3]+n),2*(r[0]+n),e.width,e.height),1<i.length?t.size=t.size+(r[0]+r[2]+2*n)/i.length:t.size=t.size+(r[0]+r[2]+n)/i.length,l;function v(e,t){return e=e||"#ededed","rgba("+parseInt("0x"+e.slice(1,3))+","+parseInt("0x"+e.slice(3,5))+","+parseInt("0x"+e.slice(5,7))+","+(t||"1")+")"}}drawText(h,i,r){if(h.textBaseline="alphabetic",1===i.length){var e=i[0],t=2*e.fontSize*1.2;n(e,2,r,r.height/2+t/3)}else{let t=0;for(let e=0;e<i.length;e++){var s=i[e],a=2*s.fontSize*1.2;0===e?t+=a:t=t+a+2*s.lineSpacing,n(s,2,r,t)}}function n(e,t,i,r){var s=e.text,a=e.fontSize*t*1.2;let n=a+"px "+e.fontFamily,o=(void 0!==e.fontWeight&&(n=e.fontWeight+" "+a+"px "+e.fontFamily),h.font=n,1);void 0!==e.strokeColor?(h.strokeStyle=e.strokeColor,void 0===e.strokeWidth||isNaN(""+e.strokeWidth)||(o=parseFloat(""+e.strokeWidth)),h.lineWidth=2*t*o):o=0,h.fillStyle=e.fillColor,e.textAlign===fengmap.FMTextAlign.Left?(h.textAlign="left",0!==o&&h.strokeText(s,0,r),h.fillText(s,0,r)):e.textAlign===fengmap.FMTextAlign.Right?(h.textAlign="right",0!==o&&h.strokeText(s,i.width,r),h.fillText(s,i.width,r)):(h.textAlign="center",0!==o&&h.strokeText(s,i.width/2,r),h.fillText(s,i.width/2,r))}}getCanvasInfo(i,e){let r=2,s=1.2;e&&(r=1,s=1);var a=document.createElement("canvas").getContext("2d");a.textBaseline="alphabetic";let n=null,o=0,h=null,l=0,c=0;for(let t=0;t<i.length;t++){var d=i[t].fontSize*r*s;(null===h||h<i[t].fontSize)&&(h=i[t].fontSize);let e=d+"px "+i[t].fontFamily;void 0!==i[t].fontWeight&&(e=i[t].fontWeight+" "+d+"px "+i[t].fontFamily),a.font=e;var u=a.measureText(i[t].text).width,f=d+i[t].lineSpacing*r;l=l+d+i[t].lineSpacing*r,c+=i[t].lineSpacing,o+=f,(null===n||n<u)&&(n=u)}let t=h,m=(1<i.length&&(t+=c/i.length),this.De.text.padding);void 0===m&&(m=[0,0,0,0]);e=this.De.text.plateStrokeColor;let p=this.De.text.plateStrokeWidth;return void 0===(p=void 0!==e&&void 0===p?1:p)&&(p=0),{width:n,height:o,fontHeight:o,size:t,rowHeight:(l+(m[0]+m[2])*r+2*p*r)/i.length}}getTextInfo(){var e=this.H.map,t=this.De.text.content;let i=t.lineSpacing,r=((i=void 0===i?2:i)<2&&(i=2),t.textAlign),s=(void 0===r&&(r=fengmap.FMTextAlign.Center),t.fontSize);void 0===s&&(s=20);var a=t.fontWeight;let n=t.fontFamily,o=(void 0===n&&(n=e.getMapOptions().fontFamily),t.fillColor);void 0===o&&(o="#000000");var h=t.strokeColor;let l=t.strokeWidth;void 0!==h&&void 0===l&&(l=1);var c=t.text,d=[];if("string"==typeof c)if(c.indexOf("%rn%")<0)d.push({textAlign:r,fontSize:s,fontWeight:a,fontFamily:n,fillColor:o,strokeColor:h,strokeWidth:l,lineSpacing:0,text:c});else{var u=c.split("%rn%");for(let e=0;e<u.length;e++)d.push({textAlign:r,fontSize:s,fontWeight:a,fontFamily:n,fillColor:o,strokeColor:h,strokeWidth:l,lineSpacing:i,text:u[e]})}else for(let e=0;e<c.length;e++){var f=c[e];void 0===f.textAlign&&(f.textAlign=r),void 0===f.fontSize&&(f.fontSize=s),void 0===f.fontWeight&&(f.fontWeight=a),void 0===f.fontFamily&&(f.fontFamily=n),void 0===f.fillColor&&(f.fillColor=o),void 0===f.strokeColor&&(f.strokeColor=h),void 0===f.strokeWidth&&(f.strokeWidth=l),void 0===f.lineSpacing&&(f.lineSpacing=i),d.push(f)}return d}getLocationScale(e,t){var i;return this.H.map.camera.isPerspectiveCamera?(i=new _,e.updateMatrixWorld(),this.H.map.camera.updateMatrixWorld(),i.multiplyMatrices(this.H.map.camera.matrixWorldInverse,e.matrixWorld),e=(new N).applyMatrix4(i),this.getScale(t)*Math.abs(e.z)):this.getScale(t)}getScale(e){let t=0;return t=this.H.map.camera.isPerspectiveCamera?e/(this.H.map.getRenderManager().renderer.domElement.clientHeight/(2*Math.tan(this.H.map.camera.fov*to.DEG2RAD/2))):e*Math.abs(this.H.map.camera.top-this.H.map.camera.bottom)/this.H.map.camera.zoom/this.H.map.getRenderManager().renderer.domElement.clientHeight,t=isNaN(t)?1:t}}let U={BILLBOARD:1,FLAT:2,FIX_FLAT:3,FIX_BILLBOARD:4};class ro extends fengmap.FMTextMarker{constructor(e){void 0===e.anchor&&(e.anchor={baseon:"all",anchor:fengmap.FMMarkerAnchor.CENTER}),void 0!==e.layout&&"image"!==e.layout.style&&"text"!==e.layout.style||(e.anchor.baseon="all"),void 0===e.collision&&(e.collision=!0),void 0===e.render||""+e.render!="flat"&&""+e.render!="rectangle"&&""+e.render!=""+U.FLAT&&""+e.render!=""+U.FIX_FLAT&&""+e.render!=""+U.FIX_BILLBOARD||(e.collision=!1);var t={text:"",x:e.x,y:e.y,height:e.height,collision:!1};""+e.render!="rectangle"&&""+e.render!=""+U.FIX_FLAT&&""+e.render!=""+U.FIX_BILLBOARD||void 0===e.rectangle||(void 0===t.x&&(t.x=e.rectangle.center.x),void 0===t.y&&(t.y=e.rectangle.center.y)),"all"===e.anchor.baseon&&(t.anchor=e.anchor.anchor),super(t),this.myanchor=e.anchor,this.map=null,this.markerOptions=e,void 0===this.markerOptions.zoomRange&&(this.markerOptions.zoomRange=[1,30]),this.tool=new io(this,e),this.mydepth=void 0!==e.depth&&e.depth,this.url=null,this.imagesize=[32,32],this.renderType=e.render,this.myrenderNode=null,void 0===this.renderType?this.renderType="billboard":""+this.renderType==""+U.FLAT?this.renderType="flat":""+this.renderType==""+U.FIX_FLAT?this.renderType="rectangle":""+this.renderType==""+U.BILLBOARD?this.renderType="billboard":""+this.renderType==""+U.FIX_BILLBOARD&&(this.renderType="fix_billboard"),e.image&&(this.url=e.image.url,e.image.size)&&(this.imagesize=e.image.size),e.media&&(this.url=e.media.url,e.media.size)&&(this.imagesize=e.media.size),this.rotateAnimation=null,this.tiltAnimation=null,this.jumpAnimation=null,this.myUpdateSize=this.myUpdateSize.bind(this),this.vodeoAnimate=this.vodeoAnimate.bind(this),this.visibilitychange=this.visibilitychange.bind(this),"billboard"===this.renderType||"fix_billboard"===this.renderType?super.setInitWriteRenderNodeFunction(e=>this.tool.createSprite(e)):"flat"===this.renderType?super.setInitWriteRenderNodeFunction(e=>(this.myrenderNode=this.tool.createFlatMesh(e),this.myrenderNode.visible=this.collisitionVisible,this.myrenderNode)):"rectangle"===this.renderType&&super.setInitWriteRenderNodeFunction(e=>(this.myrenderNode=this.tool.createRectMesh(e),this.myrenderNode.visible=this.collisitionVisible,this.myrenderNode)),this.isDeleted=!1}addTo(e){super.addTo(e),this.map=e.parent.parent,this.zoomRange=this.markerOptions.zoomRange,this.size=this.imagesize[1],"billboard"===this.renderType?this.tool.myUpdateMaterial():this.myInit()}stop(){super.stop(),this.rotateAnimation&&(this.map.removeAnimator(this.rotateAnimation),this.rotateAnimation=null),this.tiltAnimation&&(this.map.removeAnimator(this.tiltAnimation),this.tiltAnimation=null),this.stopJump()}remove(){var e,t;this.stop(),super.remove(),!this.isDeleted&&this.url&&(0<=this.url.indexOf(".mp4")||0<=this.url.indexOf(".webm")||0<=this.url.indexOf(".ogg"))&&(this.removeFrameCallbacks(this.vodeoAnimate),(e=document.getElementById(this.url+"_div"))&&e.parentNode&&(document.removeEventListener("visibilitychange",this.visibilitychange),1===(t=parseInt(e.getAttribute("num")))?e.parentNode.removeChild(e):e.setAttribute("num",""+(t-1)),this.isDeleted=!0),this.url=null,this.tool.Oe=null),"flat"===this.renderType&&(this.map.off("zoom",this.myUpdateSize),this.map.off("resize",this.myUpdateSize),this.map.off("viewChanged",this.myUpdateSize))}setText(e){this.markerOptions.text.content.text=e}getText(){return this.markerOptions.text.content.text}setImage(e,t){this.url=e,void 0!==t&&(this.imagesize=t,this.size=this.imagesize[1])}getImage(){return{url:this.url,size:this.imagesize}}setMedia(e,t){this.setImage(e,t)}getMedia(){return this.getImage()}getBelongedBuildingID(){return super.getBelongedBuildingID()}update(i){var e,t;if(null!==this.tool.Ie&&(this.removeFrameCallbacks(this.vodeoAnimate),(e=this.tool.Ie.parentNode)&&e.parentNode&&(1===(t=parseInt(e.getAttribute("num")))?e.parentNode.removeChild(e):e.setAttribute("num",""+(t-1))),this.tool.Ie=null),"billboard"===this.renderType||"fix_billboard"===this.renderType)this.tool.myUpdateMaterial(!0);else{let t=new zt;this.tool.editFlatMaterial(t,()=>{var e=this.myrenderNode;e.material.map&&e.material.map.dispose(),e.material.dispose(),e.material=t,"flat"===this.renderType&&this.myUpdateSize(),this.map.enableUpdateRender(),i&&i()})}}moveTo(e){super.moveTo(e)}rotateTo(t){if("billboard"!==this.renderType&&"fix_billboard"!==this.renderType){let i=this.map;var r=t.duration||.5,s=this.myrenderNode.userData.heading;let e=t.heading%360*to.DEG2RAD;"flat"===this.renderType&&(e=-e-Math.PI),t.animate?(this.rotateAnimation||(this.rotateAnimation=this.getFMAnimation()),this.rotateAnimation.setSrc([s]),this.rotateAnimation.setDest([e]),this.rotateAnimation.setDuration(r).setUpdate(e=>{var t;this.myrenderNode&&(t=this.myrenderNode.userData.tilt,"flat"===this.renderType?this.tool.updateMeshAngle(this.myrenderNode,t,e.destination[0],-Math.PI):this.tool.updateMeshAngle(this.myrenderNode,t,e.destination[0]),i.enableUpdateRender())}).setCallback(()=>{this.map.removeAnimator(this.rotateAnimation),this.rotateAnimation=null,i.enableUpdateRender(),t.finish&&t.finish()}),this.map.addAnimator(this.rotateAnimation.play())):this.myrenderNode&&(s=this.myrenderNode.userData.tilt,"flat"===this.renderType?this.tool.updateMeshAngle(this.myrenderNode,s,e,-Math.PI):this.tool.updateMeshAngle(this.myrenderNode,s,e),i.enableUpdateRender())}}tiltTo(t){if("billboard"!==this.renderType&&"fix_billboard"!==this.renderType){let i=this.map;var r=t.duration||.5,s=this.myrenderNode.userData.tilt;let e=t.tilt%360*to.DEG2RAD;"rectangle"===this.renderType&&(e=-Math.PI/2+e),t.animate?(this.tiltAnimation||(this.tiltAnimation=this.getFMAnimation()),this.tiltAnimation.setSrc([s]),this.tiltAnimation.setDest([e]),this.tiltAnimation.setDuration(r).setUpdate(e=>{var t;this.myrenderNode&&(t=this.myrenderNode.userData.heading,"flat"===this.renderType?(this.tool.updateMeshAngle(this.myrenderNode,e.destination[0],t,-Math.PI),this.myUpdateSize()):(this.tool.updateMeshAngle(this.myrenderNode,e.destination[0],t),this.myrenderNode.position.y=this.height+this.markerOptions.rectangle.size.y*this.myrenderNode.scale.y*Math.abs(Math.cos(e.destination[0]))/2),i.enableUpdateRender())}).setCallback(()=>{this.map.removeAnimator(this.tiltAnimation),this.tiltAnimation=null,i.enableUpdateRender(),t.finish&&t.finish()}),this.map.addAnimator(this.tiltAnimation.play())):this.myrenderNode&&(s=this.myrenderNode.userData.heading,"flat"===this.renderType?(this.tool.updateMeshAngle(this.myrenderNode,e,s,-Math.PI),this.myUpdateSize()):(this.tool.updateMeshAngle(this.myrenderNode,e,s),this.myrenderNode.position.y=this.height+this.markerOptions.rectangle.size.y*this.myrenderNode.scale.y*Math.abs(Math.cos(e))/2),i.enableUpdateRender())}}jump(e){var t=void 0!==e.duration?e.duration:1;let i=void 0!==e.times?e.times:1/0,r=void 0!==e.delay?e.delay:0,s=(0===i&&(i=1/0),0);var a=this.getRenderNode();a&&(a.userData.oldy=a.position.y),this.jumpAnimation||(this.jumpAnimation=this.getFMAnimation()),this.jumpAnimation.setSrc([a.userData.oldy]),this.jumpAnimation.setDest([a.userData.oldy+e.height]),this.jumpAnimation.setDuration(t).setUpdate(e=>{var t=this.getRenderNode();t&&(t.position.y=e.destination[0]),this.map.enableUpdateRender()}).setCallback(()=>{if((s+=.5)<i){let e=r;s%1==0&&(e=0),this.jumpAnimation.inverse().setDelay(e),this.jumpAnimation.play()}}),this.map.addAnimator(this.jumpAnimation.play())}stopJump(){if(this.jumpAnimation){this.map.removeAnimator(this.jumpAnimation),this.jumpAnimation=null;var t=this.getRenderNode();if(t){let e=t.userData.oldy;void 0===e&&(e=this.height),t.position.y=e,t.userData.oldy=void 0}}}get visible(){return super.visible}set visible(e){super.visible=e}get plateColor(){return this.markerOptions.text.plateColor}set plateColor(e){this.markerOptions.text.plateColor=e}get plateStrokeColor(){return this.markerOptions.text.plateStrokeColor}set plateStrokeColor(e){this.markerOptions.text.plateStrokeColor=e}get plateOpacity(){return this.markerOptions.text.plateOpacity}set plateOpacity(e){this.markerOptions.text.plateOpacity=e}get plateStrokeRadius(){return this.markerOptions.text.plateStrokeRadius}set plateStrokeRadius(e){this.markerOptions.text.plateStrokeRadius=e}set height(e){super.height=e,"flat"===this.renderType?this.myUpdateSize():"rectangle"===this.renderType&&(e=this.myrenderNode.userData.tilt,this.myrenderNode.position.y=this.height+this.markerOptions.rectangle.size.y*this.myrenderNode.scale.y*Math.abs(Math.cos(e))/2),this.map.enableUpdateRender()}get height(){return super.height}get x(){return super.x}get y(){return super.y}get zoomRange(){return super.zoomRange}set zoomRange(e){this.markerOptions.zoomRange=e,super.zoomRange=e}get opacity(){var e=this.markerOptions.opacity;return void 0===e?1:e}set opacity(e){this.markerOptions.opacity=e}get level(){return super.level}get text(){try{return"image"!==this.markerOptions.layout.style?this.getText():" "}catch(e){return" "}}get type(){return super.type}myInit(){this.update(()=>{"flat"===this.renderType&&(this.map.on("zoom",this.myUpdateSize),this.map.on("resize",this.myUpdateSize),this.map.on("viewChanged",this.myUpdateSize),this.map.enableUpdateRender())})}vodeoAnimate(){this.map.enableUpdateRender()}visibilitychange(){this.tool.Ie&&("hidden"==document.visibilityState&&this.tool.Ie.pause(),"visible"==document.visibilityState)&&this.tool.Ie.play()}myUpdateSize(){var t=this.map;if(t){var i=this.myrenderNode.position;let e=!1;!(isNaN(i.x)||isNaN(i.y)||isNaN(i.z))&&"number"==typeof i.x&&"number"==typeof i.y&&"number"==typeof i.z||(e=!0),"flat"!==this.renderType||e||(i=this.tool.getLocationScale(this.myrenderNode,this.size),this.myrenderNode.scale.set(i,i,i),this.myrenderNode.scale.multiplyScalar(this.myrenderNode.material.userData.mspriteScale),this.myrenderNode.scale.setX(this.myrenderNode.scale.x/this.myrenderNode.material.userData.scaleRatio),this.myrenderNode.position.y=this.height+this.myrenderNode.scale.y*Math.abs(Math.sin(this.myrenderNode.userData.tilt))/2,t.enableUpdateRender())}}avoidBefor(){}dispose(){this.remove()}getAnchor(){let e;return e="billboard"===this.renderType?{x:this.getRenderNode().center.x,y:this.getRenderNode().center.y}:{x:.5,y:.5}}getScreenSize(){let e=null;var t,i;return e="billboard"===this.renderType?{width:(t=this.size*this.getRenderNode().material.userData.mspriteScale*1.1)/this.getRenderNode().material.userData.scaleRatio,height:t}:(t=this.markerOptions.layout.style,i=this.myrenderNode.material.map.image,"image"===t?{width:i.width,height:i.height}:{width:i.width/2,height:i.height/2})}}let so={FMWallMarker:lr,FMTubeMarker:ur,FMSphereMarker:Dn,FMLine3dMarker:An,FMCompositeMarker:ro,FMMarkerRenderMode:U},ao=window.fengmap;for(let e in so)ao[e]=so[e];export{ro as FMCompositeMarker,An as FMLine3dMarker,U as FMMarkerRenderMode,Dn as FMSphereMarker,ur as FMTubeMarker,lr as FMWallMarker,ao as default};
